
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3084"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3084"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("boZNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e4b14ad7ed75be8c$export$2e2bcd8739ae039);

var $87GX8 = parcelRequire("87GX8");

var $bXYKW = parcelRequire("bXYKW");

var $1LCJs = parcelRequire("1LCJs");
var $e4b14ad7ed75be8c$export$2e2bcd8739ae039 = {
    name: "App",
    components: {
        Header: $87GX8.default,
        Footer: $bXYKW.default,
        Loading: $1LCJs.default
    },
    data () {
        return {
            show: true
        };
    },
    mounted () {
        window.addEventListener("load", ()=>this.show = !this.show);
    }
};

});
parcelRegister("87GX8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ea04bb99a847ad4$export$2e2bcd8739ae039);
let $5ea04bb99a847ad4$var$script;



let $5ea04bb99a847ad4$var$initialize = ()=>{
    $5ea04bb99a847ad4$var$script = (parcelRequire("hx1ni"));
    if ($5ea04bb99a847ad4$var$script.__esModule) $5ea04bb99a847ad4$var$script = $5ea04bb99a847ad4$var$script.default;
    $5ea04bb99a847ad4$var$script.render = (parcelRequire("8vzlI")).render;
    (parcelRequire("21zwM")).default($5ea04bb99a847ad4$var$script);
    $5ea04bb99a847ad4$var$script.__scopeId = "data-v-6ae1f3";
    $5ea04bb99a847ad4$var$script.__file = "Header.vue";
};
$5ea04bb99a847ad4$var$initialize();
var $5ea04bb99a847ad4$export$2e2bcd8739ae039 = $5ea04bb99a847ad4$var$script;

});
parcelRegister("hx1ni", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cc3695b74b92ab2d$export$2e2bcd8739ae039);

var $3taZC = parcelRequire("3taZC");

var $hEHvj = parcelRequire("hEHvj");
var $cc3695b74b92ab2d$export$2e2bcd8739ae039 = {
    name: "Header",
    data () {
        return {
            overlay: false
        };
    },
    components: {
        HeaderDefault: $3taZC.default,
        HeaderOverlay: $hEHvj.default
    },
    watch: {
        $route (to, from) {
            this.overlay = false;
        }
    }
};

});
parcelRegister("3taZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $286c9b7c7e7d0d30$export$2e2bcd8739ae039);
let $286c9b7c7e7d0d30$var$script;




let $286c9b7c7e7d0d30$var$initialize = ()=>{
    $286c9b7c7e7d0d30$var$script = (parcelRequire("cuENK"));
    if ($286c9b7c7e7d0d30$var$script.__esModule) $286c9b7c7e7d0d30$var$script = $286c9b7c7e7d0d30$var$script.default;
    $286c9b7c7e7d0d30$var$script.render = (parcelRequire("2OxMi")).render;
    $286c9b7c7e7d0d30$var$script.__cssModules = {};
    (parcelRequire("5VMzB")).default($286c9b7c7e7d0d30$var$script);
    $286c9b7c7e7d0d30$var$script.__scopeId = "data-v-879550";
    $286c9b7c7e7d0d30$var$script.__file = "HeaderDefault.vue";
};
$286c9b7c7e7d0d30$var$initialize();
var $286c9b7c7e7d0d30$export$2e2bcd8739ae039 = $286c9b7c7e7d0d30$var$script;

});
parcelRegister("cuENK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9187efacd9cbe8e1$export$2e2bcd8739ae039);

var $iGa2N = parcelRequire("iGa2N");

var $eCPNH = parcelRequire("eCPNH");

var $g2ma9 = parcelRequire("g2ma9");

var $8mD58 = parcelRequire("8mD58");
var $9187efacd9cbe8e1$export$2e2bcd8739ae039 = {
    name: "HeaderDefault",
    props: {
        toggleIcon: {
            default: "charm:menu-hamburger"
        }
    },
    components: {
        Container: $iGa2N.default,
        Navigation: $eCPNH.default,
        Icon: $g2ma9.default
    },
    emits: [
        "toggle"
    ],
    data () {
        return {
            logo: (/*@__PURE__*/$parcel$interopDefault($8mD58))
        };
    }
};

});
parcelRegister("iGa2N", function(module, exports) {

$parcel$export(module.exports, "default", () => $d993f0cc61f8847b$export$2e2bcd8739ae039);
let $d993f0cc61f8847b$var$script;




let $d993f0cc61f8847b$var$initialize = ()=>{
    $d993f0cc61f8847b$var$script = (parcelRequire("gj9yN"));
    if ($d993f0cc61f8847b$var$script.__esModule) $d993f0cc61f8847b$var$script = $d993f0cc61f8847b$var$script.default;
    $d993f0cc61f8847b$var$script.render = (parcelRequire("9GmDR")).render;
    $d993f0cc61f8847b$var$script.__cssModules = {};
    (parcelRequire("hhMUS")).default($d993f0cc61f8847b$var$script);
    $d993f0cc61f8847b$var$script.__scopeId = "data-v-89fb5b";
    $d993f0cc61f8847b$var$script.__file = "Container.vue";
};
$d993f0cc61f8847b$var$initialize();
var $d993f0cc61f8847b$export$2e2bcd8739ae039 = $d993f0cc61f8847b$var$script;

});
parcelRegister("gj9yN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bdf5d6273ec974b9$export$2e2bcd8739ae039);
var $bdf5d6273ec974b9$export$2e2bcd8739ae039 = {
    name: "Container"
};

});

parcelRegister("9GmDR", function(module, exports) {

$parcel$export(module.exports, "render", () => $70c99985db81e72d$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
const $70c99985db81e72d$var$_hoisted_1 = {
    class: "container"
};
function $70c99985db81e72d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("div", $70c99985db81e72d$var$_hoisted_1, [
        (0, $1vQIy.renderSlot)(_ctx.$slots, "default")
    ]);
}

});
parcelRegister("6s3pK", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("1vQIy")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("1vQIy")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("1vQIy")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("1vQIy")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("1vQIy")).createElementVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("1vQIy")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("1vQIy")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("1vQIy")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("1vQIy")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("1vQIy")).getCurrentInstance);
$parcel$export(module.exports, "h", () => (parcelRequire("1vQIy")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("1vQIy")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("1vQIy")).inject);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("1vQIy")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("esA86")).normalizeClass);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("1vQIy")).onActivated);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("1vQIy")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("1vQIy")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("1vQIy")).onUnmounted);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("1vQIy")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("1vQIy")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("1iCGX")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("1iCGX")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("1vQIy")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("1vQIy")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("1vQIy")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("1vQIy")).resolveDynamicComponent);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("1iCGX")).shallowReactive);
$parcel$export(module.exports, "watch", () => (parcelRequire("1vQIy")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("1vQIy")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("1vQIy")).withCtx);
$parcel$export(module.exports, "createApp", () => (parcelRequire("anRt3")).createApp);
$parcel$export(module.exports, "Transition", () => (parcelRequire("anRt3")).Transition);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("anRt3")).withModifiers);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("1iCGX")).shallowRef);
$parcel$export(module.exports, "unref", () => (parcelRequire("1iCGX")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("esA86")).toDisplayString);

var $1vQIy = parcelRequire("1vQIy");parcelRequire("anRt3");parcelRequire("1iCGX");parcelRequire("esA86");
function $4b2801a0d3699aaf$var$initDev() {
    (0, $1vQIy.initCustomFormatter)();
}
const $4b2801a0d3699aaf$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("1vQIy", function(module, exports) {

$parcel$export(module.exports, "warn", () => $11a1944ccdde57bc$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $11a1944ccdde57bc$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $11a1944ccdde57bc$export$bdd553fddd433dcb);
$parcel$export(module.exports, "Fragment", () => $11a1944ccdde57bc$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $11a1944ccdde57bc$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $11a1944ccdde57bc$export$694b237e827a3d23);
$parcel$export(module.exports, "createVNode", () => $11a1944ccdde57bc$export$bf5c4cf060303d58);
$parcel$export(module.exports, "openBlock", () => $11a1944ccdde57bc$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "watchEffect", () => $11a1944ccdde57bc$export$ede35fc0e5500309);
$parcel$export(module.exports, "watchPostEffect", () => $11a1944ccdde57bc$export$b7f27ea67102d543);
$parcel$export(module.exports, "watch", () => $11a1944ccdde57bc$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "useTransitionState", () => $11a1944ccdde57bc$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $11a1944ccdde57bc$export$6d1641039221b5cb);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $11a1944ccdde57bc$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $11a1944ccdde57bc$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $11a1944ccdde57bc$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $11a1944ccdde57bc$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $11a1944ccdde57bc$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $11a1944ccdde57bc$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $11a1944ccdde57bc$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "onUpdated", () => $11a1944ccdde57bc$export$5876c47052fb88b1);
$parcel$export(module.exports, "onActivated", () => $11a1944ccdde57bc$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $11a1944ccdde57bc$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onUnmounted", () => $11a1944ccdde57bc$export$13348a43ccacfe58);
$parcel$export(module.exports, "resolveComponent", () => $11a1944ccdde57bc$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDynamicComponent", () => $11a1944ccdde57bc$export$b44c564a05ca975);
$parcel$export(module.exports, "renderList", () => $11a1944ccdde57bc$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "renderSlot", () => $11a1944ccdde57bc$export$4abee4c34694ada1);
$parcel$export(module.exports, "createBlock", () => $11a1944ccdde57bc$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "computed", () => $11a1944ccdde57bc$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "provide", () => $11a1944ccdde57bc$export$abe1e183e22e10ad);
$parcel$export(module.exports, "inject", () => $11a1944ccdde57bc$export$a976684a0efeb93f);
$parcel$export(module.exports, "createTextVNode", () => $11a1944ccdde57bc$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "createRenderer", () => $11a1944ccdde57bc$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $11a1944ccdde57bc$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $11a1944ccdde57bc$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $11a1944ccdde57bc$export$42098e0eaa15c48e);
$parcel$export(module.exports, "createCommentVNode", () => $11a1944ccdde57bc$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $11a1944ccdde57bc$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $11a1944ccdde57bc$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $11a1944ccdde57bc$export$aed4979be6a60047);
$parcel$export(module.exports, "reactive", () => (parcelRequire("1iCGX")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("1iCGX")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("1iCGX")).shallowReactive);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("1iCGX")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("esA86")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("esA86")).normalizeClass);

var $1iCGX = parcelRequire("1iCGX");

var $esA86 = parcelRequire("esA86");
const $11a1944ccdde57bc$var$stack = [];
function $11a1944ccdde57bc$var$pushWarningContext(vnode) {
    $11a1944ccdde57bc$var$stack.push(vnode);
}
function $11a1944ccdde57bc$var$popWarningContext() {
    $11a1944ccdde57bc$var$stack.pop();
}
function $11a1944ccdde57bc$export$c106dd0671a0fc2d(msg, ...args) {
    var vnode;
    return;
}
function $11a1944ccdde57bc$var$getComponentTrace() {
    let currentVNode = $11a1944ccdde57bc$var$stack[$11a1944ccdde57bc$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $11a1944ccdde57bc$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$11a1944ccdde57bc$var$formatTraceEntry(entry));
    });
    return logs;
}
function $11a1944ccdde57bc$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$11a1944ccdde57bc$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$11a1944ccdde57bc$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $11a1944ccdde57bc$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$11a1944ccdde57bc$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $11a1944ccdde57bc$var$formatProp(key, value1, raw) {
    if ((0, $esA86.isString)(value1)) {
        value1 = JSON.stringify(value1);
        return raw ? value1 : [
            `${key}=${value1}`
        ];
    } else if (typeof value1 === "number" || typeof value1 === "boolean" || value1 == null) return raw ? value1 : [
        `${key}=${value1}`
    ];
    else if ((0, $1iCGX.isRef)(value1)) {
        value1 = $11a1944ccdde57bc$var$formatProp(key, (0, $1iCGX.toRaw)(value1.value), true);
        return raw ? value1 : [
            `${key}=Ref<`,
            value1,
            `>`
        ];
    } else if ((0, $esA86.isFunction)(value1)) return [
        `${key}=fn${value1.name ? `<${value1.name}>` : ``}`
    ];
    else {
        value1 = (0, $1iCGX.toRaw)(value1);
        return raw ? value1 : [
            `${key}=`,
            value1
        ];
    }
}
function $11a1944ccdde57bc$export$dfbcecb440255e4a(val, type) {
    return;
}
const $11a1944ccdde57bc$var$ErrorTypeStrings = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function $11a1944ccdde57bc$export$b22fcaf88446e9bf(fn, instance, type, args) {
    let res;
    try {
        res = args ? fn(...args) : fn();
    } catch (err) {
        $11a1944ccdde57bc$export$d3da1ecaf1206c58(err, instance, type);
    }
    return res;
}
function $11a1944ccdde57bc$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $esA86.isFunction)(fn)) {
        const res = $11a1944ccdde57bc$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $esA86.isPromise)(res)) res.catch((err)=>{
            $11a1944ccdde57bc$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    const values = [];
    for(let i = 0; i < fn.length; i++)values.push($11a1944ccdde57bc$export$dae85862a8d94378(fn[i], instance, type, args));
    return values;
}
function $11a1944ccdde57bc$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = type;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            $11a1944ccdde57bc$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            return;
        }
    }
    $11a1944ccdde57bc$var$logError(err, type, contextVNode, throwInDev);
}
function $11a1944ccdde57bc$var$logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let $11a1944ccdde57bc$var$isFlushing = false;
let $11a1944ccdde57bc$var$isFlushPending = false;
const $11a1944ccdde57bc$var$queue = [];
let $11a1944ccdde57bc$var$flushIndex = 0;
const $11a1944ccdde57bc$var$pendingPostFlushCbs = [];
let $11a1944ccdde57bc$var$activePostFlushCbs = null;
let $11a1944ccdde57bc$var$postFlushIndex = 0;
const $11a1944ccdde57bc$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $11a1944ccdde57bc$var$currentFlushPromise = null;
const $11a1944ccdde57bc$var$RECURSION_LIMIT = 100;
function $11a1944ccdde57bc$export$bdd553fddd433dcb(fn) {
    const p = $11a1944ccdde57bc$var$currentFlushPromise || $11a1944ccdde57bc$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $11a1944ccdde57bc$var$findInsertionIndex(id) {
    let start = $11a1944ccdde57bc$var$flushIndex + 1;
    let end = $11a1944ccdde57bc$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $11a1944ccdde57bc$var$queue[middle];
        const middleJobId = $11a1944ccdde57bc$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.pre) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $11a1944ccdde57bc$var$queueJob(job) {
    if (!$11a1944ccdde57bc$var$queue.length || !$11a1944ccdde57bc$var$queue.includes(job, $11a1944ccdde57bc$var$isFlushing && job.allowRecurse ? $11a1944ccdde57bc$var$flushIndex + 1 : $11a1944ccdde57bc$var$flushIndex)) {
        if (job.id == null) $11a1944ccdde57bc$var$queue.push(job);
        else $11a1944ccdde57bc$var$queue.splice($11a1944ccdde57bc$var$findInsertionIndex(job.id), 0, job);
        $11a1944ccdde57bc$var$queueFlush();
    }
}
function $11a1944ccdde57bc$var$queueFlush() {
    if (!$11a1944ccdde57bc$var$isFlushing && !$11a1944ccdde57bc$var$isFlushPending) {
        $11a1944ccdde57bc$var$isFlushPending = true;
        $11a1944ccdde57bc$var$currentFlushPromise = $11a1944ccdde57bc$var$resolvedPromise.then($11a1944ccdde57bc$var$flushJobs);
    }
}
function $11a1944ccdde57bc$var$invalidateJob(job) {
    const i = $11a1944ccdde57bc$var$queue.indexOf(job);
    if (i > $11a1944ccdde57bc$var$flushIndex) $11a1944ccdde57bc$var$queue.splice(i, 1);
}
function $11a1944ccdde57bc$export$59536a0199721cab(cb) {
    if (!(0, $esA86.isArray)(cb)) {
        if (!$11a1944ccdde57bc$var$activePostFlushCbs || !$11a1944ccdde57bc$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $11a1944ccdde57bc$var$postFlushIndex + 1 : $11a1944ccdde57bc$var$postFlushIndex)) $11a1944ccdde57bc$var$pendingPostFlushCbs.push(cb);
    } else $11a1944ccdde57bc$var$pendingPostFlushCbs.push(...cb);
    $11a1944ccdde57bc$var$queueFlush();
}
function $11a1944ccdde57bc$var$flushPreFlushCbs(seen, i = $11a1944ccdde57bc$var$isFlushing ? $11a1944ccdde57bc$var$flushIndex + 1 : 0) {
    for(; i < $11a1944ccdde57bc$var$queue.length; i++){
        const cb = $11a1944ccdde57bc$var$queue[i];
        if (cb && cb.pre) {
            $11a1944ccdde57bc$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $11a1944ccdde57bc$var$flushPostFlushCbs(seen) {
    if ($11a1944ccdde57bc$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($11a1944ccdde57bc$var$pendingPostFlushCbs)
        ];
        $11a1944ccdde57bc$var$pendingPostFlushCbs.length = 0;
        if ($11a1944ccdde57bc$var$activePostFlushCbs) {
            $11a1944ccdde57bc$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $11a1944ccdde57bc$var$activePostFlushCbs = deduped;
        $11a1944ccdde57bc$var$activePostFlushCbs.sort((a, b)=>$11a1944ccdde57bc$var$getId(a) - $11a1944ccdde57bc$var$getId(b));
        for($11a1944ccdde57bc$var$postFlushIndex = 0; $11a1944ccdde57bc$var$postFlushIndex < $11a1944ccdde57bc$var$activePostFlushCbs.length; $11a1944ccdde57bc$var$postFlushIndex++)$11a1944ccdde57bc$var$activePostFlushCbs[$11a1944ccdde57bc$var$postFlushIndex]();
        $11a1944ccdde57bc$var$activePostFlushCbs = null;
        $11a1944ccdde57bc$var$postFlushIndex = 0;
    }
}
const $11a1944ccdde57bc$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $11a1944ccdde57bc$var$comparator = (a, b)=>{
    const diff = $11a1944ccdde57bc$var$getId(a) - $11a1944ccdde57bc$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $11a1944ccdde57bc$var$flushJobs(seen) {
    $11a1944ccdde57bc$var$isFlushPending = false;
    $11a1944ccdde57bc$var$isFlushing = true;
    $11a1944ccdde57bc$var$queue.sort($11a1944ccdde57bc$var$comparator);
    const check = (0, $esA86.NOOP);
    try {
        for($11a1944ccdde57bc$var$flushIndex = 0; $11a1944ccdde57bc$var$flushIndex < $11a1944ccdde57bc$var$queue.length; $11a1944ccdde57bc$var$flushIndex++){
            const job = $11a1944ccdde57bc$var$queue[$11a1944ccdde57bc$var$flushIndex];
            if (job && job.active !== false) $11a1944ccdde57bc$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $11a1944ccdde57bc$var$flushIndex = 0;
        $11a1944ccdde57bc$var$queue.length = 0;
        $11a1944ccdde57bc$var$flushPostFlushCbs(seen);
        $11a1944ccdde57bc$var$isFlushing = false;
        $11a1944ccdde57bc$var$currentFlushPromise = null;
        if ($11a1944ccdde57bc$var$queue.length || $11a1944ccdde57bc$var$pendingPostFlushCbs.length) $11a1944ccdde57bc$var$flushJobs(seen);
    }
}
function $11a1944ccdde57bc$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $11a1944ccdde57bc$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $11a1944ccdde57bc$var$getComponentName(instance.type);
            $11a1944ccdde57bc$export$c106dd0671a0fc2d(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $11a1944ccdde57bc$var$isHmrUpdating = false;
const $11a1944ccdde57bc$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
const $11a1944ccdde57bc$var$map = /* @__PURE__ */ new Map();
function $11a1944ccdde57bc$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $11a1944ccdde57bc$var$map.get(id);
    if (!record) {
        $11a1944ccdde57bc$var$createRecord(id, instance.type);
        record = $11a1944ccdde57bc$var$map.get(id);
    }
    record.instances.add(instance);
}
function $11a1944ccdde57bc$var$unregisterHMR(instance) {
    $11a1944ccdde57bc$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $11a1944ccdde57bc$var$createRecord(id, initialDef) {
    if ($11a1944ccdde57bc$var$map.has(id)) return false;
    $11a1944ccdde57bc$var$map.set(id, {
        initialDef: $11a1944ccdde57bc$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $11a1944ccdde57bc$var$normalizeClassComponent(component) {
    return $11a1944ccdde57bc$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $11a1944ccdde57bc$var$rerender(id, newRender) {
    const record = $11a1944ccdde57bc$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $11a1944ccdde57bc$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $11a1944ccdde57bc$var$isHmrUpdating = true;
        instance.update();
        $11a1944ccdde57bc$var$isHmrUpdating = false;
    });
}
function $11a1944ccdde57bc$var$reload(id, newComp) {
    const record = $11a1944ccdde57bc$var$map.get(id);
    if (!record) return;
    newComp = $11a1944ccdde57bc$var$normalizeClassComponent(newComp);
    $11a1944ccdde57bc$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $11a1944ccdde57bc$var$normalizeClassComponent(instance.type);
        if (!$11a1944ccdde57bc$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $11a1944ccdde57bc$var$updateComponentDef(oldComp, newComp);
            $11a1944ccdde57bc$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $11a1944ccdde57bc$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $11a1944ccdde57bc$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) $11a1944ccdde57bc$var$queueJob(instance.parent.update);
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $11a1944ccdde57bc$export$59536a0199721cab(()=>{
        for (const instance of instances)$11a1944ccdde57bc$var$hmrDirtyComponents.delete($11a1944ccdde57bc$var$normalizeClassComponent(instance.type));
    });
}
function $11a1944ccdde57bc$var$updateComponentDef(oldComp, newComp) {
    (0, $esA86.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $11a1944ccdde57bc$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $11a1944ccdde57bc$export$6922d3b3a607469e;
let $11a1944ccdde57bc$var$buffer = [];
let $11a1944ccdde57bc$var$devtoolsNotInstalled = false;
function $11a1944ccdde57bc$var$emit$1(event, ...args) {
    if ($11a1944ccdde57bc$export$6922d3b3a607469e) $11a1944ccdde57bc$export$6922d3b3a607469e.emit(event, ...args);
    else if (!$11a1944ccdde57bc$var$devtoolsNotInstalled) $11a1944ccdde57bc$var$buffer.push({
        event: event,
        args: args
    });
}
function $11a1944ccdde57bc$export$b0c258b32c26c785(hook, target) {
    var _a, _b;
    $11a1944ccdde57bc$export$6922d3b3a607469e = hook;
    if ($11a1944ccdde57bc$export$6922d3b3a607469e) {
        $11a1944ccdde57bc$export$6922d3b3a607469e.enabled = true;
        $11a1944ccdde57bc$var$buffer.forEach(({ event: event, args: args })=>$11a1944ccdde57bc$export$6922d3b3a607469e.emit(event, ...args));
        $11a1944ccdde57bc$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $11a1944ccdde57bc$export$b0c258b32c26c785(newHook, target);
        });
        setTimeout(()=>{
            if (!$11a1944ccdde57bc$export$6922d3b3a607469e) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $11a1944ccdde57bc$var$devtoolsNotInstalled = true;
                $11a1944ccdde57bc$var$buffer = [];
            }
        }, 3e3);
    } else {
        $11a1944ccdde57bc$var$devtoolsNotInstalled = true;
        $11a1944ccdde57bc$var$buffer = [];
    }
}
function $11a1944ccdde57bc$var$devtoolsInitApp(app, version) {
    $11a1944ccdde57bc$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $11a1944ccdde57bc$export$ffb0004e005737fa,
        Text: $11a1944ccdde57bc$export$5f1af8db9871e1d6,
        Comment: $11a1944ccdde57bc$export$4d299b491347818a,
        Static: $11a1944ccdde57bc$export$c1b9a1d3af45b7b6
    });
}
function $11a1944ccdde57bc$var$devtoolsUnmountApp(app) {
    $11a1944ccdde57bc$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $11a1944ccdde57bc$var$devtoolsComponentAdded = /* @__PURE__ */ $11a1944ccdde57bc$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $11a1944ccdde57bc$var$devtoolsComponentUpdated = /* @__PURE__ */ $11a1944ccdde57bc$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $11a1944ccdde57bc$var$_devtoolsComponentRemoved = /* @__PURE__ */ $11a1944ccdde57bc$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $11a1944ccdde57bc$var$devtoolsComponentRemoved = (component)=>{
    if ($11a1944ccdde57bc$export$6922d3b3a607469e && typeof $11a1944ccdde57bc$export$6922d3b3a607469e.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$11a1944ccdde57bc$export$6922d3b3a607469e.cleanupBuffer(component)) $11a1944ccdde57bc$var$_devtoolsComponentRemoved(component);
};
function $11a1944ccdde57bc$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $11a1944ccdde57bc$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $11a1944ccdde57bc$var$devtoolsPerfStart = /* @__PURE__ */ $11a1944ccdde57bc$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $11a1944ccdde57bc$var$devtoolsPerfEnd = /* @__PURE__ */ $11a1944ccdde57bc$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $11a1944ccdde57bc$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $11a1944ccdde57bc$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $11a1944ccdde57bc$var$devtoolsComponentEmit(component, event, params) {
    $11a1944ccdde57bc$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $11a1944ccdde57bc$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $esA86.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $esA86.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $esA86.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $esA86.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $11a1944ccdde57bc$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $esA86.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $esA86.toHandlerKey)((0, $esA86.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $esA86.toHandlerKey)((0, $esA86.hyphenate)(event))];
    if (handler) $11a1944ccdde57bc$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $11a1944ccdde57bc$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $11a1944ccdde57bc$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $esA86.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $11a1944ccdde57bc$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $esA86.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $esA86.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $esA86.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $esA86.extend)(normalized, raw);
    if ((0, $esA86.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $11a1944ccdde57bc$var$isEmitListener(options, key) {
    if (!options || !(0, $esA86.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $esA86.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $esA86.hasOwn)(options, (0, $esA86.hyphenate)(key)) || (0, $esA86.hasOwn)(options, key);
}
let $11a1944ccdde57bc$var$currentRenderingInstance = null;
let $11a1944ccdde57bc$var$currentScopeId = null;
function $11a1944ccdde57bc$var$setCurrentRenderingInstance(instance) {
    const prev = $11a1944ccdde57bc$var$currentRenderingInstance;
    $11a1944ccdde57bc$var$currentRenderingInstance = instance;
    $11a1944ccdde57bc$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $11a1944ccdde57bc$export$ac020265ca2cc4cd(id) {
    $11a1944ccdde57bc$var$currentScopeId = id;
}
function $11a1944ccdde57bc$export$f2dc6805dc11834e() {
    $11a1944ccdde57bc$var$currentScopeId = null;
}
const $11a1944ccdde57bc$export$15ba313e13f3dd04 = (_id)=>$11a1944ccdde57bc$export$694b237e827a3d23;
function $11a1944ccdde57bc$export$694b237e827a3d23(fn, ctx = $11a1944ccdde57bc$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $11a1944ccdde57bc$export$c20bee82f26f1e27(-1);
        const prevInstance = $11a1944ccdde57bc$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $11a1944ccdde57bc$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $11a1944ccdde57bc$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $11a1944ccdde57bc$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $11a1944ccdde57bc$var$accessedAttrs = false;
function $11a1944ccdde57bc$var$markAttrsAccessed() {
    $11a1944ccdde57bc$var$accessedAttrs = true;
}
function $11a1944ccdde57bc$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, props: props, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev = $11a1944ccdde57bc$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            result = $11a1944ccdde57bc$var$normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $11a1944ccdde57bc$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $11a1944ccdde57bc$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $11a1944ccdde57bc$var$blockStack.length = 0;
        $11a1944ccdde57bc$export$d3da1ecaf1206c58(err, instance, 1);
        result = $11a1944ccdde57bc$export$bf5c4cf060303d58($11a1944ccdde57bc$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $esA86.isModelListener))) fallthroughAttrs = $11a1944ccdde57bc$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $11a1944ccdde57bc$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    if (vnode.dirs) {
        root = $11a1944ccdde57bc$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $11a1944ccdde57bc$var$setCurrentRenderingInstance(prev);
    return result;
}
const $11a1944ccdde57bc$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $11a1944ccdde57bc$var$filterSingleRoot(rawChildren);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $11a1944ccdde57bc$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $11a1944ccdde57bc$var$filterSingleRoot(children) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($11a1944ccdde57bc$export$3868d13f8734ae81(child)) {
            if (child.type !== $11a1944ccdde57bc$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $11a1944ccdde57bc$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $esA86.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $11a1944ccdde57bc$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $esA86.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $11a1944ccdde57bc$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $11a1944ccdde57bc$export$4d299b491347818a;
};
function $11a1944ccdde57bc$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $11a1944ccdde57bc$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$11a1944ccdde57bc$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $11a1944ccdde57bc$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $11a1944ccdde57bc$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$11a1944ccdde57bc$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $11a1944ccdde57bc$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent && parent.subTree === vnode){
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
    }
}
const $11a1944ccdde57bc$var$isSuspense = (type)=>type.__isSuspense;
const $11a1944ccdde57bc$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $11a1944ccdde57bc$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals);
        else $11a1944ccdde57bc$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, rendererInternals);
    },
    hydrate: $11a1944ccdde57bc$var$hydrateSuspense,
    create: $11a1944ccdde57bc$var$createSuspenseBoundary,
    normalize: $11a1944ccdde57bc$var$normalizeSuspenseChildren
};
const $11a1944ccdde57bc$export$74bf444e3cd11ea5 = $11a1944ccdde57bc$var$SuspenseImpl;
function $11a1944ccdde57bc$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $esA86.isFunction)(eventListener)) eventListener();
}
function $11a1944ccdde57bc$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $11a1944ccdde57bc$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds);
    if (suspense.deps > 0) {
        $11a1944ccdde57bc$var$triggerEvent(vnode, "onPending");
        $11a1944ccdde57bc$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        isSVG, slotScopeIds);
        $11a1944ccdde57bc$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $11a1944ccdde57bc$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($11a1944ccdde57bc$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                isSVG, slotScopeIds, optimized);
                $11a1944ccdde57bc$var$setActiveBranch(suspense, newFallback);
            }
        } else {
            suspense.pendingId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    isSVG, slotScopeIds, optimized);
                    $11a1944ccdde57bc$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $11a1944ccdde57bc$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $11a1944ccdde57bc$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        $11a1944ccdde57bc$var$setActiveBranch(suspense, newBranch);
    } else {
        $11a1944ccdde57bc$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        suspense.pendingId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $11a1944ccdde57bc$var$hasWarned = false;
function $11a1944ccdde57bc$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $11a1944ccdde57bc$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense == null ? void 0 : parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $esA86.toNumber)(vnode.props.timeout) : void 0;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        isSVG: isSVG,
        container: container,
        hiddenContainer: hiddenContainer,
        anchor: anchor,
        deps: 0,
        pendingId: 0,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: true,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor2, 0);
                        $11a1944ccdde57bc$export$59536a0199721cab(effects);
                    }
                };
                let { anchor: anchor2 } = suspense;
                if (activeBranch) {
                    anchor2 = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor2, 0);
            }
            $11a1944ccdde57bc$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $11a1944ccdde57bc$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $11a1944ccdde57bc$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, isSVG: isSVG2 } = suspense;
            $11a1944ccdde57bc$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                isSVG2, slotScopeIds, optimized);
                $11a1944ccdde57bc$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $11a1944ccdde57bc$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $11a1944ccdde57bc$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
                if (placeholder) remove(placeholder);
                $11a1944ccdde57bc$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $11a1944ccdde57bc$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $11a1944ccdde57bc$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement("div"), null, isSVG, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $11a1944ccdde57bc$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $11a1944ccdde57bc$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $11a1944ccdde57bc$var$normalizeSuspenseSlot(children.fallback) : $11a1944ccdde57bc$export$bf5c4cf060303d58($11a1944ccdde57bc$export$4d299b491347818a);
}
function $11a1944ccdde57bc$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $esA86.isFunction)(s)) {
        const trackBlock = $11a1944ccdde57bc$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $11a1944ccdde57bc$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $11a1944ccdde57bc$var$currentBlock;
            $11a1944ccdde57bc$var$closeBlock();
        }
    }
    if ((0, $esA86.isArray)(s)) {
        const singleChild = $11a1944ccdde57bc$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $11a1944ccdde57bc$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $11a1944ccdde57bc$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $esA86.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $11a1944ccdde57bc$export$59536a0199721cab(fn);
}
function $11a1944ccdde57bc$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    const el = vnode.el = branch.el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $11a1944ccdde57bc$var$updateHOCHostEl(parentComponent, el);
    }
}
function $11a1944ccdde57bc$var$isVNodeSuspensible(vnode) {
    var _a;
    return ((_a = vnode.props) == null ? void 0 : _a.suspensible) != null && vnode.props.suspensible !== false;
}
function $11a1944ccdde57bc$export$ede35fc0e5500309(effect, options) {
    return $11a1944ccdde57bc$var$doWatch(effect, null, options);
}
function $11a1944ccdde57bc$export$b7f27ea67102d543(effect, options) {
    return $11a1944ccdde57bc$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $11a1944ccdde57bc$export$2035654f31b0e555(effect, options) {
    return $11a1944ccdde57bc$var$doWatch(effect, null, {
        flush: "sync"
    });
}
const $11a1944ccdde57bc$var$INITIAL_WATCHER_VALUE = {};
function $11a1944ccdde57bc$export$3db5d71bdb2d5499(source, cb, options) {
    return $11a1944ccdde57bc$var$doWatch(source, cb, options);
}
function $11a1944ccdde57bc$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, onTrack: onTrack, onTrigger: onTrigger } = (0, $esA86.EMPTY_OBJ)) {
    var _a;
    const warnInvalidSource = (s)=>{
        $11a1944ccdde57bc$export$c106dd0671a0fc2d(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = (0, $1iCGX.getCurrentScope)() === ((_a = $11a1944ccdde57bc$var$currentInstance) == null ? void 0 : _a.scope) ? $11a1944ccdde57bc$var$currentInstance : null;
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $1iCGX.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $1iCGX.isShallow)(source);
    } else if ((0, $1iCGX.isReactive)(source)) {
        getter = ()=>source;
        deep = true;
    } else if ((0, $esA86.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $1iCGX.isReactive)(s) || (0, $1iCGX.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $1iCGX.isRef)(s)) return s.value;
                else if ((0, $1iCGX.isReactive)(s)) return $11a1944ccdde57bc$var$traverse(s);
                else if ((0, $esA86.isFunction)(s)) return $11a1944ccdde57bc$export$b22fcaf88446e9bf(s, instance, 2);
            });
    } else if ((0, $esA86.isFunction)(source)) {
        if (cb) getter = ()=>$11a1944ccdde57bc$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (instance && instance.isUnmounted) return;
            if (cleanup) cleanup();
            return $11a1944ccdde57bc$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $esA86.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$11a1944ccdde57bc$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $11a1944ccdde57bc$export$b22fcaf88446e9bf(fn, instance, 4);
        };
    };
    let ssrCleanup;
    if ($11a1944ccdde57bc$var$isInSSRComponentSetup) {
        onCleanup = (0, $esA86.NOOP);
        if (!cb) getter();
        else if (immediate) $11a1944ccdde57bc$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $11a1944ccdde57bc$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $esA86.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($11a1944ccdde57bc$var$INITIAL_WATCHER_VALUE) : $11a1944ccdde57bc$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $esA86.hasChanged)(v1, oldValue[i])) : (0, $esA86.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $11a1944ccdde57bc$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $11a1944ccdde57bc$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $11a1944ccdde57bc$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$11a1944ccdde57bc$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$11a1944ccdde57bc$var$queueJob(job);
    }
    const effect = new (0, $1iCGX.ReactiveEffect)(getter, scheduler);
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $11a1944ccdde57bc$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    const unwatch = ()=>{
        effect.stop();
        if (instance && instance.scope) (0, $esA86.remove)(instance.scope.effects, effect);
    };
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $11a1944ccdde57bc$var$instanceWatch(source, value1, options) {
    const publicThis = this.proxy;
    const getter = (0, $esA86.isString)(source) ? source.includes(".") ? $11a1944ccdde57bc$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $esA86.isFunction)(value1)) cb = value1;
    else {
        cb = value1.handler;
        options = value1;
    }
    const cur = $11a1944ccdde57bc$var$currentInstance;
    $11a1944ccdde57bc$var$setCurrentInstance(this);
    const res = $11a1944ccdde57bc$var$doWatch(getter, cb.bind(publicThis), options);
    if (cur) $11a1944ccdde57bc$var$setCurrentInstance(cur);
    else $11a1944ccdde57bc$var$unsetCurrentInstance();
    return res;
}
function $11a1944ccdde57bc$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $11a1944ccdde57bc$var$traverse(value1, seen) {
    if (!(0, $esA86.isObject)(value1) || value1["__v_skip"]) return value1;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value1)) return value1;
    seen.add(value1);
    if ((0, $1iCGX.isRef)(value1)) $11a1944ccdde57bc$var$traverse(value1.value, seen);
    else if ((0, $esA86.isArray)(value1)) for(let i = 0; i < value1.length; i++)$11a1944ccdde57bc$var$traverse(value1[i], seen);
    else if ((0, $esA86.isSet)(value1) || (0, $esA86.isMap)(value1)) value1.forEach((v1)=>{
        $11a1944ccdde57bc$var$traverse(v1, seen);
    });
    else if ((0, $esA86.isPlainObject)(value1)) for(const key in value1)$11a1944ccdde57bc$var$traverse(value1[key], seen);
    return value1;
}
function $11a1944ccdde57bc$var$validateDirectiveName(name) {
    if ((0, $esA86.isBuiltInDirective)(name)) $11a1944ccdde57bc$export$c106dd0671a0fc2d("Do not use built-in directive ids as custom directive id: " + name);
}
function $11a1944ccdde57bc$export$49729353e7c1e6c5(vnode, directives) {
    const internalInstance = $11a1944ccdde57bc$var$currentRenderingInstance;
    if (internalInstance === null) return vnode;
    const instance = $11a1944ccdde57bc$var$getExposeProxy(internalInstance) || internalInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value1, arg, modifiers = (0, $esA86.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $esA86.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $11a1944ccdde57bc$var$traverse(value1);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value1,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $11a1944ccdde57bc$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $1iCGX.pauseTracking)();
            $11a1944ccdde57bc$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $1iCGX.resetTracking)();
        }
    }
}
const $11a1944ccdde57bc$var$leaveCbKey = Symbol("_leaveCb");
const $11a1944ccdde57bc$var$enterCbKey = Symbol("_enterCb");
function $11a1944ccdde57bc$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $11a1944ccdde57bc$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $11a1944ccdde57bc$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $11a1944ccdde57bc$var$TransitionHookValidator = [
    Function,
    Array
];
const $11a1944ccdde57bc$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $11a1944ccdde57bc$var$TransitionHookValidator,
    onEnter: $11a1944ccdde57bc$var$TransitionHookValidator,
    onAfterEnter: $11a1944ccdde57bc$var$TransitionHookValidator,
    onEnterCancelled: $11a1944ccdde57bc$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $11a1944ccdde57bc$var$TransitionHookValidator,
    onLeave: $11a1944ccdde57bc$var$TransitionHookValidator,
    onAfterLeave: $11a1944ccdde57bc$var$TransitionHookValidator,
    onLeaveCancelled: $11a1944ccdde57bc$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $11a1944ccdde57bc$var$TransitionHookValidator,
    onAppear: $11a1944ccdde57bc$var$TransitionHookValidator,
    onAfterAppear: $11a1944ccdde57bc$var$TransitionHookValidator,
    onAppearCancelled: $11a1944ccdde57bc$var$TransitionHookValidator
};
const $11a1944ccdde57bc$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $11a1944ccdde57bc$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $11a1944ccdde57bc$export$f13e630aa3915748();
        const state = $11a1944ccdde57bc$export$d2a0a1bc267c90f6();
        let prevTransitionKey;
        return ()=>{
            const children = slots.default && $11a1944ccdde57bc$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $11a1944ccdde57bc$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, $1iCGX.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $11a1944ccdde57bc$var$emptyPlaceholder(child);
            const innerChild = $11a1944ccdde57bc$var$getKeepAliveChild(child);
            if (!innerChild) return $11a1944ccdde57bc$var$emptyPlaceholder(child);
            const enterHooks = $11a1944ccdde57bc$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $11a1944ccdde57bc$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $11a1944ccdde57bc$var$getKeepAliveChild(oldChild);
            let transitionKeyChanged = false;
            const { getTransitionKey: getTransitionKey } = innerChild.type;
            if (getTransitionKey) {
                const key = getTransitionKey();
                if (prevTransitionKey === void 0) prevTransitionKey = key;
                else if (key !== prevTransitionKey) {
                    prevTransitionKey = key;
                    transitionKeyChanged = true;
                }
            }
            if (oldInnerChild && oldInnerChild.type !== $11a1944ccdde57bc$export$4d299b491347818a && (!$11a1944ccdde57bc$var$isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
                const leavingHooks = $11a1944ccdde57bc$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $11a1944ccdde57bc$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in") {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) instance.update();
                    };
                    return $11a1944ccdde57bc$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $11a1944ccdde57bc$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $11a1944ccdde57bc$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$11a1944ccdde57bc$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$11a1944ccdde57bc$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $11a1944ccdde57bc$export$abd95b5f5e8a8837 = $11a1944ccdde57bc$var$BaseTransitionImpl;
function $11a1944ccdde57bc$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $11a1944ccdde57bc$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $11a1944ccdde57bc$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $11a1944ccdde57bc$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $esA86.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$11a1944ccdde57bc$var$leaveCbKey]) el[$11a1944ccdde57bc$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $11a1944ccdde57bc$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$11a1944ccdde57bc$var$leaveCbKey]) leavingVNode.el[$11a1944ccdde57bc$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$11a1944ccdde57bc$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$11a1944ccdde57bc$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$11a1944ccdde57bc$var$enterCbKey]) el[$11a1944ccdde57bc$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$11a1944ccdde57bc$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$11a1944ccdde57bc$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            return $11a1944ccdde57bc$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $11a1944ccdde57bc$var$emptyPlaceholder(vnode) {
    if ($11a1944ccdde57bc$var$isKeepAlive(vnode)) {
        vnode = $11a1944ccdde57bc$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $11a1944ccdde57bc$var$getKeepAliveChild(vnode) {
    return $11a1944ccdde57bc$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : void 0 : vnode;
}
function $11a1944ccdde57bc$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $11a1944ccdde57bc$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $11a1944ccdde57bc$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $11a1944ccdde57bc$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($11a1944ccdde57bc$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $11a1944ccdde57bc$export$4d299b491347818a) ret.push(key != null ? $11a1944ccdde57bc$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $11a1944ccdde57bc$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $esA86.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $esA86.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $11a1944ccdde57bc$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $11a1944ccdde57bc$export$d75d499b4c16cf21(source) {
    if ((0, $esA86.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $11a1944ccdde57bc$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $11a1944ccdde57bc$var$currentInstance;
            if (resolvedComp) return ()=>$11a1944ccdde57bc$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $11a1944ccdde57bc$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $11a1944ccdde57bc$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$11a1944ccdde57bc$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $11a1944ccdde57bc$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $1iCGX.ref)(false);
            const error = (0, $1iCGX.ref)();
            const delayed = (0, $1iCGX.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $11a1944ccdde57bc$var$isKeepAlive(instance.parent.vnode)) $11a1944ccdde57bc$var$queueJob(instance.parent.update);
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $11a1944ccdde57bc$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $11a1944ccdde57bc$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $11a1944ccdde57bc$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $11a1944ccdde57bc$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $11a1944ccdde57bc$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $11a1944ccdde57bc$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $11a1944ccdde57bc$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $11a1944ccdde57bc$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, isSVG, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, isSVG, vnode.slotScopeIds, optimized);
            $11a1944ccdde57bc$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $esA86.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $11a1944ccdde57bc$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $11a1944ccdde57bc$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $11a1944ccdde57bc$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $esA86.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $11a1944ccdde57bc$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $11a1944ccdde57bc$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $11a1944ccdde57bc$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $11a1944ccdde57bc$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$11a1944ccdde57bc$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $11a1944ccdde57bc$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $11a1944ccdde57bc$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$11a1944ccdde57bc$var$matches(include, name));
            exclude && pruneCache((name)=>!$11a1944ccdde57bc$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $11a1944ccdde57bc$var$getInnerChild(instance.subTree));
        };
        $11a1944ccdde57bc$export$6d1641039221b5cb(cacheSubtree);
        $11a1944ccdde57bc$export$5876c47052fb88b1(cacheSubtree);
        $11a1944ccdde57bc$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $11a1944ccdde57bc$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $11a1944ccdde57bc$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $11a1944ccdde57bc$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$11a1944ccdde57bc$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $11a1944ccdde57bc$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $11a1944ccdde57bc$var$getComponentName($11a1944ccdde57bc$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$11a1944ccdde57bc$var$matches(include, name)) || exclude && name && $11a1944ccdde57bc$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $11a1944ccdde57bc$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $11a1944ccdde57bc$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $11a1944ccdde57bc$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $11a1944ccdde57bc$export$70eb8a58709972df = $11a1944ccdde57bc$var$KeepAliveImpl;
function $11a1944ccdde57bc$var$matches(pattern, name) {
    if ((0, $esA86.isArray)(pattern)) return pattern.some((p)=>$11a1944ccdde57bc$var$matches(p, name));
    else if ((0, $esA86.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $esA86.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $11a1944ccdde57bc$export$ba52d824b95a2154(hook, target) {
    $11a1944ccdde57bc$var$registerKeepAliveHook(hook, "a", target);
}
function $11a1944ccdde57bc$export$bf1440eeaf5fa709(hook, target) {
    $11a1944ccdde57bc$var$registerKeepAliveHook(hook, "da", target);
}
function $11a1944ccdde57bc$var$registerKeepAliveHook(hook, type, target = $11a1944ccdde57bc$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $11a1944ccdde57bc$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($11a1944ccdde57bc$var$isKeepAlive(current.parent.vnode)) $11a1944ccdde57bc$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $11a1944ccdde57bc$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $11a1944ccdde57bc$var$injectHook(type, hook, keepAliveRoot, true);
    $11a1944ccdde57bc$export$13348a43ccacfe58(()=>{
        (0, $esA86.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $11a1944ccdde57bc$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $11a1944ccdde57bc$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $11a1944ccdde57bc$var$injectHook(type, hook, target = $11a1944ccdde57bc$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            (0, $1iCGX.pauseTracking)();
            $11a1944ccdde57bc$var$setCurrentInstance(target);
            const res = $11a1944ccdde57bc$export$dae85862a8d94378(hook, target, type, args);
            $11a1944ccdde57bc$var$unsetCurrentInstance();
            (0, $1iCGX.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $11a1944ccdde57bc$var$createHook = (lifecycle)=>(hook, target = $11a1944ccdde57bc$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$11a1944ccdde57bc$var$isInSSRComponentSetup || lifecycle === "sp") && $11a1944ccdde57bc$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $11a1944ccdde57bc$export$23b7aeb0d671f804 = $11a1944ccdde57bc$var$createHook("bm");
const $11a1944ccdde57bc$export$6d1641039221b5cb = $11a1944ccdde57bc$var$createHook("m");
const $11a1944ccdde57bc$export$ab91988a13872e4c = $11a1944ccdde57bc$var$createHook("bu");
const $11a1944ccdde57bc$export$5876c47052fb88b1 = $11a1944ccdde57bc$var$createHook("u");
const $11a1944ccdde57bc$export$40c420df62d2614 = $11a1944ccdde57bc$var$createHook("bum");
const $11a1944ccdde57bc$export$13348a43ccacfe58 = $11a1944ccdde57bc$var$createHook("um");
const $11a1944ccdde57bc$export$ebf0c601f267bceb = $11a1944ccdde57bc$var$createHook("sp");
const $11a1944ccdde57bc$export$898295a813d662eb = $11a1944ccdde57bc$var$createHook("rtg");
const $11a1944ccdde57bc$export$2b41f4235363e921 = $11a1944ccdde57bc$var$createHook("rtc");
function $11a1944ccdde57bc$export$6a3a15856e50ad19(hook, target = $11a1944ccdde57bc$var$currentInstance) {
    $11a1944ccdde57bc$var$injectHook("ec", hook, target);
}
const $11a1944ccdde57bc$var$COMPONENTS = "components";
const $11a1944ccdde57bc$var$DIRECTIVES = "directives";
function $11a1944ccdde57bc$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $11a1944ccdde57bc$var$resolveAsset($11a1944ccdde57bc$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $11a1944ccdde57bc$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $11a1944ccdde57bc$export$b44c564a05ca975(component) {
    if ((0, $esA86.isString)(component)) return $11a1944ccdde57bc$var$resolveAsset($11a1944ccdde57bc$var$COMPONENTS, component, false) || component;
    else return component || $11a1944ccdde57bc$var$NULL_DYNAMIC_COMPONENT;
}
function $11a1944ccdde57bc$export$a1989e995cd481be(name) {
    return $11a1944ccdde57bc$var$resolveAsset($11a1944ccdde57bc$var$DIRECTIVES, name);
}
function $11a1944ccdde57bc$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $11a1944ccdde57bc$var$currentRenderingInstance || $11a1944ccdde57bc$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $11a1944ccdde57bc$var$COMPONENTS) {
            const selfName = $11a1944ccdde57bc$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $esA86.camelize)(name) || selfName === (0, $esA86.capitalize)((0, $esA86.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $11a1944ccdde57bc$var$resolve(instance[type] || Component[type], name) || // global registration
        $11a1944ccdde57bc$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $11a1944ccdde57bc$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $esA86.camelize)(name)] || registry[(0, $esA86.capitalize)((0, $esA86.camelize)(name))]);
}
function $11a1944ccdde57bc$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $esA86.isArray)(source) || (0, $esA86.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $esA86.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $11a1944ccdde57bc$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $esA86.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $11a1944ccdde57bc$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($11a1944ccdde57bc$var$currentRenderingInstance.isCE || $11a1944ccdde57bc$var$currentRenderingInstance.parent && $11a1944ccdde57bc$var$isAsyncWrapper($11a1944ccdde57bc$var$currentRenderingInstance.parent) && $11a1944ccdde57bc$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $11a1944ccdde57bc$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $11a1944ccdde57bc$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $11a1944ccdde57bc$var$ensureValidVNode(slot(props));
    const rendered = $11a1944ccdde57bc$export$9f2dfe8048dfb22b($11a1944ccdde57bc$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $11a1944ccdde57bc$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$11a1944ccdde57bc$export$3868d13f8734ae81(child)) return true;
        if (child.type === $11a1944ccdde57bc$export$4d299b491347818a) return false;
        if (child.type === $11a1944ccdde57bc$export$ffb0004e005737fa && !$11a1944ccdde57bc$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $11a1944ccdde57bc$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $esA86.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $11a1944ccdde57bc$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($11a1944ccdde57bc$var$isStatefulComponent(i)) return $11a1944ccdde57bc$var$getExposeProxy(i) || i.proxy;
    return $11a1944ccdde57bc$var$getPublicInstance(i.parent);
};
const $11a1944ccdde57bc$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $esA86.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$11a1944ccdde57bc$var$getPublicInstance(i.parent),
    $root: (i)=>$11a1944ccdde57bc$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $11a1944ccdde57bc$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>$11a1944ccdde57bc$var$queueJob(i.update)),
    $nextTick: (i)=>i.n || (i.n = $11a1944ccdde57bc$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $11a1944ccdde57bc$var$instanceWatch.bind(i) : (0, $esA86.NOOP)
});
const $11a1944ccdde57bc$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $11a1944ccdde57bc$var$hasSetupBinding = (state, key)=>state !== (0, $esA86.EMPTY_OBJ) && !state.__isScriptSetup && (0, $esA86.hasOwn)(state, key);
const $11a1944ccdde57bc$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($11a1944ccdde57bc$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $esA86.EMPTY_OBJ) && (0, $esA86.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $esA86.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $esA86.EMPTY_OBJ) && (0, $esA86.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $11a1944ccdde57bc$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $11a1944ccdde57bc$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $1iCGX.track)(instance, "get", key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $esA86.EMPTY_OBJ) && (0, $esA86.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $esA86.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value1) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($11a1944ccdde57bc$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value1;
            return true;
        } else {
            if (data !== (0, $esA86.EMPTY_OBJ) && (0, $esA86.hasOwn)(data, key)) {
                data[key] = value1;
                return true;
            } else if ((0, $esA86.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value1;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $esA86.EMPTY_OBJ) && (0, $esA86.hasOwn)(data, key) || $11a1944ccdde57bc$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $esA86.hasOwn)(normalizedProps, key) || (0, $esA86.hasOwn)(ctx, key) || (0, $esA86.hasOwn)($11a1944ccdde57bc$var$publicPropertiesMap, key) || (0, $esA86.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $esA86.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $11a1944ccdde57bc$var$target;
const $11a1944ccdde57bc$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $esA86.extend)({}, $11a1944ccdde57bc$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $11a1944ccdde57bc$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $esA86.isGloballyAllowed)(key);
        return has;
    }
});
function $11a1944ccdde57bc$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($11a1944ccdde57bc$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$11a1944ccdde57bc$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $esA86.NOOP)
        });
    });
    return target;
}
function $11a1944ccdde57bc$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $esA86.NOOP)
        });
    });
}
function $11a1944ccdde57bc$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $1iCGX.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($11a1944ccdde57bc$var$isReservedPrefix(key[0])) {
                $11a1944ccdde57bc$export$c106dd0671a0fc2d(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $esA86.NOOP)
            });
        }
    });
}
const $11a1944ccdde57bc$var$warnRuntimeUsage = (method)=>$11a1944ccdde57bc$export$c106dd0671a0fc2d(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $11a1944ccdde57bc$export$80b33eababae110e() {
    return null;
}
function $11a1944ccdde57bc$export$51ecece22fc17ddc() {
    return null;
}
function $11a1944ccdde57bc$export$da25b65ca24b518a(exposed) {}
function $11a1944ccdde57bc$export$77e79129327f3d0d(options) {}
function $11a1944ccdde57bc$export$1b3acd4bb805b712() {
    return null;
}
function $11a1944ccdde57bc$export$acd55aa037e791bb() {}
function $11a1944ccdde57bc$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $11a1944ccdde57bc$export$9203a8e84125433c() {
    return $11a1944ccdde57bc$var$getContext().slots;
}
function $11a1944ccdde57bc$export$75e29435042cd2ea() {
    return $11a1944ccdde57bc$var$getContext().attrs;
}
function $11a1944ccdde57bc$export$fb78bd113157f1a1(props, name, options) {
    const i = $11a1944ccdde57bc$export$f13e630aa3915748();
    if (options && options.local) {
        const proxy = (0, $1iCGX.ref)(props[name]);
        $11a1944ccdde57bc$export$3db5d71bdb2d5499(()=>props[name], (v1)=>proxy.value = v1);
        $11a1944ccdde57bc$export$3db5d71bdb2d5499(proxy, (value1)=>{
            if (value1 !== props[name]) i.emit(`update:${name}`, value1);
        });
        return proxy;
    } else return {
        __v_isRef: true,
        get value () {
            return props[name];
        },
        set value (value){
            i.emit(`update:${name}`, value);
        }
    };
}
function $11a1944ccdde57bc$var$getContext() {
    const i = $11a1944ccdde57bc$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $11a1944ccdde57bc$var$createSetupContext(i));
}
function $11a1944ccdde57bc$var$normalizePropsOrEmits(props) {
    return (0, $esA86.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $11a1944ccdde57bc$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $11a1944ccdde57bc$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $esA86.isArray)(opt) || (0, $esA86.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $11a1944ccdde57bc$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $esA86.isArray)(a) && (0, $esA86.isArray)(b)) return a.concat(b);
    return (0, $esA86.extend)({}, $11a1944ccdde57bc$var$normalizePropsOrEmits(a), $11a1944ccdde57bc$var$normalizePropsOrEmits(b));
}
function $11a1944ccdde57bc$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $11a1944ccdde57bc$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $11a1944ccdde57bc$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $11a1944ccdde57bc$var$unsetCurrentInstance();
    if ((0, $esA86.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $11a1944ccdde57bc$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$11a1944ccdde57bc$var$setCurrentInstance(ctx)
    ];
}
function $11a1944ccdde57bc$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $11a1944ccdde57bc$export$c106dd0671a0fc2d(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $11a1944ccdde57bc$var$shouldCacheAccess = true;
function $11a1944ccdde57bc$var$applyOptions(instance) {
    const options = $11a1944ccdde57bc$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $11a1944ccdde57bc$var$shouldCacheAccess = false;
    if (options.beforeCreate) $11a1944ccdde57bc$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $11a1944ccdde57bc$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $esA86.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $esA86.isObject)(data)) ;
        else instance.data = (0, $1iCGX.reactive)(data);
    }
    $11a1944ccdde57bc$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $esA86.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $esA86.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $esA86.NOOP);
        const set = !(0, $esA86.isFunction)(opt) && (0, $esA86.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $esA86.NOOP);
        const c = $11a1944ccdde57bc$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$11a1944ccdde57bc$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $esA86.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $11a1944ccdde57bc$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $11a1944ccdde57bc$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $esA86.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($11a1944ccdde57bc$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($11a1944ccdde57bc$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($11a1944ccdde57bc$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($11a1944ccdde57bc$export$5876c47052fb88b1, updated);
    registerLifecycleHook($11a1944ccdde57bc$export$ba52d824b95a2154, activated);
    registerLifecycleHook($11a1944ccdde57bc$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($11a1944ccdde57bc$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($11a1944ccdde57bc$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($11a1944ccdde57bc$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($11a1944ccdde57bc$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($11a1944ccdde57bc$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($11a1944ccdde57bc$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $esA86.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $esA86.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $11a1944ccdde57bc$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $esA86.NOOP)) {
    if ((0, $esA86.isArray)(injectOptions)) injectOptions = $11a1944ccdde57bc$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $esA86.isObject)(opt)) {
            if ("default" in opt) injected = $11a1944ccdde57bc$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $11a1944ccdde57bc$export$a976684a0efeb93f(opt.from || key);
        } else injected = $11a1944ccdde57bc$export$a976684a0efeb93f(opt);
        if ((0, $1iCGX.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $11a1944ccdde57bc$var$callHook(hook, instance, type) {
    $11a1944ccdde57bc$export$dae85862a8d94378((0, $esA86.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $11a1944ccdde57bc$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $11a1944ccdde57bc$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $esA86.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $esA86.isFunction)(handler)) $11a1944ccdde57bc$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $esA86.isFunction)(raw)) $11a1944ccdde57bc$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $esA86.isObject)(raw)) {
        if ((0, $esA86.isArray)(raw)) raw.forEach((r)=>$11a1944ccdde57bc$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $esA86.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $esA86.isFunction)(handler)) $11a1944ccdde57bc$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $11a1944ccdde57bc$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$11a1944ccdde57bc$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $11a1944ccdde57bc$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $esA86.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $11a1944ccdde57bc$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $11a1944ccdde57bc$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$11a1944ccdde57bc$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $11a1944ccdde57bc$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $11a1944ccdde57bc$var$internalOptionMergeStrats = {
    data: $11a1944ccdde57bc$var$mergeDataFn,
    props: $11a1944ccdde57bc$var$mergeEmitsOrPropsOptions,
    emits: $11a1944ccdde57bc$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $11a1944ccdde57bc$var$mergeObjectOptions,
    computed: $11a1944ccdde57bc$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $11a1944ccdde57bc$var$mergeAsArray,
    created: $11a1944ccdde57bc$var$mergeAsArray,
    beforeMount: $11a1944ccdde57bc$var$mergeAsArray,
    mounted: $11a1944ccdde57bc$var$mergeAsArray,
    beforeUpdate: $11a1944ccdde57bc$var$mergeAsArray,
    updated: $11a1944ccdde57bc$var$mergeAsArray,
    beforeDestroy: $11a1944ccdde57bc$var$mergeAsArray,
    beforeUnmount: $11a1944ccdde57bc$var$mergeAsArray,
    destroyed: $11a1944ccdde57bc$var$mergeAsArray,
    unmounted: $11a1944ccdde57bc$var$mergeAsArray,
    activated: $11a1944ccdde57bc$var$mergeAsArray,
    deactivated: $11a1944ccdde57bc$var$mergeAsArray,
    errorCaptured: $11a1944ccdde57bc$var$mergeAsArray,
    serverPrefetch: $11a1944ccdde57bc$var$mergeAsArray,
    // assets
    components: $11a1944ccdde57bc$var$mergeObjectOptions,
    directives: $11a1944ccdde57bc$var$mergeObjectOptions,
    // watch
    watch: $11a1944ccdde57bc$var$mergeWatchOptions,
    // provide / inject
    provide: $11a1944ccdde57bc$var$mergeDataFn,
    inject: $11a1944ccdde57bc$var$mergeInject
};
function $11a1944ccdde57bc$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $esA86.extend)((0, $esA86.isFunction)(to) ? to.call(this, this) : to, (0, $esA86.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $11a1944ccdde57bc$var$mergeInject(to, from) {
    return $11a1944ccdde57bc$var$mergeObjectOptions($11a1944ccdde57bc$var$normalizeInject(to), $11a1944ccdde57bc$var$normalizeInject(from));
}
function $11a1944ccdde57bc$var$normalizeInject(raw) {
    if ((0, $esA86.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $11a1944ccdde57bc$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $11a1944ccdde57bc$var$mergeObjectOptions(to, from) {
    return to ? (0, $esA86.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $11a1944ccdde57bc$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $esA86.isArray)(to) && (0, $esA86.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $esA86.extend)(/* @__PURE__ */ Object.create(null), $11a1944ccdde57bc$var$normalizePropsOrEmits(to), $11a1944ccdde57bc$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $11a1944ccdde57bc$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $esA86.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $11a1944ccdde57bc$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $11a1944ccdde57bc$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $esA86.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $11a1944ccdde57bc$var$uid$1 = 0;
function $11a1944ccdde57bc$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $esA86.isFunction)(rootComponent)) rootComponent = (0, $esA86.extend)({}, rootComponent);
        if (rootProps != null && !(0, $esA86.isObject)(rootProps)) rootProps = null;
        const context = $11a1944ccdde57bc$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        let isMounted = false;
        const app = context.app = {
            _uid: $11a1944ccdde57bc$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $11a1944ccdde57bc$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $esA86.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $esA86.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, isSVG) {
                if (!isMounted) {
                    const vnode = $11a1944ccdde57bc$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, isSVG);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $11a1944ccdde57bc$var$devtoolsInitApp(app, $11a1944ccdde57bc$export$83d89fbfd8236492);
                    }
                    return $11a1944ccdde57bc$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $11a1944ccdde57bc$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value1) {
                context.provides[key] = value1;
                return app;
            },
            runWithContext (fn) {
                $11a1944ccdde57bc$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $11a1944ccdde57bc$var$currentApp = null;
                }
            }
        };
        return app;
    };
}
let $11a1944ccdde57bc$var$currentApp = null;
function $11a1944ccdde57bc$export$abe1e183e22e10ad(key, value1) {
    if (!$11a1944ccdde57bc$var$currentInstance) ;
    else {
        let provides = $11a1944ccdde57bc$var$currentInstance.provides;
        const parentProvides = $11a1944ccdde57bc$var$currentInstance.parent && $11a1944ccdde57bc$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $11a1944ccdde57bc$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value1;
    }
}
function $11a1944ccdde57bc$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $11a1944ccdde57bc$var$currentInstance || $11a1944ccdde57bc$var$currentRenderingInstance;
    if (instance || $11a1944ccdde57bc$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $11a1944ccdde57bc$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $esA86.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $11a1944ccdde57bc$export$caf6761f24fc571a() {
    return !!($11a1944ccdde57bc$var$currentInstance || $11a1944ccdde57bc$var$currentRenderingInstance || $11a1944ccdde57bc$var$currentApp);
}
function $11a1944ccdde57bc$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = {};
    (0, $esA86.def)(attrs, $11a1944ccdde57bc$var$InternalObjectKey, 1);
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $11a1944ccdde57bc$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $1iCGX.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $11a1944ccdde57bc$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $11a1944ccdde57bc$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $1iCGX.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($11a1944ccdde57bc$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value1 = rawProps[key];
                if (options) {
                    if ((0, $esA86.hasOwn)(attrs, key)) {
                        if (value1 !== attrs[key]) {
                            attrs[key] = value1;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $esA86.camelize)(key);
                        props[camelizedKey] = $11a1944ccdde57bc$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value1, instance, false);
                    }
                } else if (value1 !== attrs[key]) {
                    attrs[key] = value1;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($11a1944ccdde57bc$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $esA86.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $esA86.hyphenate)(key)) === key || !(0, $esA86.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $11a1944ccdde57bc$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $esA86.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $1iCGX.trigger)(instance, "set", "$attrs");
}
function $11a1944ccdde57bc$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $esA86.isReservedProp)(key)) continue;
        const value1 = rawProps[key];
        let camelKey;
        if (options && (0, $esA86.hasOwn)(options, camelKey = (0, $esA86.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value1;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value1;
        } else if (!$11a1944ccdde57bc$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value1 !== attrs[key]) {
                attrs[key] = value1;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $1iCGX.toRaw)(props);
        const castValues = rawCastValues || (0, $esA86.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $11a1944ccdde57bc$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $esA86.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $11a1944ccdde57bc$var$resolvePropValue(options, props, key, value1, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $esA86.hasOwn)(opt, "default");
        if (hasDefault && value1 === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $esA86.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value1 = propsDefaults[key];
                else {
                    $11a1944ccdde57bc$var$setCurrentInstance(instance);
                    value1 = propsDefaults[key] = defaultValue.call(null, props);
                    $11a1944ccdde57bc$var$unsetCurrentInstance();
                }
            } else value1 = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value1 = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value1 === "" || value1 === (0, $esA86.hyphenate)(key))) value1 = true;
        }
    }
    return value1;
}
function $11a1944ccdde57bc$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $esA86.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $11a1944ccdde57bc$var$normalizePropsOptions(raw2, appContext, true);
            (0, $esA86.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $esA86.isObject)(comp)) cache.set(comp, (0, $esA86.EMPTY_ARR));
        return 0, $esA86.EMPTY_ARR;
    }
    if ((0, $esA86.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $esA86.camelize)(raw[i]);
        if ($11a1944ccdde57bc$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $esA86.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $esA86.camelize)(key);
        if ($11a1944ccdde57bc$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $esA86.isArray)(opt) || (0, $esA86.isFunction)(opt) ? {
                type: opt
            } : (0, $esA86.extend)({}, opt);
            if (prop) {
                const booleanIndex = $11a1944ccdde57bc$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $11a1944ccdde57bc$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $esA86.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $esA86.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $11a1944ccdde57bc$var$validatePropName(key) {
    if (key[0] !== "$") return true;
    return false;
}
function $11a1944ccdde57bc$var$getType(ctor) {
    const match = ctor && ctor.toString().match(/^\s*(function|class) (\w+)/);
    return match ? match[2] : ctor === null ? "null" : "";
}
function $11a1944ccdde57bc$var$isSameType(a, b) {
    return $11a1944ccdde57bc$var$getType(a) === $11a1944ccdde57bc$var$getType(b);
}
function $11a1944ccdde57bc$var$getTypeIndex(type, expectedTypes) {
    if ((0, $esA86.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$11a1944ccdde57bc$var$isSameType(t, type));
    else if ((0, $esA86.isFunction)(expectedTypes)) return $11a1944ccdde57bc$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $11a1944ccdde57bc$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $1iCGX.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $11a1944ccdde57bc$var$validateProp(key, resolvedValues[key], opt, !(0, $esA86.hasOwn)(rawProps, key) && !(0, $esA86.hasOwn)(rawProps, (0, $esA86.hyphenate)(key)));
    }
}
function $11a1944ccdde57bc$var$validateProp(name, value1, prop, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $11a1944ccdde57bc$export$c106dd0671a0fc2d('Missing required prop: "' + name + '"');
        return;
    }
    if (value1 == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $esA86.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $11a1944ccdde57bc$var$assertType(value1, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $11a1944ccdde57bc$export$c106dd0671a0fc2d($11a1944ccdde57bc$var$getInvalidTypeMessage(name, value1, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value1)) $11a1944ccdde57bc$export$c106dd0671a0fc2d('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $11a1944ccdde57bc$var$isSimpleType = /* @__PURE__ */ (0, $esA86.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $11a1944ccdde57bc$var$assertType(value1, type) {
    let valid;
    const expectedType = $11a1944ccdde57bc$var$getType(type);
    if ($11a1944ccdde57bc$var$isSimpleType(expectedType)) {
        const t = typeof value1;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value1 instanceof type;
    } else if (expectedType === "Object") valid = (0, $esA86.isObject)(value1);
    else if (expectedType === "Array") valid = (0, $esA86.isArray)(value1);
    else if (expectedType === "null") valid = value1 === null;
    else valid = value1 instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $11a1944ccdde57bc$var$getInvalidTypeMessage(name, value1, expectedTypes) {
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $esA86.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $esA86.toRawType)(value1);
    const expectedValue = $11a1944ccdde57bc$var$styleValue(value1, expectedType);
    const receivedValue = $11a1944ccdde57bc$var$styleValue(value1, receivedType);
    if (expectedTypes.length === 1 && $11a1944ccdde57bc$var$isExplicable(expectedType) && !$11a1944ccdde57bc$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($11a1944ccdde57bc$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $11a1944ccdde57bc$var$styleValue(value1, type) {
    if (type === "String") return `"${value1}"`;
    else if (type === "Number") return `${Number(value1)}`;
    else return `${value1}`;
}
function $11a1944ccdde57bc$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $11a1944ccdde57bc$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $11a1944ccdde57bc$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $11a1944ccdde57bc$var$normalizeSlotValue = (value1)=>(0, $esA86.isArray)(value1) ? value1.map($11a1944ccdde57bc$var$normalizeVNode) : [
        $11a1944ccdde57bc$var$normalizeVNode(value1)
    ];
const $11a1944ccdde57bc$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $11a1944ccdde57bc$export$694b237e827a3d23((...args)=>{
        return $11a1944ccdde57bc$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $11a1944ccdde57bc$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($11a1944ccdde57bc$var$isInternalKey(key)) continue;
        const value1 = rawSlots[key];
        if ((0, $esA86.isFunction)(value1)) slots[key] = $11a1944ccdde57bc$var$normalizeSlot(key, value1, ctx);
        else if (value1 != null) {
            const normalized = $11a1944ccdde57bc$var$normalizeSlotValue(value1);
            slots[key] = ()=>normalized;
        }
    }
};
const $11a1944ccdde57bc$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $11a1944ccdde57bc$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $11a1944ccdde57bc$var$initSlots = (instance, children)=>{
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            instance.slots = (0, $1iCGX.toRaw)(children);
            (0, $esA86.def)(children, "_", type);
        } else $11a1944ccdde57bc$var$normalizeObjectSlots(children, instance.slots = {});
    } else {
        instance.slots = {};
        if (children) $11a1944ccdde57bc$var$normalizeVNodeSlots(instance, children);
    }
    (0, $esA86.def)(instance.slots, $11a1944ccdde57bc$var$InternalObjectKey, 1);
};
const $11a1944ccdde57bc$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $esA86.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $esA86.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $11a1944ccdde57bc$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $11a1944ccdde57bc$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$11a1944ccdde57bc$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
function $11a1944ccdde57bc$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $esA86.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$11a1944ccdde57bc$var$setRef(r, oldRawRef && ((0, $esA86.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($11a1944ccdde57bc$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $11a1944ccdde57bc$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value1 = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $esA86.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $esA86.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $esA86.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $1iCGX.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $esA86.isFunction)(ref)) $11a1944ccdde57bc$export$b22fcaf88446e9bf(ref, owner, 12, [
        value1,
        refs
    ]);
    else {
        const _isString = (0, $esA86.isString)(ref);
        const _isRef = (0, $1iCGX.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $esA86.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $esA86.isArray)(existing) && (0, $esA86.remove)(existing, refValue);
                    else {
                        if (!(0, $esA86.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $esA86.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value1;
                    if ((0, $esA86.hasOwn)(setupState, ref)) setupState[ref] = value1;
                } else if (_isRef) {
                    ref.value = value1;
                    if (rawRef.k) refs[rawRef.k] = value1;
                }
            };
            if (value1) {
                doSet.id = -1;
                $11a1944ccdde57bc$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $11a1944ccdde57bc$var$hasMismatch = false;
const $11a1944ccdde57bc$var$isSVGContainer = (container)=>/svg/.test(container.namespaceURI) && container.tagName !== "foreignObject";
const $11a1944ccdde57bc$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $11a1944ccdde57bc$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            patch(null, vnode, container);
            $11a1944ccdde57bc$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $11a1944ccdde57bc$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $11a1944ccdde57bc$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($11a1944ccdde57bc$var$hasMismatch && true) console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        const isFragmentStart = $11a1944ccdde57bc$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $11a1944ccdde57bc$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $11a1944ccdde57bc$var$hasMismatch = true;
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $11a1944ccdde57bc$export$4d299b491347818a:
                if (domType !== 8 /* COMMENT */  || isFragmentStart) {
                    if (node.tagName.toLowerCase() === "template") {
                        const content = vnode.el.content.firstChild;
                        replaceNode(content, node, parentComponent);
                        vnode.el = node = content;
                        nextNode = nextSibling(node);
                    } else nextNode = onMismatch();
                } else nextNode = nextSibling(node);
                break;
            case $11a1944ccdde57bc$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $11a1944ccdde57bc$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($11a1944ccdde57bc$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $11a1944ccdde57bc$var$isSVGContainer(container), optimized);
                    if ($11a1944ccdde57bc$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $11a1944ccdde57bc$export$bf5c4cf060303d58($11a1944ccdde57bc$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $11a1944ccdde57bc$export$22f9b5ffd89dac9("") : $11a1944ccdde57bc$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $11a1944ccdde57bc$var$isSVGContainer(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
        }
        if (ref != null) $11a1944ccdde57bc$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatchValue = type === "input" && dirs || type === "option";
        if (forcePatchValue || patchFlag !== -1) {
            if (dirs) $11a1944ccdde57bc$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            if (props) {
                if (forcePatchValue || !optimized || patchFlag & 48) {
                    for(const key in props)if (forcePatchValue && key.endsWith("value") || (0, $esA86.isOn)(key) && !(0, $esA86.isReservedProp)(key)) patchProp(el, key, null, props[key], false, void 0, parentComponent);
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, false, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $11a1944ccdde57bc$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $11a1944ccdde57bc$var$needTransition(parentSuspense, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (dirs) $11a1944ccdde57bc$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $11a1944ccdde57bc$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $11a1944ccdde57bc$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $11a1944ccdde57bc$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $11a1944ccdde57bc$var$hasMismatch = true;
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $11a1944ccdde57bc$var$hasMismatch = true;
                    el.textContent = vnode.children;
                }
            }
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $11a1944ccdde57bc$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $11a1944ccdde57bc$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $11a1944ccdde57bc$var$hasMismatch = true;
                patch(null, vnode, container, null, parentComponent, parentSuspense, $11a1944ccdde57bc$var$isSVGContainer(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $11a1944ccdde57bc$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $11a1944ccdde57bc$var$hasMismatch = true;
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $11a1944ccdde57bc$var$hasMismatch = true;
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $11a1944ccdde57bc$var$isSVGContainer(container), slotScopeIds);
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $11a1944ccdde57bc$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) {
                parent.vnode.el = newNode;
                parent.subTree.el = newNode;
            }
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 /* ELEMENT */  && node.tagName.toLowerCase() === "template";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
let $11a1944ccdde57bc$var$supported;
let $11a1944ccdde57bc$var$perf;
function $11a1944ccdde57bc$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $11a1944ccdde57bc$var$isSupported()) $11a1944ccdde57bc$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $11a1944ccdde57bc$var$devtoolsPerfStart(instance, type, $11a1944ccdde57bc$var$isSupported() ? $11a1944ccdde57bc$var$perf.now() : Date.now());
}
function $11a1944ccdde57bc$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $11a1944ccdde57bc$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $11a1944ccdde57bc$var$perf.mark(endTag);
        $11a1944ccdde57bc$var$perf.measure(`<${$11a1944ccdde57bc$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $11a1944ccdde57bc$var$perf.clearMarks(startTag);
        $11a1944ccdde57bc$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $11a1944ccdde57bc$var$devtoolsPerfEnd(instance, type, $11a1944ccdde57bc$var$isSupported() ? $11a1944ccdde57bc$var$perf.now() : Date.now());
}
function $11a1944ccdde57bc$var$isSupported() {
    if ($11a1944ccdde57bc$var$supported !== void 0) return $11a1944ccdde57bc$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $11a1944ccdde57bc$var$supported = true;
        $11a1944ccdde57bc$var$perf = window.performance;
    } else $11a1944ccdde57bc$var$supported = false;
    return $11a1944ccdde57bc$var$supported;
}
function $11a1944ccdde57bc$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $esA86.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $esA86.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
}
const $11a1944ccdde57bc$var$queuePostRenderEffect = $11a1944ccdde57bc$var$queueEffectWithSuspense;
function $11a1944ccdde57bc$export$53ae2f996c64e9a(options) {
    return $11a1944ccdde57bc$var$baseCreateRenderer(options);
}
function $11a1944ccdde57bc$export$200524cf0d997ff0(options) {
    return $11a1944ccdde57bc$var$baseCreateRenderer(options, $11a1944ccdde57bc$var$createHydrationFunctions);
}
function $11a1944ccdde57bc$var$baseCreateRenderer(options, createHydrationFns) {
    $11a1944ccdde57bc$var$initFeatureFlags();
    const target = (0, $esA86.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $11a1944ccdde57bc$export$b0c258b32c26c785(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $esA86.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$11a1944ccdde57bc$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $11a1944ccdde57bc$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $11a1944ccdde57bc$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $11a1944ccdde57bc$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, isSVG);
                break;
            case $11a1944ccdde57bc$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $11a1944ccdde57bc$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, isSVG)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, isSVG)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        isSVG = isSVG || n2.type === "svg";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { type: type, props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
        if (dirs) $11a1944ccdde57bc$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $esA86.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value);
            if (vnodeHook = props.onVnodeBeforeMount) $11a1944ccdde57bc$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $11a1944ccdde57bc$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $11a1944ccdde57bc$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $11a1944ccdde57bc$var$queuePostRenderEffect(()=>{
            vnodeHook && $11a1944ccdde57bc$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $11a1944ccdde57bc$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $11a1944ccdde57bc$var$cloneIfMounted(children[i]) : $11a1944ccdde57bc$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $esA86.EMPTY_OBJ);
        const newProps = n2.props || (0, $esA86.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $11a1944ccdde57bc$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $11a1944ccdde57bc$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $11a1944ccdde57bc$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $11a1944ccdde57bc$var$toggleRecurse(parentComponent, true);
        const areChildrenSVG = isSVG && n2.type !== "foreignObject";
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, isSVG);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $11a1944ccdde57bc$var$queuePostRenderEffect(()=>{
            vnodeHook && $11a1944ccdde57bc$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $11a1944ccdde57bc$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $11a1944ccdde57bc$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$11a1944ccdde57bc$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $esA86.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $esA86.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $esA86.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $11a1944ccdde57bc$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized)=>{
        const instance = initialVNode.component = $11a1944ccdde57bc$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($11a1944ccdde57bc$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $11a1944ccdde57bc$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $11a1944ccdde57bc$export$bf5c4cf060303d58($11a1944ccdde57bc$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
            return;
        }
        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($11a1944ccdde57bc$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $11a1944ccdde57bc$var$invalidateJob(instance.update);
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $11a1944ccdde57bc$var$isAsyncWrapper(initialVNode);
                $11a1944ccdde57bc$var$toggleRecurse(instance, false);
                if (bm) (0, $esA86.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $11a1944ccdde57bc$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $11a1944ccdde57bc$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $11a1944ccdde57bc$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $11a1944ccdde57bc$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
                    initialVNode.el = subTree.el;
                }
                if (m) $11a1944ccdde57bc$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $11a1944ccdde57bc$var$queuePostRenderEffect(()=>$11a1944ccdde57bc$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $11a1944ccdde57bc$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $11a1944ccdde57bc$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $11a1944ccdde57bc$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                let originNext = next;
                let vnodeHook;
                $11a1944ccdde57bc$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $esA86.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $11a1944ccdde57bc$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $11a1944ccdde57bc$var$toggleRecurse(instance, true);
                const nextTree = $11a1944ccdde57bc$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
                next.el = nextTree.el;
                if (originNext === null) $11a1944ccdde57bc$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $11a1944ccdde57bc$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $11a1944ccdde57bc$var$queuePostRenderEffect(()=>$11a1944ccdde57bc$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $11a1944ccdde57bc$var$devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, $1iCGX.ReactiveEffect)(componentUpdateFn, ()=>$11a1944ccdde57bc$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>effect.run();
        update.id = instance.uid;
        $11a1944ccdde57bc$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $11a1944ccdde57bc$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $11a1944ccdde57bc$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $1iCGX.pauseTracking)();
        $11a1944ccdde57bc$var$flushPreFlushCbs();
        (0, $1iCGX.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $esA86.EMPTY_ARR);
        c2 = c2 || (0, $esA86.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $11a1944ccdde57bc$var$cloneIfMounted(c2[i]) : $11a1944ccdde57bc$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $11a1944ccdde57bc$var$cloneIfMounted(c2[i]) : $11a1944ccdde57bc$var$normalizeVNode(c2[i]);
            if ($11a1944ccdde57bc$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $11a1944ccdde57bc$var$cloneIfMounted(c2[e2]) : $11a1944ccdde57bc$var$normalizeVNode(c2[e2]);
            if ($11a1944ccdde57bc$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $11a1944ccdde57bc$var$cloneIfMounted(c2[i]) : $11a1944ccdde57bc$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $11a1944ccdde57bc$var$cloneIfMounted(c2[i]) : $11a1944ccdde57bc$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $11a1944ccdde57bc$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $11a1944ccdde57bc$var$getSequence(newIndexToOldIndexMap) : (0, $esA86.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $11a1944ccdde57bc$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $11a1944ccdde57bc$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $11a1944ccdde57bc$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (ref != null) $11a1944ccdde57bc$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$11a1944ccdde57bc$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $11a1944ccdde57bc$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $11a1944ccdde57bc$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $11a1944ccdde57bc$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $11a1944ccdde57bc$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $11a1944ccdde57bc$var$queuePostRenderEffect(()=>{
            vnodeHook && $11a1944ccdde57bc$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $11a1944ccdde57bc$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $11a1944ccdde57bc$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $11a1944ccdde57bc$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        if (bum) (0, $esA86.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $11a1944ccdde57bc$var$queuePostRenderEffect(um, parentSuspense);
        $11a1944ccdde57bc$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $11a1944ccdde57bc$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    const render = (vnode, container, isSVG)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, isSVG);
        $11a1944ccdde57bc$var$flushPreFlushCbs();
        $11a1944ccdde57bc$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $11a1944ccdde57bc$var$createAppAPI(render, hydrate)
    };
}
function $11a1944ccdde57bc$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $11a1944ccdde57bc$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $11a1944ccdde57bc$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $esA86.isArray)(ch1) && (0, $esA86.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $11a1944ccdde57bc$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $11a1944ccdde57bc$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $11a1944ccdde57bc$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $11a1944ccdde57bc$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
const $11a1944ccdde57bc$var$isTeleport = (type)=>type.__isTeleport;
const $11a1944ccdde57bc$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $11a1944ccdde57bc$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $11a1944ccdde57bc$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $esA86.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $11a1944ccdde57bc$var$TeleportImpl = {
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $11a1944ccdde57bc$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $11a1944ccdde57bc$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                isSVG = isSVG || $11a1944ccdde57bc$var$isTargetSVG(target);
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $11a1944ccdde57bc$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            isSVG = isSVG || $11a1944ccdde57bc$var$isTargetSVG(target);
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
                $11a1944ccdde57bc$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $11a1944ccdde57bc$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $11a1944ccdde57bc$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $11a1944ccdde57bc$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $11a1944ccdde57bc$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $11a1944ccdde57bc$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$11a1944ccdde57bc$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $11a1944ccdde57bc$var$moveTeleport,
    hydrate: $11a1944ccdde57bc$var$hydrateTeleport
};
function $11a1944ccdde57bc$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $11a1944ccdde57bc$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $11a1944ccdde57bc$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $11a1944ccdde57bc$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($11a1944ccdde57bc$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $11a1944ccdde57bc$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $11a1944ccdde57bc$export$76d55a0304a371f4 = $11a1944ccdde57bc$var$TeleportImpl;
function $11a1944ccdde57bc$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node && node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $11a1944ccdde57bc$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $11a1944ccdde57bc$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $11a1944ccdde57bc$export$4d299b491347818a = Symbol.for("v-cmt");
const $11a1944ccdde57bc$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $11a1944ccdde57bc$var$blockStack = [];
let $11a1944ccdde57bc$var$currentBlock = null;
function $11a1944ccdde57bc$export$e7eaa45e502fe5cc(disableTracking = false) {
    $11a1944ccdde57bc$var$blockStack.push($11a1944ccdde57bc$var$currentBlock = disableTracking ? null : []);
}
function $11a1944ccdde57bc$var$closeBlock() {
    $11a1944ccdde57bc$var$blockStack.pop();
    $11a1944ccdde57bc$var$currentBlock = $11a1944ccdde57bc$var$blockStack[$11a1944ccdde57bc$var$blockStack.length - 1] || null;
}
let $11a1944ccdde57bc$var$isBlockTreeEnabled = 1;
function $11a1944ccdde57bc$export$c20bee82f26f1e27(value1) {
    $11a1944ccdde57bc$var$isBlockTreeEnabled += value1;
}
function $11a1944ccdde57bc$var$setupBlock(vnode) {
    vnode.dynamicChildren = $11a1944ccdde57bc$var$isBlockTreeEnabled > 0 ? $11a1944ccdde57bc$var$currentBlock || (0, $esA86.EMPTY_ARR) : null;
    $11a1944ccdde57bc$var$closeBlock();
    if ($11a1944ccdde57bc$var$isBlockTreeEnabled > 0 && $11a1944ccdde57bc$var$currentBlock) $11a1944ccdde57bc$var$currentBlock.push(vnode);
    return vnode;
}
function $11a1944ccdde57bc$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $11a1944ccdde57bc$var$setupBlock($11a1944ccdde57bc$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $11a1944ccdde57bc$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $11a1944ccdde57bc$var$setupBlock($11a1944ccdde57bc$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $11a1944ccdde57bc$export$3868d13f8734ae81(value1) {
    return value1 ? value1.__v_isVNode === true : false;
}
function $11a1944ccdde57bc$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $11a1944ccdde57bc$var$vnodeArgsTransformer;
function $11a1944ccdde57bc$export$83beccd3afeeb809(transformer) {
    $11a1944ccdde57bc$var$vnodeArgsTransformer = transformer;
}
const $11a1944ccdde57bc$var$createVNodeWithArgsTransform = (...args)=>{
    return $11a1944ccdde57bc$var$_createVNode(...$11a1944ccdde57bc$var$vnodeArgsTransformer ? $11a1944ccdde57bc$var$vnodeArgsTransformer(args, $11a1944ccdde57bc$var$currentRenderingInstance) : args);
};
const $11a1944ccdde57bc$var$InternalObjectKey = `__vInternal`;
const $11a1944ccdde57bc$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $11a1944ccdde57bc$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $esA86.isString)(ref) || (0, $1iCGX.isRef)(ref) || (0, $esA86.isFunction)(ref) ? {
        i: $11a1944ccdde57bc$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $11a1944ccdde57bc$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $11a1944ccdde57bc$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $11a1944ccdde57bc$var$normalizeKey(props),
        ref: props && $11a1944ccdde57bc$var$normalizeRef(props),
        scopeId: $11a1944ccdde57bc$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $11a1944ccdde57bc$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $11a1944ccdde57bc$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $esA86.isString)(children) ? 8 : 16;
    if ($11a1944ccdde57bc$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $11a1944ccdde57bc$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $11a1944ccdde57bc$var$currentBlock.push(vnode);
    return vnode;
}
const $11a1944ccdde57bc$export$bf5c4cf060303d58 = $11a1944ccdde57bc$var$_createVNode;
function $11a1944ccdde57bc$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $11a1944ccdde57bc$var$NULL_DYNAMIC_COMPONENT) type = $11a1944ccdde57bc$export$4d299b491347818a;
    if ($11a1944ccdde57bc$export$3868d13f8734ae81(type)) {
        const cloned = $11a1944ccdde57bc$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $11a1944ccdde57bc$var$normalizeChildren(cloned, children);
        if ($11a1944ccdde57bc$var$isBlockTreeEnabled > 0 && !isBlockNode && $11a1944ccdde57bc$var$currentBlock) {
            if (cloned.shapeFlag & 6) $11a1944ccdde57bc$var$currentBlock[$11a1944ccdde57bc$var$currentBlock.indexOf(type)] = cloned;
            else $11a1944ccdde57bc$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($11a1944ccdde57bc$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $11a1944ccdde57bc$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $esA86.isString)(klass)) props.class = (0, $esA86.normalizeClass)(klass);
        if ((0, $esA86.isObject)(style)) {
            if ((0, $1iCGX.isProxy)(style) && !(0, $esA86.isArray)(style)) style = (0, $esA86.extend)({}, style);
            props.style = (0, $esA86.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $esA86.isString)(type) ? 1 : $11a1944ccdde57bc$var$isSuspense(type) ? 128 : $11a1944ccdde57bc$var$isTeleport(type) ? 64 : (0, $esA86.isObject)(type) ? 4 : (0, $esA86.isFunction)(type) ? 2 : 0;
    return $11a1944ccdde57bc$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $11a1944ccdde57bc$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $1iCGX.isProxy)(props) || $11a1944ccdde57bc$var$InternalObjectKey in props ? (0, $esA86.extend)({}, props) : props;
}
function $11a1944ccdde57bc$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children } = vnode;
    const mergedProps = extraProps ? $11a1944ccdde57bc$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $11a1944ccdde57bc$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $esA86.isArray)(ref) ? ref.concat($11a1944ccdde57bc$var$normalizeRef(extraProps)) : [
            ref,
            $11a1944ccdde57bc$var$normalizeRef(extraProps)
        ] : $11a1944ccdde57bc$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $11a1944ccdde57bc$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $11a1944ccdde57bc$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $11a1944ccdde57bc$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    return cloned;
}
function $11a1944ccdde57bc$var$deepCloneVNode(vnode) {
    const cloned = $11a1944ccdde57bc$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $esA86.isArray)(vnode.children)) cloned.children = vnode.children.map($11a1944ccdde57bc$var$deepCloneVNode);
    return cloned;
}
function $11a1944ccdde57bc$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $11a1944ccdde57bc$export$bf5c4cf060303d58($11a1944ccdde57bc$export$5f1af8db9871e1d6, null, text, flag);
}
function $11a1944ccdde57bc$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $11a1944ccdde57bc$export$bf5c4cf060303d58($11a1944ccdde57bc$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $11a1944ccdde57bc$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($11a1944ccdde57bc$export$e7eaa45e502fe5cc(), $11a1944ccdde57bc$export$9f2dfe8048dfb22b($11a1944ccdde57bc$export$4d299b491347818a, null, text)) : $11a1944ccdde57bc$export$bf5c4cf060303d58($11a1944ccdde57bc$export$4d299b491347818a, null, text);
}
function $11a1944ccdde57bc$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $11a1944ccdde57bc$export$bf5c4cf060303d58($11a1944ccdde57bc$export$4d299b491347818a);
    else if ((0, $esA86.isArray)(child)) return $11a1944ccdde57bc$export$bf5c4cf060303d58($11a1944ccdde57bc$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $11a1944ccdde57bc$var$cloneIfMounted(child);
    else return $11a1944ccdde57bc$export$bf5c4cf060303d58($11a1944ccdde57bc$export$5f1af8db9871e1d6, null, String(child));
}
function $11a1944ccdde57bc$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $11a1944ccdde57bc$export$ee4f9e12c0a92a1a(child);
}
function $11a1944ccdde57bc$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $esA86.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $11a1944ccdde57bc$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !($11a1944ccdde57bc$var$InternalObjectKey in children)) children._ctx = $11a1944ccdde57bc$var$currentRenderingInstance;
            else if (slotFlag === 3 && $11a1944ccdde57bc$var$currentRenderingInstance) {
                if ($11a1944ccdde57bc$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $esA86.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $11a1944ccdde57bc$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $11a1944ccdde57bc$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $11a1944ccdde57bc$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $esA86.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $esA86.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $esA86.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $esA86.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $11a1944ccdde57bc$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $11a1944ccdde57bc$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $11a1944ccdde57bc$var$emptyAppContext = $11a1944ccdde57bc$var$createAppContext();
let $11a1944ccdde57bc$var$uid = 0;
function $11a1944ccdde57bc$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $11a1944ccdde57bc$var$emptyAppContext;
    const instance = {
        uid: $11a1944ccdde57bc$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $1iCGX.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $11a1944ccdde57bc$var$normalizePropsOptions(type, appContext),
        emitsOptions: $11a1944ccdde57bc$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $esA86.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $esA86.EMPTY_OBJ),
        data: (0, $esA86.EMPTY_OBJ),
        props: (0, $esA86.EMPTY_OBJ),
        attrs: (0, $esA86.EMPTY_OBJ),
        slots: (0, $esA86.EMPTY_OBJ),
        refs: (0, $esA86.EMPTY_OBJ),
        setupState: (0, $esA86.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $11a1944ccdde57bc$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $11a1944ccdde57bc$var$currentInstance = null;
const $11a1944ccdde57bc$export$f13e630aa3915748 = ()=>$11a1944ccdde57bc$var$currentInstance || $11a1944ccdde57bc$var$currentRenderingInstance;
let $11a1944ccdde57bc$var$internalSetCurrentInstance;
let $11a1944ccdde57bc$var$globalCurrentInstanceSetters;
let $11a1944ccdde57bc$var$settersKey = "__VUE_INSTANCE_SETTERS__";
if (!($11a1944ccdde57bc$var$globalCurrentInstanceSetters = (0, $esA86.getGlobalThis)()[$11a1944ccdde57bc$var$settersKey])) $11a1944ccdde57bc$var$globalCurrentInstanceSetters = (0, $esA86.getGlobalThis)()[$11a1944ccdde57bc$var$settersKey] = [];
$11a1944ccdde57bc$var$globalCurrentInstanceSetters.push((i)=>$11a1944ccdde57bc$var$currentInstance = i);
$11a1944ccdde57bc$var$internalSetCurrentInstance = (instance)=>{
    if ($11a1944ccdde57bc$var$globalCurrentInstanceSetters.length > 1) $11a1944ccdde57bc$var$globalCurrentInstanceSetters.forEach((s)=>s(instance));
    else $11a1944ccdde57bc$var$globalCurrentInstanceSetters[0](instance);
};
const $11a1944ccdde57bc$var$setCurrentInstance = (instance)=>{
    $11a1944ccdde57bc$var$internalSetCurrentInstance(instance);
    instance.scope.on();
};
const $11a1944ccdde57bc$var$unsetCurrentInstance = ()=>{
    $11a1944ccdde57bc$var$currentInstance && $11a1944ccdde57bc$var$currentInstance.scope.off();
    $11a1944ccdde57bc$var$internalSetCurrentInstance(null);
};
const $11a1944ccdde57bc$var$isBuiltInTag = /* @__PURE__ */ (0, $esA86.makeMap)("slot,component");
function $11a1944ccdde57bc$var$validateComponentName(name, config) {
    const appIsNativeTag = config.isNativeTag || (0, $esA86.NO);
    if ($11a1944ccdde57bc$var$isBuiltInTag(name) || appIsNativeTag(name)) $11a1944ccdde57bc$export$c106dd0671a0fc2d("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $11a1944ccdde57bc$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $11a1944ccdde57bc$var$isInSSRComponentSetup = false;
function $11a1944ccdde57bc$var$setupComponent(instance, isSSR = false) {
    $11a1944ccdde57bc$var$isInSSRComponentSetup = isSSR;
    const { props: props, children: children } = instance.vnode;
    const isStateful = $11a1944ccdde57bc$var$isStatefulComponent(instance);
    $11a1944ccdde57bc$var$initProps(instance, props, isStateful, isSSR);
    $11a1944ccdde57bc$var$initSlots(instance, children);
    const setupResult = isStateful ? $11a1944ccdde57bc$var$setupStatefulComponent(instance, isSSR) : void 0;
    $11a1944ccdde57bc$var$isInSSRComponentSetup = false;
    return setupResult;
}
function $11a1944ccdde57bc$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = (0, $1iCGX.markRaw)(new Proxy(instance.ctx, $11a1944ccdde57bc$var$PublicInstanceProxyHandlers));
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $11a1944ccdde57bc$var$createSetupContext(instance) : null;
        $11a1944ccdde57bc$var$setCurrentInstance(instance);
        (0, $1iCGX.pauseTracking)();
        const setupResult = $11a1944ccdde57bc$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $1iCGX.resetTracking)();
        $11a1944ccdde57bc$var$unsetCurrentInstance();
        if ((0, $esA86.isPromise)(setupResult)) {
            setupResult.then($11a1944ccdde57bc$var$unsetCurrentInstance, $11a1944ccdde57bc$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $11a1944ccdde57bc$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $11a1944ccdde57bc$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $11a1944ccdde57bc$var$handleSetupResult(instance, setupResult, isSSR);
    } else $11a1944ccdde57bc$var$finishComponentSetup(instance, isSSR);
}
function $11a1944ccdde57bc$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $esA86.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $esA86.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $1iCGX.proxyRefs)(setupResult);
    }
    $11a1944ccdde57bc$var$finishComponentSetup(instance, isSSR);
}
let $11a1944ccdde57bc$var$compile;
let $11a1944ccdde57bc$var$installWithProxy;
function $11a1944ccdde57bc$export$667bb5a67822b941(_compile) {
    $11a1944ccdde57bc$var$compile = _compile;
    $11a1944ccdde57bc$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $11a1944ccdde57bc$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $11a1944ccdde57bc$export$c93a9c496c5211fa = ()=>!$11a1944ccdde57bc$var$compile;
function $11a1944ccdde57bc$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $11a1944ccdde57bc$var$compile && !Component.render) {
            const template = Component.template || $11a1944ccdde57bc$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $esA86.extend)((0, $esA86.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $11a1944ccdde57bc$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $esA86.NOOP);
        if ($11a1944ccdde57bc$var$installWithProxy) $11a1944ccdde57bc$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        $11a1944ccdde57bc$var$setCurrentInstance(instance);
        (0, $1iCGX.pauseTracking)();
        try {
            $11a1944ccdde57bc$var$applyOptions(instance);
        } finally{
            (0, $1iCGX.resetTracking)();
            $11a1944ccdde57bc$var$unsetCurrentInstance();
        }
    }
}
function $11a1944ccdde57bc$var$getAttrsProxy(instance) {
    return instance.attrsProxy || (instance.attrsProxy = new Proxy(instance.attrs, {
        get (target, key) {
            (0, $1iCGX.track)(instance, "get", "$attrs");
            return target[key];
        }
    }));
}
function $11a1944ccdde57bc$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $1iCGX.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $11a1944ccdde57bc$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        get attrs () {
            return $11a1944ccdde57bc$var$getAttrsProxy(instance);
        },
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $11a1944ccdde57bc$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $1iCGX.proxyRefs)((0, $1iCGX.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $11a1944ccdde57bc$var$publicPropertiesMap) return $11a1944ccdde57bc$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $11a1944ccdde57bc$var$publicPropertiesMap;
        }
    }));
}
const $11a1944ccdde57bc$var$classifyRE = /(?:^|[-_])(\w)/g;
const $11a1944ccdde57bc$var$classify = (str)=>str.replace($11a1944ccdde57bc$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $11a1944ccdde57bc$var$getComponentName(Component, includeInferred = true) {
    return (0, $esA86.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $11a1944ccdde57bc$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $11a1944ccdde57bc$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $11a1944ccdde57bc$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $11a1944ccdde57bc$var$isClassComponent(value1) {
    return (0, $esA86.isFunction)(value1) && "__vccOpts" in value1;
}
const $11a1944ccdde57bc$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    return (0, $1iCGX.computed)(getterOrOptions, debugOptions, $11a1944ccdde57bc$var$isInSSRComponentSetup);
};
function $11a1944ccdde57bc$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $esA86.isObject)(propsOrChildren) && !(0, $esA86.isArray)(propsOrChildren)) {
            if ($11a1944ccdde57bc$export$3868d13f8734ae81(propsOrChildren)) return $11a1944ccdde57bc$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $11a1944ccdde57bc$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $11a1944ccdde57bc$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $11a1944ccdde57bc$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $11a1944ccdde57bc$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
const $11a1944ccdde57bc$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $11a1944ccdde57bc$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $11a1944ccdde57bc$export$a976684a0efeb93f($11a1944ccdde57bc$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $11a1944ccdde57bc$var$isShallow(value1) {
    return !!(value1 && value1["__v_isShallow"]);
}
function $11a1944ccdde57bc$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $1iCGX.toRaw)(instance.props)));
        if (instance.setupState !== (0, $esA86.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $esA86.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $1iCGX.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $esA86.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $esA86.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $1iCGX.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $esA86.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $esA86.isArray)(opts) && opts.includes(key) || (0, $esA86.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ($11a1944ccdde57bc$var$isShallow(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $11a1944ccdde57bc$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $11a1944ccdde57bc$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $11a1944ccdde57bc$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $esA86.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($11a1944ccdde57bc$var$isBlockTreeEnabled > 0 && $11a1944ccdde57bc$var$currentBlock) $11a1944ccdde57bc$var$currentBlock.push(cached);
    return true;
}
const $11a1944ccdde57bc$export$83d89fbfd8236492 = "3.3.7";
const $11a1944ccdde57bc$var$_ssrUtils = {
    createComponentInstance: $11a1944ccdde57bc$var$createComponentInstance,
    setupComponent: $11a1944ccdde57bc$var$setupComponent,
    renderComponentRoot: $11a1944ccdde57bc$var$renderComponentRoot,
    setCurrentRenderingInstance: $11a1944ccdde57bc$var$setCurrentRenderingInstance,
    isVNode: $11a1944ccdde57bc$export$3868d13f8734ae81,
    normalizeVNode: $11a1944ccdde57bc$var$normalizeVNode
};
const $11a1944ccdde57bc$export$a9679033567b336d = $11a1944ccdde57bc$var$_ssrUtils;
const $11a1944ccdde57bc$export$83cf26e06ea620e1 = null;
const $11a1944ccdde57bc$export$dc678eddf276286e = null;

});
parcelRegister("1iCGX", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $0f257c4d62805d2e$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "getCurrentScope", () => $0f257c4d62805d2e$export$c7be4b0125a10cba);
$parcel$export(module.exports, "ReactiveEffect", () => $0f257c4d62805d2e$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $0f257c4d62805d2e$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $0f257c4d62805d2e$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $0f257c4d62805d2e$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $0f257c4d62805d2e$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $0f257c4d62805d2e$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isRef", () => $0f257c4d62805d2e$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $0f257c4d62805d2e$export$90a44edba14e47be);
$parcel$export(module.exports, "isShallow", () => $0f257c4d62805d2e$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "shallowReactive", () => $0f257c4d62805d2e$export$8d81cefd22d22260);
$parcel$export(module.exports, "isReactive", () => $0f257c4d62805d2e$export$352205f445242f02);
$parcel$export(module.exports, "isProxy", () => $0f257c4d62805d2e$export$5f3ca29d057519b3);
$parcel$export(module.exports, "markRaw", () => $0f257c4d62805d2e$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $0f257c4d62805d2e$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $0f257c4d62805d2e$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $0f257c4d62805d2e$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $0f257c4d62805d2e$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "computed", () => $0f257c4d62805d2e$export$2983e091f1a1e8e2);

var $esA86 = parcelRequire("esA86");
function $0f257c4d62805d2e$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $0f257c4d62805d2e$var$activeEffectScope;
class $0f257c4d62805d2e$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $0f257c4d62805d2e$var$activeEffectScope;
        if (!detached && $0f257c4d62805d2e$var$activeEffectScope) this.index = ($0f257c4d62805d2e$var$activeEffectScope.scopes || ($0f257c4d62805d2e$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $0f257c4d62805d2e$var$activeEffectScope;
            try {
                $0f257c4d62805d2e$var$activeEffectScope = this;
                return fn();
            } finally{
                $0f257c4d62805d2e$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $0f257c4d62805d2e$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $0f257c4d62805d2e$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function $0f257c4d62805d2e$export$7056603ea81600be(detached) {
    return new $0f257c4d62805d2e$export$1168ed9dbc71ddbd(detached);
}
function $0f257c4d62805d2e$var$recordEffectScope(effect, scope = $0f257c4d62805d2e$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $0f257c4d62805d2e$export$c7be4b0125a10cba() {
    return $0f257c4d62805d2e$var$activeEffectScope;
}
function $0f257c4d62805d2e$export$a780418acd4762da(fn) {
    if ($0f257c4d62805d2e$var$activeEffectScope) $0f257c4d62805d2e$var$activeEffectScope.cleanups.push(fn);
}
const $0f257c4d62805d2e$var$createDep = (effects)=>{
    const dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
};
const $0f257c4d62805d2e$var$wasTracked = (dep)=>(dep.w & $0f257c4d62805d2e$var$trackOpBit) > 0;
const $0f257c4d62805d2e$var$newTracked = (dep)=>(dep.n & $0f257c4d62805d2e$var$trackOpBit) > 0;
const $0f257c4d62805d2e$var$initDepMarkers = ({ deps: deps })=>{
    if (deps.length) for(let i = 0; i < deps.length; i++)deps[i].w |= $0f257c4d62805d2e$var$trackOpBit;
};
const $0f257c4d62805d2e$var$finalizeDepMarkers = (effect)=>{
    const { deps: deps } = effect;
    if (deps.length) {
        let ptr = 0;
        for(let i = 0; i < deps.length; i++){
            const dep = deps[i];
            if ($0f257c4d62805d2e$var$wasTracked(dep) && !$0f257c4d62805d2e$var$newTracked(dep)) dep.delete(effect);
            else deps[ptr++] = dep;
            dep.w &= ~$0f257c4d62805d2e$var$trackOpBit;
            dep.n &= ~$0f257c4d62805d2e$var$trackOpBit;
        }
        deps.length = ptr;
    }
};
const $0f257c4d62805d2e$var$targetMap = /* @__PURE__ */ new WeakMap();
let $0f257c4d62805d2e$var$effectTrackDepth = 0;
let $0f257c4d62805d2e$var$trackOpBit = 1;
const $0f257c4d62805d2e$var$maxMarkerBits = 30;
let $0f257c4d62805d2e$var$activeEffect;
const $0f257c4d62805d2e$export$3c41b1a4e06acc14 = Symbol("");
const $0f257c4d62805d2e$var$MAP_KEY_ITERATE_KEY = Symbol("");
class $0f257c4d62805d2e$export$28352bb4dd362521 {
    constructor(fn, scheduler = null, scope){
        this.fn = fn;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        this.parent = void 0;
        $0f257c4d62805d2e$var$recordEffectScope(this, scope);
    }
    run() {
        if (!this.active) return this.fn();
        let parent = $0f257c4d62805d2e$var$activeEffect;
        let lastShouldTrack = $0f257c4d62805d2e$var$shouldTrack;
        while(parent){
            if (parent === this) return;
            parent = parent.parent;
        }
        try {
            this.parent = $0f257c4d62805d2e$var$activeEffect;
            $0f257c4d62805d2e$var$activeEffect = this;
            $0f257c4d62805d2e$var$shouldTrack = true;
            $0f257c4d62805d2e$var$trackOpBit = 1 << ++$0f257c4d62805d2e$var$effectTrackDepth;
            if ($0f257c4d62805d2e$var$effectTrackDepth <= $0f257c4d62805d2e$var$maxMarkerBits) $0f257c4d62805d2e$var$initDepMarkers(this);
            else $0f257c4d62805d2e$var$cleanupEffect(this);
            return this.fn();
        } finally{
            if ($0f257c4d62805d2e$var$effectTrackDepth <= $0f257c4d62805d2e$var$maxMarkerBits) $0f257c4d62805d2e$var$finalizeDepMarkers(this);
            $0f257c4d62805d2e$var$trackOpBit = 1 << --$0f257c4d62805d2e$var$effectTrackDepth;
            $0f257c4d62805d2e$var$activeEffect = this.parent;
            $0f257c4d62805d2e$var$shouldTrack = lastShouldTrack;
            this.parent = void 0;
            if (this.deferStop) this.stop();
        }
    }
    stop() {
        if ($0f257c4d62805d2e$var$activeEffect === this) this.deferStop = true;
        else if (this.active) {
            $0f257c4d62805d2e$var$cleanupEffect(this);
            if (this.onStop) this.onStop();
            this.active = false;
        }
    }
}
function $0f257c4d62805d2e$var$cleanupEffect(effect2) {
    const { deps: deps } = effect2;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect2);
        deps.length = 0;
    }
}
function $0f257c4d62805d2e$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $0f257c4d62805d2e$export$28352bb4dd362521) fn = fn.effect.fn;
    const _effect = new $0f257c4d62805d2e$export$28352bb4dd362521(fn);
    if (options) {
        (0, $esA86.extend)(_effect, options);
        if (options.scope) $0f257c4d62805d2e$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $0f257c4d62805d2e$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $0f257c4d62805d2e$var$shouldTrack = true;
const $0f257c4d62805d2e$var$trackStack = [];
function $0f257c4d62805d2e$export$938a971395fef855() {
    $0f257c4d62805d2e$var$trackStack.push($0f257c4d62805d2e$var$shouldTrack);
    $0f257c4d62805d2e$var$shouldTrack = false;
}
function $0f257c4d62805d2e$export$1f8ffc6fd33b1d16() {
    $0f257c4d62805d2e$var$trackStack.push($0f257c4d62805d2e$var$shouldTrack);
    $0f257c4d62805d2e$var$shouldTrack = true;
}
function $0f257c4d62805d2e$export$c39176b1babaa8b8() {
    const last = $0f257c4d62805d2e$var$trackStack.pop();
    $0f257c4d62805d2e$var$shouldTrack = last === void 0 ? true : last;
}
function $0f257c4d62805d2e$export$6b2a7d5132615086(target, type, key) {
    if ($0f257c4d62805d2e$var$shouldTrack && $0f257c4d62805d2e$var$activeEffect) {
        let depsMap = $0f257c4d62805d2e$var$targetMap.get(target);
        if (!depsMap) $0f257c4d62805d2e$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $0f257c4d62805d2e$var$createDep());
        const eventInfo = void 0;
        $0f257c4d62805d2e$var$trackEffects(dep, eventInfo);
    }
}
function $0f257c4d62805d2e$var$trackEffects(dep, debuggerEventExtraInfo) {
    let shouldTrack2 = false;
    if ($0f257c4d62805d2e$var$effectTrackDepth <= $0f257c4d62805d2e$var$maxMarkerBits) {
        if (!$0f257c4d62805d2e$var$newTracked(dep)) {
            dep.n |= $0f257c4d62805d2e$var$trackOpBit;
            shouldTrack2 = !$0f257c4d62805d2e$var$wasTracked(dep);
        }
    } else shouldTrack2 = !dep.has($0f257c4d62805d2e$var$activeEffect);
    if (shouldTrack2) {
        dep.add($0f257c4d62805d2e$var$activeEffect);
        $0f257c4d62805d2e$var$activeEffect.deps.push(dep);
    }
}
function $0f257c4d62805d2e$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $0f257c4d62805d2e$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $esA86.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || !(0, $esA86.isSymbol)(key2) && key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $esA86.isArray)(target)) {
                    deps.push(depsMap.get($0f257c4d62805d2e$export$3c41b1a4e06acc14));
                    if ((0, $esA86.isMap)(target)) deps.push(depsMap.get($0f257c4d62805d2e$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $esA86.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $esA86.isArray)(target)) {
                    deps.push(depsMap.get($0f257c4d62805d2e$export$3c41b1a4e06acc14));
                    if ((0, $esA86.isMap)(target)) deps.push(depsMap.get($0f257c4d62805d2e$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $esA86.isMap)(target)) deps.push(depsMap.get($0f257c4d62805d2e$export$3c41b1a4e06acc14));
                break;
        }
    }
    const eventInfo = void 0;
    if (deps.length === 1) {
        if (deps[0]) $0f257c4d62805d2e$var$triggerEffects(deps[0]);
    } else {
        const effects = [];
        for (const dep of deps)if (dep) effects.push(...dep);
        $0f257c4d62805d2e$var$triggerEffects($0f257c4d62805d2e$var$createDep(effects));
    }
}
function $0f257c4d62805d2e$var$triggerEffects(dep, debuggerEventExtraInfo) {
    const effects = (0, $esA86.isArray)(dep) ? dep : [
        ...dep
    ];
    for (const effect2 of effects)if (effect2.computed) $0f257c4d62805d2e$var$triggerEffect(effect2, debuggerEventExtraInfo);
    for (const effect2 of effects)if (!effect2.computed) $0f257c4d62805d2e$var$triggerEffect(effect2, debuggerEventExtraInfo);
}
function $0f257c4d62805d2e$var$triggerEffect(effect2, debuggerEventExtraInfo) {
    if (effect2 !== $0f257c4d62805d2e$var$activeEffect || effect2.allowRecurse) {
        if (effect2.scheduler) effect2.scheduler();
        else effect2.run();
    }
}
function $0f257c4d62805d2e$var$getDepFromReactive(object, key) {
    var _a;
    return (_a = $0f257c4d62805d2e$var$targetMap.get(object)) == null ? void 0 : _a.get(key);
}
const $0f257c4d62805d2e$var$isNonTrackableKeys = /* @__PURE__ */ (0, $esA86.makeMap)(`__proto__,__v_isRef,__isVue`);
const $0f257c4d62805d2e$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $esA86.isSymbol)));
const $0f257c4d62805d2e$var$arrayInstrumentations = /* @__PURE__ */ $0f257c4d62805d2e$var$createArrayInstrumentations();
function $0f257c4d62805d2e$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $0f257c4d62805d2e$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$0f257c4d62805d2e$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($0f257c4d62805d2e$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $0f257c4d62805d2e$export$938a971395fef855();
            const res = $0f257c4d62805d2e$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $0f257c4d62805d2e$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $0f257c4d62805d2e$var$hasOwnProperty(key) {
    const obj = $0f257c4d62805d2e$export$ab18938b9fc5f28e(this);
    $0f257c4d62805d2e$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $0f257c4d62805d2e$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _shallow = false){
        this._isReadonly = _isReadonly;
        this._shallow = _shallow;
    }
    get(target, key, receiver) {
        const isReadonly2 = this._isReadonly, shallow = this._shallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return shallow;
        else if (key === "__v_raw" && receiver === (isReadonly2 ? shallow ? $0f257c4d62805d2e$var$shallowReadonlyMap : $0f257c4d62805d2e$var$readonlyMap : shallow ? $0f257c4d62805d2e$var$shallowReactiveMap : $0f257c4d62805d2e$var$reactiveMap).get(target)) return target;
        const targetIsArray = (0, $esA86.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $esA86.hasOwn)($0f257c4d62805d2e$var$arrayInstrumentations, key)) return Reflect.get($0f257c4d62805d2e$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $0f257c4d62805d2e$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $esA86.isSymbol)(key) ? $0f257c4d62805d2e$var$builtInSymbols.has(key) : $0f257c4d62805d2e$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $0f257c4d62805d2e$export$6b2a7d5132615086(target, "get", key);
        if (shallow) return res;
        if ($0f257c4d62805d2e$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $esA86.isIntegerKey)(key) ? res : res.value;
        if ((0, $esA86.isObject)(res)) return isReadonly2 ? $0f257c4d62805d2e$export$6ec456bd5b7b3c51(res) : $0f257c4d62805d2e$export$90a44edba14e47be(res);
        return res;
    }
}
class $0f257c4d62805d2e$var$MutableReactiveHandler extends $0f257c4d62805d2e$var$BaseReactiveHandler {
    constructor(shallow = false){
        super(false, shallow);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if ($0f257c4d62805d2e$export$92d09b48637741e7(oldValue) && $0f257c4d62805d2e$export$4f9f5282de18fc69(oldValue) && !$0f257c4d62805d2e$export$4f9f5282de18fc69(value)) return false;
        if (!this._shallow) {
            if (!$0f257c4d62805d2e$export$7f3fe6025abfa26e(value) && !$0f257c4d62805d2e$export$92d09b48637741e7(value)) {
                oldValue = $0f257c4d62805d2e$export$ab18938b9fc5f28e(oldValue);
                value = $0f257c4d62805d2e$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $esA86.isArray)(target) && $0f257c4d62805d2e$export$4f9f5282de18fc69(oldValue) && !$0f257c4d62805d2e$export$4f9f5282de18fc69(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = (0, $esA86.isArray)(target) && (0, $esA86.isIntegerKey)(key) ? Number(key) < target.length : (0, $esA86.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $0f257c4d62805d2e$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $0f257c4d62805d2e$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $esA86.hasChanged)(value, oldValue)) $0f257c4d62805d2e$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $esA86.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $0f257c4d62805d2e$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $esA86.isSymbol)(key) || !$0f257c4d62805d2e$var$builtInSymbols.has(key)) $0f257c4d62805d2e$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $0f257c4d62805d2e$export$6b2a7d5132615086(target, "iterate", (0, $esA86.isArray)(target) ? "length" : $0f257c4d62805d2e$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $0f257c4d62805d2e$var$ReadonlyReactiveHandler extends $0f257c4d62805d2e$var$BaseReactiveHandler {
    constructor(shallow = false){
        super(true, shallow);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $0f257c4d62805d2e$var$mutableHandlers = /* @__PURE__ */ new $0f257c4d62805d2e$var$MutableReactiveHandler();
const $0f257c4d62805d2e$var$readonlyHandlers = /* @__PURE__ */ new $0f257c4d62805d2e$var$ReadonlyReactiveHandler();
const $0f257c4d62805d2e$var$shallowReactiveHandlers = /* @__PURE__ */ new $0f257c4d62805d2e$var$MutableReactiveHandler(true);
const $0f257c4d62805d2e$var$shallowReadonlyHandlers = /* @__PURE__ */ new $0f257c4d62805d2e$var$ReadonlyReactiveHandler(true);
const $0f257c4d62805d2e$var$toShallow = (value)=>value;
const $0f257c4d62805d2e$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $0f257c4d62805d2e$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $0f257c4d62805d2e$export$ab18938b9fc5f28e(target);
    const rawKey = $0f257c4d62805d2e$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $esA86.hasChanged)(key, rawKey)) $0f257c4d62805d2e$export$6b2a7d5132615086(rawTarget, "get", key);
        $0f257c4d62805d2e$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $0f257c4d62805d2e$var$getProto(rawTarget);
    const wrap = isShallow ? $0f257c4d62805d2e$var$toShallow : isReadonly ? $0f257c4d62805d2e$var$toReadonly : $0f257c4d62805d2e$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $0f257c4d62805d2e$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $0f257c4d62805d2e$export$ab18938b9fc5f28e(target);
    const rawKey = $0f257c4d62805d2e$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $esA86.hasChanged)(key, rawKey)) $0f257c4d62805d2e$export$6b2a7d5132615086(rawTarget, "has", key);
        $0f257c4d62805d2e$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $0f257c4d62805d2e$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $0f257c4d62805d2e$export$6b2a7d5132615086($0f257c4d62805d2e$export$ab18938b9fc5f28e(target), "iterate", $0f257c4d62805d2e$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $0f257c4d62805d2e$var$add(value) {
    value = $0f257c4d62805d2e$export$ab18938b9fc5f28e(value);
    const target = $0f257c4d62805d2e$export$ab18938b9fc5f28e(this);
    const proto = $0f257c4d62805d2e$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $0f257c4d62805d2e$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $0f257c4d62805d2e$var$set(key, value) {
    value = $0f257c4d62805d2e$export$ab18938b9fc5f28e(value);
    const target = $0f257c4d62805d2e$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $0f257c4d62805d2e$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $0f257c4d62805d2e$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $0f257c4d62805d2e$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $esA86.hasChanged)(value, oldValue)) $0f257c4d62805d2e$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $0f257c4d62805d2e$var$deleteEntry(key) {
    const target = $0f257c4d62805d2e$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $0f257c4d62805d2e$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $0f257c4d62805d2e$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $0f257c4d62805d2e$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $0f257c4d62805d2e$var$clear() {
    const target = $0f257c4d62805d2e$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) $0f257c4d62805d2e$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $0f257c4d62805d2e$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $0f257c4d62805d2e$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $0f257c4d62805d2e$var$toShallow : isReadonly ? $0f257c4d62805d2e$var$toReadonly : $0f257c4d62805d2e$var$toReactive;
        !isReadonly && $0f257c4d62805d2e$export$6b2a7d5132615086(rawTarget, "iterate", $0f257c4d62805d2e$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $0f257c4d62805d2e$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $0f257c4d62805d2e$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $esA86.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $0f257c4d62805d2e$var$toShallow : isReadonly ? $0f257c4d62805d2e$var$toReadonly : $0f257c4d62805d2e$var$toReactive;
        !isReadonly && $0f257c4d62805d2e$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $0f257c4d62805d2e$var$MAP_KEY_ITERATE_KEY : $0f257c4d62805d2e$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $0f257c4d62805d2e$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : this;
    };
}
function $0f257c4d62805d2e$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $0f257c4d62805d2e$var$get(this, key);
        },
        get size () {
            return $0f257c4d62805d2e$var$size(this);
        },
        has: $0f257c4d62805d2e$var$has,
        add: $0f257c4d62805d2e$var$add,
        set: $0f257c4d62805d2e$var$set,
        delete: $0f257c4d62805d2e$var$deleteEntry,
        clear: $0f257c4d62805d2e$var$clear,
        forEach: $0f257c4d62805d2e$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $0f257c4d62805d2e$var$get(this, key, false, true);
        },
        get size () {
            return $0f257c4d62805d2e$var$size(this);
        },
        has: $0f257c4d62805d2e$var$has,
        add: $0f257c4d62805d2e$var$add,
        set: $0f257c4d62805d2e$var$set,
        delete: $0f257c4d62805d2e$var$deleteEntry,
        clear: $0f257c4d62805d2e$var$clear,
        forEach: $0f257c4d62805d2e$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $0f257c4d62805d2e$var$get(this, key, true);
        },
        get size () {
            return $0f257c4d62805d2e$var$size(this, true);
        },
        has (key) {
            return $0f257c4d62805d2e$var$has.call(this, key, true);
        },
        add: $0f257c4d62805d2e$var$createReadonlyMethod("add"),
        set: $0f257c4d62805d2e$var$createReadonlyMethod("set"),
        delete: $0f257c4d62805d2e$var$createReadonlyMethod("delete"),
        clear: $0f257c4d62805d2e$var$createReadonlyMethod("clear"),
        forEach: $0f257c4d62805d2e$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $0f257c4d62805d2e$var$get(this, key, true, true);
        },
        get size () {
            return $0f257c4d62805d2e$var$size(this, true);
        },
        has (key) {
            return $0f257c4d62805d2e$var$has.call(this, key, true);
        },
        add: $0f257c4d62805d2e$var$createReadonlyMethod("add"),
        set: $0f257c4d62805d2e$var$createReadonlyMethod("set"),
        delete: $0f257c4d62805d2e$var$createReadonlyMethod("delete"),
        clear: $0f257c4d62805d2e$var$createReadonlyMethod("clear"),
        forEach: $0f257c4d62805d2e$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $0f257c4d62805d2e$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $0f257c4d62805d2e$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $0f257c4d62805d2e$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $0f257c4d62805d2e$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$0f257c4d62805d2e$var$mutableInstrumentations, $0f257c4d62805d2e$var$readonlyInstrumentations, $0f257c4d62805d2e$var$shallowInstrumentations, $0f257c4d62805d2e$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $0f257c4d62805d2e$var$createInstrumentations();
function $0f257c4d62805d2e$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $0f257c4d62805d2e$var$shallowReadonlyInstrumentations : $0f257c4d62805d2e$var$shallowInstrumentations : isReadonly ? $0f257c4d62805d2e$var$readonlyInstrumentations : $0f257c4d62805d2e$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $esA86.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $0f257c4d62805d2e$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $0f257c4d62805d2e$var$createInstrumentationGetter(false, false)
};
const $0f257c4d62805d2e$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $0f257c4d62805d2e$var$createInstrumentationGetter(false, true)
};
const $0f257c4d62805d2e$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $0f257c4d62805d2e$var$createInstrumentationGetter(true, false)
};
const $0f257c4d62805d2e$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $0f257c4d62805d2e$var$createInstrumentationGetter(true, true)
};
function $0f257c4d62805d2e$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $0f257c4d62805d2e$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $esA86.toRawType)(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $0f257c4d62805d2e$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $0f257c4d62805d2e$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $0f257c4d62805d2e$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $0f257c4d62805d2e$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $0f257c4d62805d2e$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $0f257c4d62805d2e$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $0f257c4d62805d2e$var$targetTypeMap((0, $esA86.toRawType)(value));
}
function $0f257c4d62805d2e$export$90a44edba14e47be(target) {
    if ($0f257c4d62805d2e$export$92d09b48637741e7(target)) return target;
    return $0f257c4d62805d2e$var$createReactiveObject(target, false, $0f257c4d62805d2e$var$mutableHandlers, $0f257c4d62805d2e$var$mutableCollectionHandlers, $0f257c4d62805d2e$var$reactiveMap);
}
function $0f257c4d62805d2e$export$8d81cefd22d22260(target) {
    return $0f257c4d62805d2e$var$createReactiveObject(target, false, $0f257c4d62805d2e$var$shallowReactiveHandlers, $0f257c4d62805d2e$var$shallowCollectionHandlers, $0f257c4d62805d2e$var$shallowReactiveMap);
}
function $0f257c4d62805d2e$export$6ec456bd5b7b3c51(target) {
    return $0f257c4d62805d2e$var$createReactiveObject(target, true, $0f257c4d62805d2e$var$readonlyHandlers, $0f257c4d62805d2e$var$readonlyCollectionHandlers, $0f257c4d62805d2e$var$readonlyMap);
}
function $0f257c4d62805d2e$export$7c4b5f2b50f09f6b(target) {
    return $0f257c4d62805d2e$var$createReactiveObject(target, true, $0f257c4d62805d2e$var$shallowReadonlyHandlers, $0f257c4d62805d2e$var$shallowReadonlyCollectionHandlers, $0f257c4d62805d2e$var$shallowReadonlyMap);
}
function $0f257c4d62805d2e$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $esA86.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $0f257c4d62805d2e$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $0f257c4d62805d2e$export$352205f445242f02(value) {
    if ($0f257c4d62805d2e$export$92d09b48637741e7(value)) return $0f257c4d62805d2e$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $0f257c4d62805d2e$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $0f257c4d62805d2e$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $0f257c4d62805d2e$export$5f3ca29d057519b3(value) {
    return $0f257c4d62805d2e$export$352205f445242f02(value) || $0f257c4d62805d2e$export$92d09b48637741e7(value);
}
function $0f257c4d62805d2e$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $0f257c4d62805d2e$export$ab18938b9fc5f28e(raw) : observed;
}
function $0f257c4d62805d2e$export$995ab8b13ad7a9d0(value) {
    (0, $esA86.def)(value, "__v_skip", true);
    return value;
}
const $0f257c4d62805d2e$var$toReactive = (value)=>(0, $esA86.isObject)(value) ? $0f257c4d62805d2e$export$90a44edba14e47be(value) : value;
const $0f257c4d62805d2e$var$toReadonly = (value)=>(0, $esA86.isObject)(value) ? $0f257c4d62805d2e$export$6ec456bd5b7b3c51(value) : value;
function $0f257c4d62805d2e$var$trackRefValue(ref2) {
    if ($0f257c4d62805d2e$var$shouldTrack && $0f257c4d62805d2e$var$activeEffect) {
        ref2 = $0f257c4d62805d2e$export$ab18938b9fc5f28e(ref2);
        $0f257c4d62805d2e$var$trackEffects(ref2.dep || (ref2.dep = $0f257c4d62805d2e$var$createDep()));
    }
}
function $0f257c4d62805d2e$var$triggerRefValue(ref2, newVal) {
    ref2 = $0f257c4d62805d2e$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $0f257c4d62805d2e$var$triggerEffects(dep);
}
function $0f257c4d62805d2e$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $0f257c4d62805d2e$export$eff4d24c3ff7876e(value) {
    return $0f257c4d62805d2e$var$createRef(value, false);
}
function $0f257c4d62805d2e$export$9b7bc5fe3b17c8b3(value) {
    return $0f257c4d62805d2e$var$createRef(value, true);
}
function $0f257c4d62805d2e$var$createRef(rawValue, shallow) {
    if ($0f257c4d62805d2e$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $0f257c4d62805d2e$var$RefImpl(rawValue, shallow);
}
class $0f257c4d62805d2e$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $0f257c4d62805d2e$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $0f257c4d62805d2e$var$toReactive(value);
    }
    get value() {
        $0f257c4d62805d2e$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $0f257c4d62805d2e$export$7f3fe6025abfa26e(newVal) || $0f257c4d62805d2e$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $0f257c4d62805d2e$export$ab18938b9fc5f28e(newVal);
        if ((0, $esA86.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $0f257c4d62805d2e$var$toReactive(newVal);
            $0f257c4d62805d2e$var$triggerRefValue(this, newVal);
        }
    }
}
function $0f257c4d62805d2e$export$f402f86588575ccc(ref2) {
    $0f257c4d62805d2e$var$triggerRefValue(ref2, void 0);
}
function $0f257c4d62805d2e$export$a239a76781616204(ref2) {
    return $0f257c4d62805d2e$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $0f257c4d62805d2e$export$30bdcc2218aa9458(source) {
    return (0, $esA86.isFunction)(source) ? source() : $0f257c4d62805d2e$export$a239a76781616204(source);
}
const $0f257c4d62805d2e$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$0f257c4d62805d2e$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($0f257c4d62805d2e$export$4f9f5282de18fc69(oldValue) && !$0f257c4d62805d2e$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $0f257c4d62805d2e$export$f353fd1b97db3fa0(objectWithRefs) {
    return $0f257c4d62805d2e$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $0f257c4d62805d2e$var$shallowUnwrapHandlers);
}
class $0f257c4d62805d2e$var$CustomRefImpl {
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$0f257c4d62805d2e$var$trackRefValue(this), ()=>$0f257c4d62805d2e$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $0f257c4d62805d2e$export$a20c2dd6199824cb(factory) {
    return new $0f257c4d62805d2e$var$CustomRefImpl(factory);
}
function $0f257c4d62805d2e$export$2e9533675e5e70e0(object) {
    const ret = (0, $esA86.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $0f257c4d62805d2e$var$propertyToRef(object, key);
    return ret;
}
class $0f257c4d62805d2e$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $0f257c4d62805d2e$var$getDepFromReactive($0f257c4d62805d2e$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $0f257c4d62805d2e$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    get value() {
        return this._getter();
    }
}
function $0f257c4d62805d2e$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($0f257c4d62805d2e$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $esA86.isFunction)(source)) return new $0f257c4d62805d2e$var$GetterRefImpl(source);
    else if ((0, $esA86.isObject)(source) && arguments.length > 1) return $0f257c4d62805d2e$var$propertyToRef(source, key, defaultValue);
    else return $0f257c4d62805d2e$export$eff4d24c3ff7876e(source);
}
function $0f257c4d62805d2e$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $0f257c4d62805d2e$export$4f9f5282de18fc69(val) ? val : new $0f257c4d62805d2e$var$ObjectRefImpl(source, key, defaultValue);
}
class $0f257c4d62805d2e$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this._dirty = true;
        this.effect = new $0f257c4d62805d2e$export$28352bb4dd362521(getter, ()=>{
            if (!this._dirty) {
                this._dirty = true;
                $0f257c4d62805d2e$var$triggerRefValue(this);
            }
        });
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    get value() {
        const self = $0f257c4d62805d2e$export$ab18938b9fc5f28e(this);
        $0f257c4d62805d2e$var$trackRefValue(self);
        if (self._dirty || !self._cacheable) {
            self._dirty = false;
            self._value = self.effect.run();
        }
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
}
function $0f257c4d62805d2e$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $esA86.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $esA86.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $0f257c4d62805d2e$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
const $0f257c4d62805d2e$var$tick = /* @__PURE__ */ Promise.resolve();
const $0f257c4d62805d2e$var$queue = [];
let $0f257c4d62805d2e$var$queued = false;
const $0f257c4d62805d2e$var$scheduler = (fn)=>{
    $0f257c4d62805d2e$var$queue.push(fn);
    if (!$0f257c4d62805d2e$var$queued) {
        $0f257c4d62805d2e$var$queued = true;
        $0f257c4d62805d2e$var$tick.then($0f257c4d62805d2e$var$flush);
    }
};
const $0f257c4d62805d2e$var$flush = ()=>{
    for(let i = 0; i < $0f257c4d62805d2e$var$queue.length; i++)$0f257c4d62805d2e$var$queue[i]();
    $0f257c4d62805d2e$var$queue.length = 0;
    $0f257c4d62805d2e$var$queued = false;
};
class $0f257c4d62805d2e$var$DeferredComputedRefImpl {
    constructor(getter){
        this.dep = void 0;
        this._dirty = true;
        this.__v_isRef = true;
        this["__v_isReadonly"] = true;
        let compareTarget;
        let hasCompareTarget = false;
        let scheduled = false;
        this.effect = new $0f257c4d62805d2e$export$28352bb4dd362521(getter, (computedTrigger)=>{
            if (this.dep) {
                if (computedTrigger) {
                    compareTarget = this._value;
                    hasCompareTarget = true;
                } else if (!scheduled) {
                    const valueToCompare = hasCompareTarget ? compareTarget : this._value;
                    scheduled = true;
                    hasCompareTarget = false;
                    $0f257c4d62805d2e$var$scheduler(()=>{
                        if (this.effect.active && this._get() !== valueToCompare) $0f257c4d62805d2e$var$triggerRefValue(this);
                        scheduled = false;
                    });
                }
                for (const e of this.dep)if (e.computed instanceof $0f257c4d62805d2e$var$DeferredComputedRefImpl) e.scheduler(true);
            }
            this._dirty = true;
        });
        this.effect.computed = this;
    }
    _get() {
        if (this._dirty) {
            this._dirty = false;
            return this._value = this.effect.run();
        }
        return this._value;
    }
    get value() {
        $0f257c4d62805d2e$var$trackRefValue(this);
        return $0f257c4d62805d2e$export$ab18938b9fc5f28e(this)._get();
    }
}
function $0f257c4d62805d2e$export$483264c4ec4c46ce(getter) {
    return new $0f257c4d62805d2e$var$DeferredComputedRefImpl(getter);
}

});
parcelRegister("esA86", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $a86fb4cb4a32bb53$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $a86fb4cb4a32bb53$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $a86fb4cb4a32bb53$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $a86fb4cb4a32bb53$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $a86fb4cb4a32bb53$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $a86fb4cb4a32bb53$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $a86fb4cb4a32bb53$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $a86fb4cb4a32bb53$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $a86fb4cb4a32bb53$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $a86fb4cb4a32bb53$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $a86fb4cb4a32bb53$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $a86fb4cb4a32bb53$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $a86fb4cb4a32bb53$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $a86fb4cb4a32bb53$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $a86fb4cb4a32bb53$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $a86fb4cb4a32bb53$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $a86fb4cb4a32bb53$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $a86fb4cb4a32bb53$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $a86fb4cb4a32bb53$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $a86fb4cb4a32bb53$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $a86fb4cb4a32bb53$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $a86fb4cb4a32bb53$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $a86fb4cb4a32bb53$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $a86fb4cb4a32bb53$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $a86fb4cb4a32bb53$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $a86fb4cb4a32bb53$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $a86fb4cb4a32bb53$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $a86fb4cb4a32bb53$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $a86fb4cb4a32bb53$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $a86fb4cb4a32bb53$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $a86fb4cb4a32bb53$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $a86fb4cb4a32bb53$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $a86fb4cb4a32bb53$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $a86fb4cb4a32bb53$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $a86fb4cb4a32bb53$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $a86fb4cb4a32bb53$export$8756898546458274);
$parcel$export(module.exports, "normalizeClass", () => $a86fb4cb4a32bb53$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $a86fb4cb4a32bb53$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $a86fb4cb4a32bb53$export$6328ce7565ea1049);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $a86fb4cb4a32bb53$export$d186f5eb2e810715);
$parcel$export(module.exports, "includeBooleanAttr", () => $a86fb4cb4a32bb53$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "looseEqual", () => $a86fb4cb4a32bb53$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $a86fb4cb4a32bb53$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $a86fb4cb4a32bb53$export$b5b1545233b45293);
function $a86fb4cb4a32bb53$export$b41394a5437791c8(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
const $a86fb4cb4a32bb53$export$cf583d23ab39677c = {};
const $a86fb4cb4a32bb53$export$6bd8558f433f1cc1 = [];
const $a86fb4cb4a32bb53$export$5702a91a6f42969f = ()=>{};
const $a86fb4cb4a32bb53$export$c01351c0af048e39 = ()=>false;
const $a86fb4cb4a32bb53$var$onRE = /^on[^a-z]/;
const $a86fb4cb4a32bb53$export$1a2d97de39ecbb75 = (key)=>$a86fb4cb4a32bb53$var$onRE.test(key);
const $a86fb4cb4a32bb53$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $a86fb4cb4a32bb53$export$8b58be045bf06082 = Object.assign;
const $a86fb4cb4a32bb53$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $a86fb4cb4a32bb53$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $a86fb4cb4a32bb53$export$b5a638e9b3fff9f3 = (val, key)=>$a86fb4cb4a32bb53$var$hasOwnProperty.call(val, key);
const $a86fb4cb4a32bb53$export$43bee75e5e14138e = Array.isArray;
const $a86fb4cb4a32bb53$export$5c90113a285f2241 = (val)=>$a86fb4cb4a32bb53$export$1dccc787cc36538b(val) === "[object Map]";
const $a86fb4cb4a32bb53$export$6750766a7c7ec627 = (val)=>$a86fb4cb4a32bb53$export$1dccc787cc36538b(val) === "[object Set]";
const $a86fb4cb4a32bb53$export$871608497c498473 = (val)=>$a86fb4cb4a32bb53$export$1dccc787cc36538b(val) === "[object Date]";
const $a86fb4cb4a32bb53$export$49841c62b9eff15 = (val)=>$a86fb4cb4a32bb53$export$1dccc787cc36538b(val) === "[object RegExp]";
const $a86fb4cb4a32bb53$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $a86fb4cb4a32bb53$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $a86fb4cb4a32bb53$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $a86fb4cb4a32bb53$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $a86fb4cb4a32bb53$export$4369c812aac99591 = (val)=>{
    return ($a86fb4cb4a32bb53$export$a6cdc56e425d0d0a(val) || $a86fb4cb4a32bb53$export$f6e2535fb5126e54(val)) && $a86fb4cb4a32bb53$export$f6e2535fb5126e54(val.then) && $a86fb4cb4a32bb53$export$f6e2535fb5126e54(val.catch);
};
const $a86fb4cb4a32bb53$export$830c053460e5ddf6 = Object.prototype.toString;
const $a86fb4cb4a32bb53$export$1dccc787cc36538b = (value)=>$a86fb4cb4a32bb53$export$830c053460e5ddf6.call(value);
const $a86fb4cb4a32bb53$export$5ad0a3c360b8fbb5 = (value)=>{
    return $a86fb4cb4a32bb53$export$1dccc787cc36538b(value).slice(8, -1);
};
const $a86fb4cb4a32bb53$export$53b83ca8eaab0383 = (val)=>$a86fb4cb4a32bb53$export$1dccc787cc36538b(val) === "[object Object]";
const $a86fb4cb4a32bb53$export$e2a2b93446ec9fe = (key)=>$a86fb4cb4a32bb53$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $a86fb4cb4a32bb53$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $a86fb4cb4a32bb53$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $a86fb4cb4a32bb53$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $a86fb4cb4a32bb53$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $a86fb4cb4a32bb53$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $a86fb4cb4a32bb53$var$camelizeRE = /-(\w)/g;
const $a86fb4cb4a32bb53$export$161d051f5dd25de7 = $a86fb4cb4a32bb53$var$cacheStringFunction((str)=>{
    return str.replace($a86fb4cb4a32bb53$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $a86fb4cb4a32bb53$var$hyphenateRE = /\B([A-Z])/g;
const $a86fb4cb4a32bb53$export$6e6a0a3676c4b8bb = $a86fb4cb4a32bb53$var$cacheStringFunction((str)=>str.replace($a86fb4cb4a32bb53$var$hyphenateRE, "-$1").toLowerCase());
const $a86fb4cb4a32bb53$export$9a00dee1beb8f576 = $a86fb4cb4a32bb53$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $a86fb4cb4a32bb53$export$8c022799eeaaefcd = $a86fb4cb4a32bb53$var$cacheStringFunction((str)=>{
    const s = str ? `on${$a86fb4cb4a32bb53$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $a86fb4cb4a32bb53$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $a86fb4cb4a32bb53$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $a86fb4cb4a32bb53$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $a86fb4cb4a32bb53$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $a86fb4cb4a32bb53$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $a86fb4cb4a32bb53$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $a86fb4cb4a32bb53$var$_globalThis;
const $a86fb4cb4a32bb53$export$ff5f2eeb11fc7e14 = ()=>{
    return $a86fb4cb4a32bb53$var$_globalThis || ($a86fb4cb4a32bb53$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $a86fb4cb4a32bb53$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $a86fb4cb4a32bb53$export$53d5e12f9a1d3cde(name) {
    return $a86fb4cb4a32bb53$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $a86fb4cb4a32bb53$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `HYDRATE_EVENTS`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $a86fb4cb4a32bb53$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $a86fb4cb4a32bb53$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console";
const $a86fb4cb4a32bb53$export$f73b8c13b7f97ebf = /* @__PURE__ */ $a86fb4cb4a32bb53$export$b41394a5437791c8($a86fb4cb4a32bb53$var$GLOBALS_ALLOWED);
const $a86fb4cb4a32bb53$export$d6571a1911e4f27e = $a86fb4cb4a32bb53$export$f73b8c13b7f97ebf;
const $a86fb4cb4a32bb53$var$range = 2;
function $a86fb4cb4a32bb53$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $a86fb4cb4a32bb53$var$range; j <= i + $a86fb4cb4a32bb53$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $a86fb4cb4a32bb53$export$8756898546458274(value) {
    if ($a86fb4cb4a32bb53$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $a86fb4cb4a32bb53$export$844ec244b1367d54(item) ? $a86fb4cb4a32bb53$export$76a205ce979d066a(item) : $a86fb4cb4a32bb53$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($a86fb4cb4a32bb53$export$844ec244b1367d54(value) || $a86fb4cb4a32bb53$export$a6cdc56e425d0d0a(value)) return value;
}
const $a86fb4cb4a32bb53$var$listDelimiterRE = /;(?![^(]*\))/g;
const $a86fb4cb4a32bb53$var$propertyDelimiterRE = /:([^]+)/;
const $a86fb4cb4a32bb53$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $a86fb4cb4a32bb53$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($a86fb4cb4a32bb53$var$styleCommentRE, "").split($a86fb4cb4a32bb53$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($a86fb4cb4a32bb53$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $a86fb4cb4a32bb53$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $a86fb4cb4a32bb53$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $a86fb4cb4a32bb53$export$6e6a0a3676c4b8bb(key);
        if ($a86fb4cb4a32bb53$export$844ec244b1367d54(value) || typeof value === "number") ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $a86fb4cb4a32bb53$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($a86fb4cb4a32bb53$export$844ec244b1367d54(value)) res = value;
    else if ($a86fb4cb4a32bb53$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $a86fb4cb4a32bb53$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($a86fb4cb4a32bb53$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $a86fb4cb4a32bb53$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$a86fb4cb4a32bb53$export$844ec244b1367d54(klass)) props.class = $a86fb4cb4a32bb53$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $a86fb4cb4a32bb53$export$8756898546458274(style);
    return props;
}
const $a86fb4cb4a32bb53$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $a86fb4cb4a32bb53$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $a86fb4cb4a32bb53$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $a86fb4cb4a32bb53$export$1ccf854a0984f890 = /* @__PURE__ */ $a86fb4cb4a32bb53$export$b41394a5437791c8($a86fb4cb4a32bb53$var$HTML_TAGS);
const $a86fb4cb4a32bb53$export$6328ce7565ea1049 = /* @__PURE__ */ $a86fb4cb4a32bb53$export$b41394a5437791c8($a86fb4cb4a32bb53$var$SVG_TAGS);
const $a86fb4cb4a32bb53$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $a86fb4cb4a32bb53$export$b41394a5437791c8($a86fb4cb4a32bb53$var$VOID_TAGS);
const $a86fb4cb4a32bb53$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $a86fb4cb4a32bb53$export$d186f5eb2e810715 = /* @__PURE__ */ $a86fb4cb4a32bb53$export$b41394a5437791c8($a86fb4cb4a32bb53$var$specialBooleanAttrs);
const $a86fb4cb4a32bb53$export$f763ba3b84e9cd8c = /* @__PURE__ */ $a86fb4cb4a32bb53$export$b41394a5437791c8($a86fb4cb4a32bb53$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $a86fb4cb4a32bb53$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $a86fb4cb4a32bb53$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $a86fb4cb4a32bb53$var$attrValidationCache = {};
function $a86fb4cb4a32bb53$export$d55ef77660f30d12(name) {
    if ($a86fb4cb4a32bb53$var$attrValidationCache.hasOwnProperty(name)) return $a86fb4cb4a32bb53$var$attrValidationCache[name];
    const isUnsafe = $a86fb4cb4a32bb53$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $a86fb4cb4a32bb53$var$attrValidationCache[name] = !isUnsafe;
}
const $a86fb4cb4a32bb53$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $a86fb4cb4a32bb53$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $a86fb4cb4a32bb53$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $a86fb4cb4a32bb53$export$80da416f43933831 = /* @__PURE__ */ $a86fb4cb4a32bb53$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $a86fb4cb4a32bb53$var$escapeRE = /["'&<>]/;
function $a86fb4cb4a32bb53$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $a86fb4cb4a32bb53$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $a86fb4cb4a32bb53$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $a86fb4cb4a32bb53$export$7b105034a53bde5f(src) {
    return src.replace($a86fb4cb4a32bb53$var$commentStripRE, "");
}
function $a86fb4cb4a32bb53$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $a86fb4cb4a32bb53$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $a86fb4cb4a32bb53$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $a86fb4cb4a32bb53$export$871608497c498473(a);
    let bValidType = $a86fb4cb4a32bb53$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $a86fb4cb4a32bb53$export$a244864fd9645c7f(a);
    bValidType = $a86fb4cb4a32bb53$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $a86fb4cb4a32bb53$export$43bee75e5e14138e(a);
    bValidType = $a86fb4cb4a32bb53$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $a86fb4cb4a32bb53$var$looseCompareArrays(a, b) : false;
    aValidType = $a86fb4cb4a32bb53$export$a6cdc56e425d0d0a(a);
    bValidType = $a86fb4cb4a32bb53$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$a86fb4cb4a32bb53$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $a86fb4cb4a32bb53$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$a86fb4cb4a32bb53$export$ae8015769846262c(item, val));
}
const $a86fb4cb4a32bb53$export$b5b1545233b45293 = (val)=>{
    return $a86fb4cb4a32bb53$export$844ec244b1367d54(val) ? val : val == null ? "" : $a86fb4cb4a32bb53$export$43bee75e5e14138e(val) || $a86fb4cb4a32bb53$export$a6cdc56e425d0d0a(val) && (val.toString === $a86fb4cb4a32bb53$export$830c053460e5ddf6 || !$a86fb4cb4a32bb53$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $a86fb4cb4a32bb53$var$replacer, 2) : String(val);
};
const $a86fb4cb4a32bb53$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $a86fb4cb4a32bb53$var$replacer(_key, val.value);
    else if ($a86fb4cb4a32bb53$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2])=>{
            entries[`${key} =>`] = val2;
            return entries;
        }, {})
    };
    else if ($a86fb4cb4a32bb53$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ]
    };
    else if ($a86fb4cb4a32bb53$export$a6cdc56e425d0d0a(val) && !$a86fb4cb4a32bb53$export$43bee75e5e14138e(val) && !$a86fb4cb4a32bb53$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};

});



parcelRegister("anRt3", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("1vQIy")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("1vQIy")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("1vQIy")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("esA86")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("1vQIy")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("1vQIy")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("1vQIy")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("1vQIy")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("1vQIy")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("1vQIy")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("1vQIy")).createRenderer);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("1vQIy")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("1vQIy")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("1vQIy")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("1vQIy")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("1vQIy")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("1vQIy")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("1vQIy")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("1vQIy")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("1vQIy")).inject);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("1vQIy")).isRuntimeOnly);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("1vQIy")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("esA86")).normalizeClass);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("1vQIy")).onActivated);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("1vQIy")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("1vQIy")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("1vQIy")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("1vQIy")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("1vQIy")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("1vQIy")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("1iCGX")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("1iCGX")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("1vQIy")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("1vQIy")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("1vQIy")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("1vQIy")).resolveDynamicComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("1vQIy")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("1vQIy")).setTransitionHooks);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("1iCGX")).shallowReactive);
$parcel$export(module.exports, "Static", () => (parcelRequire("1vQIy")).Static);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("1iCGX")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("1vQIy")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("1vQIy")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("1vQIy")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("1vQIy")).watchEffect);
$parcel$export(module.exports, "watchPostEffect", () => (parcelRequire("1vQIy")).watchPostEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("1vQIy")).withCtx);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("1iCGX")).shallowRef);
$parcel$export(module.exports, "unref", () => (parcelRequire("1iCGX")).unref);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("esA86")).toDisplayString);

$parcel$export(module.exports, "Transition", () => $78f586f1db1d6321$export$be58926105124dd4);
$parcel$export(module.exports, "withModifiers", () => $78f586f1db1d6321$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "createApp", () => $78f586f1db1d6321$export$4e373c34abfa8c68);

var $1vQIy = parcelRequire("1vQIy");
var $esA86 = parcelRequire("esA86");
var $1iCGX = parcelRequire("1iCGX");parcelRequire("1iCGX");parcelRequire("esA86");

var $esA86 = parcelRequire("esA86");
const $78f586f1db1d6321$var$svgNS = "http://www.w3.org/2000/svg";
const $78f586f1db1d6321$var$doc = typeof document !== "undefined" ? document : null;
const $78f586f1db1d6321$var$templateContainer = $78f586f1db1d6321$var$doc && /* @__PURE__ */ $78f586f1db1d6321$var$doc.createElement("template");
const $78f586f1db1d6321$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, isSVG, is, props)=>{
        const el = isSVG ? $78f586f1db1d6321$var$doc.createElementNS($78f586f1db1d6321$var$svgNS, tag) : $78f586f1db1d6321$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$78f586f1db1d6321$var$doc.createTextNode(text),
    createComment: (text)=>$78f586f1db1d6321$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$78f586f1db1d6321$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, isSVG, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $78f586f1db1d6321$var$templateContainer.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
            const template = $78f586f1db1d6321$var$templateContainer.content;
            if (isSVG) {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $78f586f1db1d6321$var$TRANSITION = "transition";
const $78f586f1db1d6321$var$ANIMATION = "animation";
const $78f586f1db1d6321$var$vtcKey = Symbol("_vtc");
const $78f586f1db1d6321$export$be58926105124dd4 = (props, { slots: slots })=>(0, $1vQIy.h)((0, $1vQIy.BaseTransition), $78f586f1db1d6321$var$resolveTransitionProps(props), slots);
$78f586f1db1d6321$export$be58926105124dd4.displayName = "Transition";
const $78f586f1db1d6321$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $78f586f1db1d6321$var$TransitionPropsValidators = $78f586f1db1d6321$export$be58926105124dd4.props = /* @__PURE__ */ (0, $esA86.extend)({}, (0, $1vQIy.BaseTransitionPropsValidators), $78f586f1db1d6321$var$DOMTransitionPropsValidators);
const $78f586f1db1d6321$var$callHook = (hook, args = [])=>{
    if ((0, $esA86.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $78f586f1db1d6321$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $esA86.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $78f586f1db1d6321$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $78f586f1db1d6321$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $78f586f1db1d6321$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $78f586f1db1d6321$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $78f586f1db1d6321$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $78f586f1db1d6321$var$removeTransitionClass(el, leaveFromClass);
        $78f586f1db1d6321$var$removeTransitionClass(el, leaveToClass);
        $78f586f1db1d6321$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $78f586f1db1d6321$var$callHook(hook, [
                el,
                resolve
            ]);
            $78f586f1db1d6321$var$nextFrame(()=>{
                $78f586f1db1d6321$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $78f586f1db1d6321$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$78f586f1db1d6321$var$hasExplicitCallback(hook)) $78f586f1db1d6321$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $esA86.extend)(baseProps, {
        onBeforeEnter (el) {
            $78f586f1db1d6321$var$callHook(onBeforeEnter, [
                el
            ]);
            $78f586f1db1d6321$var$addTransitionClass(el, enterFromClass);
            $78f586f1db1d6321$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $78f586f1db1d6321$var$callHook(onBeforeAppear, [
                el
            ]);
            $78f586f1db1d6321$var$addTransitionClass(el, appearFromClass);
            $78f586f1db1d6321$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $78f586f1db1d6321$var$addTransitionClass(el, leaveFromClass);
            $78f586f1db1d6321$var$forceReflow();
            $78f586f1db1d6321$var$addTransitionClass(el, leaveActiveClass);
            $78f586f1db1d6321$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $78f586f1db1d6321$var$removeTransitionClass(el, leaveFromClass);
                $78f586f1db1d6321$var$addTransitionClass(el, leaveToClass);
                if (!$78f586f1db1d6321$var$hasExplicitCallback(onLeave)) $78f586f1db1d6321$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $78f586f1db1d6321$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $78f586f1db1d6321$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $78f586f1db1d6321$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $78f586f1db1d6321$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $78f586f1db1d6321$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $esA86.isObject)(duration)) return [
        $78f586f1db1d6321$var$NumberOf(duration.enter),
        $78f586f1db1d6321$var$NumberOf(duration.leave)
    ];
    else {
        const n = $78f586f1db1d6321$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $78f586f1db1d6321$var$NumberOf(val) {
    const res = (0, $esA86.toNumber)(val);
    return res;
}
function $78f586f1db1d6321$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$78f586f1db1d6321$var$vtcKey] || (el[$78f586f1db1d6321$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $78f586f1db1d6321$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$78f586f1db1d6321$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$78f586f1db1d6321$var$vtcKey] = void 0;
    }
}
function $78f586f1db1d6321$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $78f586f1db1d6321$var$endId = 0;
function $78f586f1db1d6321$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$78f586f1db1d6321$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $78f586f1db1d6321$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $78f586f1db1d6321$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$78f586f1db1d6321$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$78f586f1db1d6321$var$TRANSITION}Duration`);
    const transitionTimeout = $78f586f1db1d6321$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$78f586f1db1d6321$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$78f586f1db1d6321$var$ANIMATION}Duration`);
    const animationTimeout = $78f586f1db1d6321$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $78f586f1db1d6321$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $78f586f1db1d6321$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $78f586f1db1d6321$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $78f586f1db1d6321$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $78f586f1db1d6321$var$TRANSITION : $78f586f1db1d6321$var$ANIMATION : null;
        propCount = type ? type === $78f586f1db1d6321$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $78f586f1db1d6321$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$78f586f1db1d6321$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $78f586f1db1d6321$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$78f586f1db1d6321$var$toMs(d) + $78f586f1db1d6321$var$toMs(delays[i])));
}
function $78f586f1db1d6321$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $78f586f1db1d6321$var$forceReflow() {
    return document.body.offsetHeight;
}
function $78f586f1db1d6321$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$78f586f1db1d6321$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $78f586f1db1d6321$var$vShowOldKey = Symbol("_vod");
const $78f586f1db1d6321$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$78f586f1db1d6321$var$vShowOldKey] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $78f586f1db1d6321$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $78f586f1db1d6321$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $78f586f1db1d6321$var$setDisplay(el, false);
            });
        } else $78f586f1db1d6321$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $78f586f1db1d6321$var$setDisplay(el, value);
    }
};
function $78f586f1db1d6321$var$setDisplay(el, value) {
    el.style.display = value ? el[$78f586f1db1d6321$var$vShowOldKey] : "none";
}
function $78f586f1db1d6321$var$initVShowForSSR() {
    $78f586f1db1d6321$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
function $78f586f1db1d6321$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $esA86.isString)(next);
    if (next && !isCssString) {
        if (prev && !(0, $esA86.isString)(prev)) {
            for(const key in prev)if (next[key] == null) $78f586f1db1d6321$var$setStyle(style, key, "");
        }
        for(const key in next)$78f586f1db1d6321$var$setStyle(style, key, next[key]);
    } else {
        const currentDisplay = style.display;
        if (isCssString) {
            if (prev !== next) style.cssText = next;
        } else if (prev) el.removeAttribute("style");
        if ($78f586f1db1d6321$var$vShowOldKey in el) style.display = currentDisplay;
    }
}
const $78f586f1db1d6321$var$semicolonRE = /[^\\];\s*$/;
const $78f586f1db1d6321$var$importantRE = /\s*!important$/;
function $78f586f1db1d6321$var$setStyle(style, name, val) {
    if ((0, $esA86.isArray)(val)) val.forEach((v)=>$78f586f1db1d6321$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $78f586f1db1d6321$var$autoPrefix(style, name);
            if ($78f586f1db1d6321$var$importantRE.test(val)) style.setProperty((0, $esA86.hyphenate)(prefixed), val.replace($78f586f1db1d6321$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $78f586f1db1d6321$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $78f586f1db1d6321$var$prefixCache = {};
function $78f586f1db1d6321$var$autoPrefix(style, rawName) {
    const cached = $78f586f1db1d6321$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $esA86.camelize)(rawName);
    if (name !== "filter" && name in style) return $78f586f1db1d6321$var$prefixCache[rawName] = name;
    name = (0, $esA86.capitalize)(name);
    for(let i = 0; i < $78f586f1db1d6321$var$prefixes.length; i++){
        const prefixed = $78f586f1db1d6321$var$prefixes[i] + name;
        if (prefixed in style) return $78f586f1db1d6321$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $78f586f1db1d6321$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $78f586f1db1d6321$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($78f586f1db1d6321$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($78f586f1db1d6321$var$xlinkNS, key, value);
    } else {
        const isBoolean = (0, $esA86.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $esA86.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $78f586f1db1d6321$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        el._value = value;
        const oldValue = tag === "OPTION" ? el.getAttribute("value") : el.value;
        const newValue = value == null ? "" : value;
        if (oldValue !== newValue) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $esA86.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $78f586f1db1d6321$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $78f586f1db1d6321$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $78f586f1db1d6321$var$veiKey = Symbol("_vei");
function $78f586f1db1d6321$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$78f586f1db1d6321$var$veiKey] || (el[$78f586f1db1d6321$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $78f586f1db1d6321$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $78f586f1db1d6321$var$createInvoker(nextValue, instance);
            $78f586f1db1d6321$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $78f586f1db1d6321$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $78f586f1db1d6321$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $78f586f1db1d6321$var$parseName(name) {
    let options;
    if ($78f586f1db1d6321$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($78f586f1db1d6321$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $esA86.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $78f586f1db1d6321$var$cachedNow = 0;
const $78f586f1db1d6321$var$p = /* @__PURE__ */ Promise.resolve();
const $78f586f1db1d6321$var$getNow = ()=>$78f586f1db1d6321$var$cachedNow || ($78f586f1db1d6321$var$p.then(()=>$78f586f1db1d6321$var$cachedNow = 0), $78f586f1db1d6321$var$cachedNow = Date.now());
function $78f586f1db1d6321$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $1vQIy.callWithAsyncErrorHandling)($78f586f1db1d6321$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $78f586f1db1d6321$var$getNow();
    return invoker;
}
function $78f586f1db1d6321$var$patchStopImmediatePropagation(e, value) {
    if ((0, $esA86.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $78f586f1db1d6321$var$nativeOnRE = /^on[a-z]/;
const $78f586f1db1d6321$var$patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    if (key === "class") $78f586f1db1d6321$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $78f586f1db1d6321$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $esA86.isOn)(key)) {
        if (!(0, $esA86.isModelListener)(key)) $78f586f1db1d6321$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $78f586f1db1d6321$var$shouldSetAsProp(el, key, nextValue, isSVG)) $78f586f1db1d6321$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $78f586f1db1d6321$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $78f586f1db1d6321$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $78f586f1db1d6321$var$nativeOnRE.test(key) && (0, $esA86.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if ($78f586f1db1d6321$var$nativeOnRE.test(key) && (0, $esA86.isString)(value)) return false;
    return key in el;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $78f586f1db1d6321$export$a00e2346eabbdbef(options, hydrate2) {
    const Comp = (0, $1vQIy.defineComponent)(options);
    class VueCustomElement extends $78f586f1db1d6321$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $78f586f1db1d6321$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options)=>{
    return /* @__PURE__ */ $78f586f1db1d6321$export$a00e2346eabbdbef(options, $78f586f1db1d6321$export$fa8d919ba61d84db);
};
const $78f586f1db1d6321$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $78f586f1db1d6321$export$b337c1a55163dbe3 extends $78f586f1db1d6321$var$BaseClass {
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._ob = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        if (this._ob) {
            this._ob.disconnect();
            this._ob = null;
        }
        (0, $1vQIy.nextTick)(()=>{
            if (!this._connected) {
                $78f586f1db1d6321$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $esA86.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $esA86.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $esA86.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $esA86.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $esA86.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.getAttribute(key);
        const camelKey = (0, $esA86.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $esA86.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $esA86.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $esA86.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $esA86.hyphenate)(key));
            }
        }
    }
    _update() {
        $78f586f1db1d6321$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $1vQIy.createVNode)(this._def, (0, $esA86.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $esA86.hyphenate)(event) !== event) dispatch((0, $esA86.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $78f586f1db1d6321$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $78f586f1db1d6321$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $1vQIy.getCurrentInstance)();
        if (!instance) return 0, $esA86.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $esA86.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $esA86.EMPTY_OBJ;
        return mod;
    }
}
function $78f586f1db1d6321$export$ef28b76f07940108(getter) {
    const instance = (0, $1vQIy.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$78f586f1db1d6321$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $78f586f1db1d6321$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $1vQIy.watchPostEffect)(setVars);
    (0, $1vQIy.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $1vQIy.onUnmounted)(()=>ob.disconnect());
    });
}
function $78f586f1db1d6321$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $78f586f1db1d6321$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $78f586f1db1d6321$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $1vQIy.Fragment)) vnode.children.forEach((c)=>$78f586f1db1d6321$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $1vQIy.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $78f586f1db1d6321$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $78f586f1db1d6321$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        for(const key in vars)style.setProperty(`--${key}`, vars[key]);
    }
}
const $78f586f1db1d6321$var$positionMap = /* @__PURE__ */ new WeakMap();
const $78f586f1db1d6321$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $78f586f1db1d6321$var$moveCbKey = Symbol("_moveCb");
const $78f586f1db1d6321$var$enterCbKey = Symbol("_enterCb");
const $78f586f1db1d6321$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $esA86.extend)({}, $78f586f1db1d6321$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $1vQIy.getCurrentInstance)();
        const state = (0, $1vQIy.useTransitionState)();
        let prevChildren;
        let children;
        (0, $1vQIy.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$78f586f1db1d6321$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($78f586f1db1d6321$var$callPendingCbs);
            prevChildren.forEach($78f586f1db1d6321$var$recordPosition);
            const movedChildren = prevChildren.filter($78f586f1db1d6321$var$applyTranslation);
            $78f586f1db1d6321$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $78f586f1db1d6321$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$78f586f1db1d6321$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$78f586f1db1d6321$var$moveCbKey] = null;
                        $78f586f1db1d6321$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $1iCGX.toRaw)(props);
            const cssTransitionProps = $78f586f1db1d6321$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $1vQIy.Fragment);
            prevChildren = children;
            children = slots.default ? (0, $1vQIy.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $1vQIy.setTransitionHooks)(child, (0, $1vQIy.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren) for(let i = 0; i < prevChildren.length; i++){
                const child = prevChildren[i];
                (0, $1vQIy.setTransitionHooks)(child, (0, $1vQIy.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                $78f586f1db1d6321$var$positionMap.set(child, child.el.getBoundingClientRect());
            }
            return (0, $1vQIy.createVNode)(tag, null, children);
        };
    }
};
const $78f586f1db1d6321$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $78f586f1db1d6321$var$removeMode($78f586f1db1d6321$var$TransitionGroupImpl.props);
const $78f586f1db1d6321$export$19ffa8f511f7bc2e = $78f586f1db1d6321$var$TransitionGroupImpl;
function $78f586f1db1d6321$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$78f586f1db1d6321$var$moveCbKey]) el[$78f586f1db1d6321$var$moveCbKey]();
    if (el[$78f586f1db1d6321$var$enterCbKey]) el[$78f586f1db1d6321$var$enterCbKey]();
}
function $78f586f1db1d6321$var$recordPosition(c) {
    $78f586f1db1d6321$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $78f586f1db1d6321$var$applyTranslation(c) {
    const oldPos = $78f586f1db1d6321$var$positionMap.get(c);
    const newPos = $78f586f1db1d6321$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $78f586f1db1d6321$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$78f586f1db1d6321$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $78f586f1db1d6321$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $78f586f1db1d6321$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $esA86.isArray)(fn) ? (value)=>(0, $esA86.invokeArrayFns)(fn, value) : fn;
};
function $78f586f1db1d6321$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $78f586f1db1d6321$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $78f586f1db1d6321$var$assignKey = Symbol("_assign");
const $78f586f1db1d6321$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$78f586f1db1d6321$var$assignKey] = $78f586f1db1d6321$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $78f586f1db1d6321$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $esA86.looseToNumber)(domValue);
            el[$78f586f1db1d6321$var$assignKey](domValue);
        });
        if (trim) $78f586f1db1d6321$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $78f586f1db1d6321$var$addEventListener(el, "compositionstart", $78f586f1db1d6321$var$onCompositionStart);
            $78f586f1db1d6321$var$addEventListener(el, "compositionend", $78f586f1db1d6321$var$onCompositionEnd);
            $78f586f1db1d6321$var$addEventListener(el, "change", $78f586f1db1d6321$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$78f586f1db1d6321$var$assignKey] = $78f586f1db1d6321$var$getModelAssigner(vnode);
        if (el.composing) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === value) return;
            if ((number || el.type === "number") && (0, $esA86.looseToNumber)(el.value) === value) return;
        }
        const newValue = value == null ? "" : value;
        if (el.value !== newValue) el.value = newValue;
    }
};
const $78f586f1db1d6321$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$78f586f1db1d6321$var$assignKey] = $78f586f1db1d6321$var$getModelAssigner(vnode);
        $78f586f1db1d6321$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $78f586f1db1d6321$var$getValue(el);
            const checked = el.checked;
            const assign = el[$78f586f1db1d6321$var$assignKey];
            if ((0, $esA86.isArray)(modelValue)) {
                const index = (0, $esA86.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $esA86.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($78f586f1db1d6321$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $78f586f1db1d6321$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$78f586f1db1d6321$var$assignKey] = $78f586f1db1d6321$var$getModelAssigner(vnode);
        $78f586f1db1d6321$var$setChecked(el, binding, vnode);
    }
};
function $78f586f1db1d6321$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $esA86.isArray)(value)) el.checked = (0, $esA86.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $esA86.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $esA86.looseEqual)(value, $78f586f1db1d6321$var$getCheckboxValue(el, true));
}
const $78f586f1db1d6321$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $esA86.looseEqual)(value, vnode.props.value);
        el[$78f586f1db1d6321$var$assignKey] = $78f586f1db1d6321$var$getModelAssigner(vnode);
        $78f586f1db1d6321$var$addEventListener(el, "change", ()=>{
            el[$78f586f1db1d6321$var$assignKey]($78f586f1db1d6321$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$78f586f1db1d6321$var$assignKey] = $78f586f1db1d6321$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $esA86.looseEqual)(value, vnode.props.value);
    }
};
const $78f586f1db1d6321$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $esA86.isSet)(value);
        $78f586f1db1d6321$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $esA86.looseToNumber)($78f586f1db1d6321$var$getValue(o)) : $78f586f1db1d6321$var$getValue(o));
            el[$78f586f1db1d6321$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
        });
        el[$78f586f1db1d6321$var$assignKey] = $78f586f1db1d6321$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $78f586f1db1d6321$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$78f586f1db1d6321$var$assignKey] = $78f586f1db1d6321$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        $78f586f1db1d6321$var$setSelected(el, value);
    }
};
function $78f586f1db1d6321$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    if (isMultiple && !(0, $esA86.isArray)(value) && !(0, $esA86.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $78f586f1db1d6321$var$getValue(option);
        if (isMultiple) {
            if ((0, $esA86.isArray)(value)) option.selected = (0, $esA86.looseIndexOf)(value, optionValue) > -1;
            else option.selected = value.has(optionValue);
        } else if ((0, $esA86.looseEqual)($78f586f1db1d6321$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $78f586f1db1d6321$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $78f586f1db1d6321$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $78f586f1db1d6321$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $78f586f1db1d6321$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $78f586f1db1d6321$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $78f586f1db1d6321$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $78f586f1db1d6321$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $78f586f1db1d6321$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $78f586f1db1d6321$export$87d227567b51ca39;
        case "TEXTAREA":
            return $78f586f1db1d6321$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $78f586f1db1d6321$export$8847c2e532b35714;
                case "radio":
                    return $78f586f1db1d6321$export$b4356c59b38b7aa9;
                default:
                    return $78f586f1db1d6321$export$f1f88689f5728478;
            }
    }
}
function $78f586f1db1d6321$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $78f586f1db1d6321$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $78f586f1db1d6321$var$initVModelForSSR() {
    $78f586f1db1d6321$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $78f586f1db1d6321$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $esA86.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $78f586f1db1d6321$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $esA86.isArray)(value)) {
            if (vnode.props && (0, $esA86.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $esA86.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $78f586f1db1d6321$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $78f586f1db1d6321$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $78f586f1db1d6321$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $78f586f1db1d6321$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$78f586f1db1d6321$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $78f586f1db1d6321$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    return (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $78f586f1db1d6321$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    };
};
const $78f586f1db1d6321$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $78f586f1db1d6321$export$f691a8759658f782 = (fn, modifiers)=>{
    return (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $esA86.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $78f586f1db1d6321$var$keyNames[k] === eventKey)) return fn(event);
    };
};
const $78f586f1db1d6321$var$rendererOptions = /* @__PURE__ */ (0, $esA86.extend)({
    patchProp: $78f586f1db1d6321$var$patchProp
}, $78f586f1db1d6321$var$nodeOps);
let $78f586f1db1d6321$var$renderer;
let $78f586f1db1d6321$var$enabledHydration = false;
function $78f586f1db1d6321$var$ensureRenderer() {
    return $78f586f1db1d6321$var$renderer || ($78f586f1db1d6321$var$renderer = (0, $1vQIy.createRenderer)($78f586f1db1d6321$var$rendererOptions));
}
function $78f586f1db1d6321$var$ensureHydrationRenderer() {
    $78f586f1db1d6321$var$renderer = $78f586f1db1d6321$var$enabledHydration ? $78f586f1db1d6321$var$renderer : (0, $1vQIy.createHydrationRenderer)($78f586f1db1d6321$var$rendererOptions);
    $78f586f1db1d6321$var$enabledHydration = true;
    return $78f586f1db1d6321$var$renderer;
}
const $78f586f1db1d6321$export$b3890eb0ae9dca99 = (...args)=>{
    $78f586f1db1d6321$var$ensureRenderer().render(...args);
};
const $78f586f1db1d6321$export$fa8d919ba61d84db = (...args)=>{
    $78f586f1db1d6321$var$ensureHydrationRenderer().hydrate(...args);
};
const $78f586f1db1d6321$export$4e373c34abfa8c68 = (...args)=>{
    const app = $78f586f1db1d6321$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $78f586f1db1d6321$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $esA86.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, container instanceof SVGElement);
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $78f586f1db1d6321$export$35800275c0037383 = (...args)=>{
    const app = $78f586f1db1d6321$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $78f586f1db1d6321$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, container instanceof SVGElement);
    };
    return app;
};
function $78f586f1db1d6321$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $esA86.isHTMLTag)(tag) || (0, $esA86.isSVGTag)(tag),
        writable: false
    });
}
function $78f586f1db1d6321$var$injectCompilerOptionsCheck(app) {
    if ((0, $1vQIy.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $1vQIy.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $1vQIy.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $1vQIy.warn)(msg);
            }
        });
    }
}
function $78f586f1db1d6321$var$normalizeContainer(container) {
    if ((0, $esA86.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $78f586f1db1d6321$var$ssrDirectiveInitialized = false;
const $78f586f1db1d6321$export$800b28255aa678d9 = ()=>{
    if (!$78f586f1db1d6321$var$ssrDirectiveInitialized) {
        $78f586f1db1d6321$var$ssrDirectiveInitialized = true;
        $78f586f1db1d6321$var$initVModelForSSR();
        $78f586f1db1d6321$var$initVShowForSSR();
    }
};

});



parcelRegister("hhMUS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c959f7f6051dca3e$export$2e2bcd8739ae039);
let $c959f7f6051dca3e$var$NOOP = ()=>{};
var $c959f7f6051dca3e$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("eCPNH", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa5ccbd08a76f16a$export$2e2bcd8739ae039);
let $aa5ccbd08a76f16a$var$script;




let $aa5ccbd08a76f16a$var$initialize = ()=>{
    $aa5ccbd08a76f16a$var$script = (parcelRequire("2w4NN"));
    if ($aa5ccbd08a76f16a$var$script.__esModule) $aa5ccbd08a76f16a$var$script = $aa5ccbd08a76f16a$var$script.default;
    $aa5ccbd08a76f16a$var$script.render = (parcelRequire("gCzAr")).render;
    $aa5ccbd08a76f16a$var$script.__cssModules = {};
    (parcelRequire("jE4s6")).default($aa5ccbd08a76f16a$var$script);
    $aa5ccbd08a76f16a$var$script.__scopeId = "data-v-d51654";
    $aa5ccbd08a76f16a$var$script.__file = "Navigation.vue";
};
$aa5ccbd08a76f16a$var$initialize();
var $aa5ccbd08a76f16a$export$2e2bcd8739ae039 = $aa5ccbd08a76f16a$var$script;

});
parcelRegister("2w4NN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1d524b86242a6830$export$2e2bcd8739ae039);
var $1d524b86242a6830$export$2e2bcd8739ae039 = {
    name: "Navigation"
};

});

parcelRegister("gCzAr", function(module, exports) {

$parcel$export(module.exports, "render", () => $c19bccb76722cceb$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
function $c19bccb76722cceb$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $1vQIy.resolveComponent)("router-link");
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("nav", null, [
        (0, $1vQIy.createElementVNode)("ul", null, [
            (0, $1vQIy.createElementVNode)("li", null, [
                (0, $1vQIy.createVNode)(_component_router_link, {
                    to: {
                        name: "Home"
                    }
                }, {
                    default: (0, $1vQIy.withCtx)(()=>[
                            ..._cache[0] || (_cache[0] = [
                                (0, $1vQIy.createTextVNode)("Home", -1)
                            ])
                        ]),
                    _: 1
                })
            ]),
            (0, $1vQIy.createElementVNode)("li", null, [
                (0, $1vQIy.createVNode)(_component_router_link, {
                    to: {
                        name: "About"
                    }
                }, {
                    default: (0, $1vQIy.withCtx)(()=>[
                            ..._cache[1] || (_cache[1] = [
                                (0, $1vQIy.createTextVNode)("About", -1)
                            ])
                        ]),
                    _: 1
                })
            ]),
            (0, $1vQIy.createElementVNode)("li", null, [
                (0, $1vQIy.createVNode)(_component_router_link, {
                    to: {
                        name: "Fanart"
                    }
                }, {
                    default: (0, $1vQIy.withCtx)(()=>[
                            ..._cache[2] || (_cache[2] = [
                                (0, $1vQIy.createTextVNode)("Fan art", -1)
                            ])
                        ]),
                    _: 1
                })
            ])
        ])
    ]);
}

});

parcelRegister("jE4s6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4d534dbc6fc36b7$export$2e2bcd8739ae039);
let $e4d534dbc6fc36b7$var$NOOP = ()=>{};
var $e4d534dbc6fc36b7$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("g2ma9", function(module, exports) {

$parcel$export(module.exports, "default", () => $bace06520e3129e4$export$2e2bcd8739ae039);
let $bace06520e3129e4$var$script;



let $bace06520e3129e4$var$initialize = ()=>{
    $bace06520e3129e4$var$script = (parcelRequire("eeyLP"));
    if ($bace06520e3129e4$var$script.__esModule) $bace06520e3129e4$var$script = $bace06520e3129e4$var$script.default;
    $bace06520e3129e4$var$script.render = (parcelRequire("jlmG6")).render;
    (parcelRequire("4U7Rq")).default($bace06520e3129e4$var$script);
    $bace06520e3129e4$var$script.__scopeId = "data-v-90f7b1";
    $bace06520e3129e4$var$script.__file = "Icon.vue";
};
$bace06520e3129e4$var$initialize();
var $bace06520e3129e4$export$2e2bcd8739ae039 = $bace06520e3129e4$var$script;

});
parcelRegister("eeyLP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a5cd582b35371f89$export$2e2bcd8739ae039);

var $5TDZp = parcelRequire("5TDZp");
var $a5cd582b35371f89$export$2e2bcd8739ae039 = {
    name: "Icon",
    props: {
        name: String
    },
    components: {
        Iconify: (0, $5TDZp.Icon)
    }
};

});
parcelRegister("5TDZp", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $09ef86b1407f6d61$export$f04a61298a47a40f);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
var $1iCGX = parcelRequire("1iCGX");
/**
* Expression to test part of icon name.
*
* Used when loading icons from Iconify API due to project naming convension.
* Ignored when using custom icon sets - convension does not apply.
*/ const $09ef86b1407f6d61$var$matchIconName = /^[a-z0-9]+(-[a-z0-9]+)*$/;
/**
* Convert string icon name to IconifyIconName object.
*/ const $09ef86b1407f6d61$var$stringToIcon = (value, validate, allowSimpleName, provider = "")=>{
    const colonSeparated = value.split(":");
    if (value.slice(0, 1) === "@") {
        if (colonSeparated.length < 2 || colonSeparated.length > 3) return null;
        provider = colonSeparated.shift().slice(1);
    }
    if (colonSeparated.length > 3 || !colonSeparated.length) return null;
    if (colonSeparated.length > 1) {
        const name = colonSeparated.pop();
        const prefix = colonSeparated.pop();
        const result = {
            provider: colonSeparated.length > 0 ? colonSeparated[0] : provider,
            prefix: prefix,
            name: name
        };
        return validate && !$09ef86b1407f6d61$var$validateIconName(result) ? null : result;
    }
    const name = colonSeparated[0];
    const dashSeparated = name.split("-");
    if (dashSeparated.length > 1) {
        const result = {
            provider: provider,
            prefix: dashSeparated.shift(),
            name: dashSeparated.join("-")
        };
        return validate && !$09ef86b1407f6d61$var$validateIconName(result) ? null : result;
    }
    if (allowSimpleName && provider === "") {
        const result = {
            provider: provider,
            prefix: "",
            name: name
        };
        return validate && !$09ef86b1407f6d61$var$validateIconName(result, allowSimpleName) ? null : result;
    }
    return null;
};
/**
* Check if icon is valid.
*
* This function is not part of stringToIcon because validation is not needed for most code.
*/ const $09ef86b1407f6d61$var$validateIconName = (icon, allowSimpleName)=>{
    if (!icon) return false;
    return !!((allowSimpleName && icon.prefix === "" || !!icon.prefix) && !!icon.name);
};
/**
* Resolve icon set icons
*
* Returns parent icon for each icon
*/ function $09ef86b1407f6d61$var$getIconsTree(data, names) {
    const icons = data.icons;
    const aliases = data.aliases || Object.create(null);
    const resolved = Object.create(null);
    function resolve(name) {
        if (icons[name]) return resolved[name] = [];
        if (!(name in resolved)) {
            resolved[name] = null;
            const parent = aliases[name] && aliases[name].parent;
            const value = parent && resolve(parent);
            if (value) resolved[name] = [
                parent
            ].concat(value);
        }
        return resolved[name];
    }
    Object.keys(icons).concat(Object.keys(aliases)).forEach(resolve);
    return resolved;
}
/** Default values for dimensions */ const $09ef86b1407f6d61$var$defaultIconDimensions = Object.freeze({
    left: 0,
    top: 0,
    width: 16,
    height: 16
});
/** Default values for transformations */ const $09ef86b1407f6d61$var$defaultIconTransformations = Object.freeze({
    rotate: 0,
    vFlip: false,
    hFlip: false
});
/** Default values for all optional IconifyIcon properties */ const $09ef86b1407f6d61$var$defaultIconProps = Object.freeze({
    ...$09ef86b1407f6d61$var$defaultIconDimensions,
    ...$09ef86b1407f6d61$var$defaultIconTransformations
});
/** Default values for all properties used in ExtendedIconifyIcon */ const $09ef86b1407f6d61$var$defaultExtendedIconProps = Object.freeze({
    ...$09ef86b1407f6d61$var$defaultIconProps,
    body: "",
    hidden: false
});
/**
* Merge transformations
*/ function $09ef86b1407f6d61$var$mergeIconTransformations(obj1, obj2) {
    const result = {};
    if (!obj1.hFlip !== !obj2.hFlip) result.hFlip = true;
    if (!obj1.vFlip !== !obj2.vFlip) result.vFlip = true;
    const rotate = ((obj1.rotate || 0) + (obj2.rotate || 0)) % 4;
    if (rotate) result.rotate = rotate;
    return result;
}
/**
* Merge icon and alias
*
* Can also be used to merge default values and icon
*/ function $09ef86b1407f6d61$var$mergeIconData(parent, child) {
    const result = $09ef86b1407f6d61$var$mergeIconTransformations(parent, child);
    for(const key in $09ef86b1407f6d61$var$defaultExtendedIconProps)if (key in $09ef86b1407f6d61$var$defaultIconTransformations) {
        if (key in parent && !(key in result)) result[key] = $09ef86b1407f6d61$var$defaultIconTransformations[key];
    } else if (key in child) result[key] = child[key];
    else if (key in parent) result[key] = parent[key];
    return result;
}
/**
* Get icon data, using prepared aliases tree
*/ function $09ef86b1407f6d61$var$internalGetIconData(data, name, tree) {
    const icons = data.icons;
    const aliases = data.aliases || Object.create(null);
    let currentProps = {};
    function parse(name) {
        currentProps = $09ef86b1407f6d61$var$mergeIconData(icons[name] || aliases[name], currentProps);
    }
    parse(name);
    tree.forEach(parse);
    return $09ef86b1407f6d61$var$mergeIconData(data, currentProps);
}
/**
* Extract icons from an icon set
*
* Returns list of icons that were found in icon set
*/ function $09ef86b1407f6d61$var$parseIconSet(data, callback) {
    const names = [];
    if (typeof data !== "object" || typeof data.icons !== "object") return names;
    if (data.not_found instanceof Array) data.not_found.forEach((name)=>{
        callback(name, null);
        names.push(name);
    });
    const tree = $09ef86b1407f6d61$var$getIconsTree(data);
    for(const name in tree){
        const item = tree[name];
        if (item) {
            callback(name, $09ef86b1407f6d61$var$internalGetIconData(data, name, item));
            names.push(name);
        }
    }
    return names;
}
/**
* Optional properties
*/ const $09ef86b1407f6d61$var$optionalPropertyDefaults = {
    provider: "",
    aliases: {},
    not_found: {},
    ...$09ef86b1407f6d61$var$defaultIconDimensions
};
/**
* Check props
*/ function $09ef86b1407f6d61$var$checkOptionalProps(item, defaults) {
    for(const prop in defaults)if (prop in item && typeof item[prop] !== typeof defaults[prop]) return false;
    return true;
}
/**
* Validate icon set, return it as IconifyJSON on success, null on failure
*
* Unlike validateIconSet(), this function is very basic.
* It does not throw exceptions, it does not check metadata, it does not fix stuff.
*/ function $09ef86b1407f6d61$var$quicklyValidateIconSet(obj) {
    if (typeof obj !== "object" || obj === null) return null;
    const data = obj;
    if (typeof data.prefix !== "string" || !obj.icons || typeof obj.icons !== "object") return null;
    if (!$09ef86b1407f6d61$var$checkOptionalProps(obj, $09ef86b1407f6d61$var$optionalPropertyDefaults)) return null;
    const icons = data.icons;
    for(const name in icons){
        const icon = icons[name];
        if (!name || typeof icon.body !== "string" || !$09ef86b1407f6d61$var$checkOptionalProps(icon, $09ef86b1407f6d61$var$defaultExtendedIconProps)) return null;
    }
    const aliases = data.aliases || Object.create(null);
    for(const name in aliases){
        const icon = aliases[name];
        const parent = icon.parent;
        if (!name || typeof parent !== "string" || !icons[parent] && !aliases[parent] || !$09ef86b1407f6d61$var$checkOptionalProps(icon, $09ef86b1407f6d61$var$defaultExtendedIconProps)) return null;
    }
    return data;
}
/**
* Storage by provider and prefix
*/ const $09ef86b1407f6d61$var$dataStorage = Object.create(null);
/**
* Create new storage
*/ function $09ef86b1407f6d61$var$newStorage(provider, prefix) {
    return {
        provider: provider,
        prefix: prefix,
        icons: Object.create(null),
        missing: /* @__PURE__ */ new Set()
    };
}
/**
* Get storage for provider and prefix
*/ function $09ef86b1407f6d61$var$getStorage(provider, prefix) {
    const providerStorage = $09ef86b1407f6d61$var$dataStorage[provider] || ($09ef86b1407f6d61$var$dataStorage[provider] = Object.create(null));
    return providerStorage[prefix] || (providerStorage[prefix] = $09ef86b1407f6d61$var$newStorage(provider, prefix));
}
/**
* Add icon set to storage
*
* Returns array of added icons
*/ function $09ef86b1407f6d61$var$addIconSet(storage, data) {
    if (!$09ef86b1407f6d61$var$quicklyValidateIconSet(data)) return [];
    return $09ef86b1407f6d61$var$parseIconSet(data, (name, icon)=>{
        if (icon) storage.icons[name] = icon;
        else storage.missing.add(name);
    });
}
/**
* Add icon to storage
*/ function $09ef86b1407f6d61$var$addIconToStorage(storage, name, icon) {
    try {
        if (typeof icon.body === "string") {
            storage.icons[name] = {
                ...icon
            };
            return true;
        }
    } catch (err) {}
    return false;
}
/**
* List available icons
*/ function $09ef86b1407f6d61$export$a598a3910899291f(provider, prefix) {
    let allIcons = [];
    (typeof provider === "string" ? [
        provider
    ] : Object.keys($09ef86b1407f6d61$var$dataStorage)).forEach((provider)=>{
        (typeof provider === "string" && typeof prefix === "string" ? [
            prefix
        ] : Object.keys($09ef86b1407f6d61$var$dataStorage[provider] || {})).forEach((prefix)=>{
            const storage = $09ef86b1407f6d61$var$getStorage(provider, prefix);
            allIcons = allIcons.concat(Object.keys(storage.icons).map((name)=>(provider !== "" ? "@" + provider + ":" : "") + prefix + ":" + name));
        });
    });
    return allIcons;
}
/**
* Allow storing icons without provider or prefix, making it possible to store icons like "home"
*/ let $09ef86b1407f6d61$var$simpleNames = false;
function $09ef86b1407f6d61$var$allowSimpleNames(allow) {
    if (typeof allow === "boolean") $09ef86b1407f6d61$var$simpleNames = allow;
    return $09ef86b1407f6d61$var$simpleNames;
}
/**
* Get icon data
*
* Returns:
* - IconifyIcon on success, object directly from storage so don't modify it
* - null if icon is marked as missing (returned in `not_found` property from API, so don't bother sending API requests)
* - undefined if icon is missing in storage
*/ function $09ef86b1407f6d61$var$getIconData(name) {
    const icon = typeof name === "string" ? $09ef86b1407f6d61$var$stringToIcon(name, true, $09ef86b1407f6d61$var$simpleNames) : name;
    if (icon) {
        const storage = $09ef86b1407f6d61$var$getStorage(icon.provider, icon.prefix);
        const iconName = icon.name;
        return storage.icons[iconName] || (storage.missing.has(iconName) ? null : void 0);
    }
}
/**
* Add one icon
*/ function $09ef86b1407f6d61$export$3488242433cbedb(name, data) {
    const icon = $09ef86b1407f6d61$var$stringToIcon(name, true, $09ef86b1407f6d61$var$simpleNames);
    if (!icon) return false;
    const storage = $09ef86b1407f6d61$var$getStorage(icon.provider, icon.prefix);
    if (data) return $09ef86b1407f6d61$var$addIconToStorage(storage, icon.name, data);
    else {
        storage.missing.add(icon.name);
        return true;
    }
}
/**
* Add icon set
*/ function $09ef86b1407f6d61$export$933f273b2a11730f(data, provider) {
    if (typeof data !== "object") return false;
    if (typeof provider !== "string") provider = data.provider || "";
    if ($09ef86b1407f6d61$var$simpleNames && !provider && !data.prefix) {
        let added = false;
        if ($09ef86b1407f6d61$var$quicklyValidateIconSet(data)) {
            data.prefix = "";
            $09ef86b1407f6d61$var$parseIconSet(data, (name, icon)=>{
                if ($09ef86b1407f6d61$export$3488242433cbedb(name, icon)) added = true;
            });
        }
        return added;
    }
    const prefix = data.prefix;
    if (!$09ef86b1407f6d61$var$validateIconName({
        prefix: prefix,
        name: "a"
    })) return false;
    const storage = $09ef86b1407f6d61$var$getStorage(provider, prefix);
    return !!$09ef86b1407f6d61$var$addIconSet(storage, data);
}
/**
* Check if icon data is available
*/ function $09ef86b1407f6d61$export$6728fff2d370396a(name) {
    return !!$09ef86b1407f6d61$var$getIconData(name);
}
/**
* Get full icon
*/ function $09ef86b1407f6d61$export$16b26cd5e98d9100(name) {
    const result = $09ef86b1407f6d61$var$getIconData(name);
    return result ? {
        ...$09ef86b1407f6d61$var$defaultIconProps,
        ...result
    } : result;
}
/**
* Default icon customisations values
*/ const $09ef86b1407f6d61$var$defaultIconSizeCustomisations = Object.freeze({
    width: null,
    height: null
});
const $09ef86b1407f6d61$var$defaultIconCustomisations = Object.freeze({
    ...$09ef86b1407f6d61$var$defaultIconSizeCustomisations,
    ...$09ef86b1407f6d61$var$defaultIconTransformations
});
/**
* Regular expressions for calculating dimensions
*/ const $09ef86b1407f6d61$var$unitsSplit = /(-?[0-9.]*[0-9]+[0-9.]*)/g;
const $09ef86b1407f6d61$var$unitsTest = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function $09ef86b1407f6d61$export$907c7b8171f13ef1(size, ratio, precision) {
    if (ratio === 1) return size;
    precision = precision || 100;
    if (typeof size === "number") return Math.ceil(size * ratio * precision) / precision;
    if (typeof size !== "string") return size;
    const oldParts = size.split($09ef86b1407f6d61$var$unitsSplit);
    if (oldParts === null || !oldParts.length) return size;
    const newParts = [];
    let code = oldParts.shift();
    let isNumber = $09ef86b1407f6d61$var$unitsTest.test(code);
    while(true){
        if (isNumber) {
            const num = parseFloat(code);
            if (isNaN(num)) newParts.push(code);
            else newParts.push(Math.ceil(num * ratio * precision) / precision);
        } else newParts.push(code);
        code = oldParts.shift();
        if (code === void 0) return newParts.join("");
        isNumber = !isNumber;
    }
}
function $09ef86b1407f6d61$var$splitSVGDefs(content, tag = "defs") {
    let defs = "";
    const index = content.indexOf("<" + tag);
    while(index >= 0){
        const start = content.indexOf(">", index);
        const end = content.indexOf("</" + tag);
        if (start === -1 || end === -1) break;
        const endEnd = content.indexOf(">", end);
        if (endEnd === -1) break;
        defs += content.slice(start + 1, end).trim();
        content = content.slice(0, index).trim() + content.slice(endEnd + 1);
    }
    return {
        defs: defs,
        content: content
    };
}
/**
* Merge defs and content
*/ function $09ef86b1407f6d61$var$mergeDefsAndContent(defs, content) {
    return defs ? "<defs>" + defs + "</defs>" + content : content;
}
/**
* Wrap SVG content, without wrapping definitions
*/ function $09ef86b1407f6d61$var$wrapSVGContent(body, start, end) {
    const split = $09ef86b1407f6d61$var$splitSVGDefs(body);
    return $09ef86b1407f6d61$var$mergeDefsAndContent(split.defs, start + split.content + end);
}
/**
* Check if value should be unset. Allows multiple keywords
*/ const $09ef86b1407f6d61$var$isUnsetKeyword = (value)=>value === "unset" || value === "undefined" || value === "none";
/**
* Get SVG attributes and content from icon + customisations
*
* Does not generate style to make it compatible with frameworks that use objects for style, such as React.
* Instead, it generates 'inline' value. If true, rendering engine should add verticalAlign: -0.125em to icon.
*
* Customisations should be normalised by platform specific parser.
* Result should be converted to <svg> by platform specific parser.
* Use replaceIDs to generate unique IDs for body.
*/ function $09ef86b1407f6d61$export$78c1051fc6863a0b(icon, customisations) {
    const fullIcon = {
        ...$09ef86b1407f6d61$var$defaultIconProps,
        ...icon
    };
    const fullCustomisations = {
        ...$09ef86b1407f6d61$var$defaultIconCustomisations,
        ...customisations
    };
    const box = {
        left: fullIcon.left,
        top: fullIcon.top,
        width: fullIcon.width,
        height: fullIcon.height
    };
    let body = fullIcon.body;
    [
        fullIcon,
        fullCustomisations
    ].forEach((props)=>{
        const transformations = [];
        const hFlip = props.hFlip;
        const vFlip = props.vFlip;
        let rotation = props.rotate;
        if (hFlip) {
            if (vFlip) rotation += 2;
            else {
                transformations.push("translate(" + (box.width + box.left).toString() + " " + (0 - box.top).toString() + ")");
                transformations.push("scale(-1 1)");
                box.top = box.left = 0;
            }
        } else if (vFlip) {
            transformations.push("translate(" + (0 - box.left).toString() + " " + (box.height + box.top).toString() + ")");
            transformations.push("scale(1 -1)");
            box.top = box.left = 0;
        }
        let tempValue;
        if (rotation < 0) rotation -= Math.floor(rotation / 4) * 4;
        rotation = rotation % 4;
        switch(rotation){
            case 1:
                tempValue = box.height / 2 + box.top;
                transformations.unshift("rotate(90 " + tempValue.toString() + " " + tempValue.toString() + ")");
                break;
            case 2:
                transformations.unshift("rotate(180 " + (box.width / 2 + box.left).toString() + " " + (box.height / 2 + box.top).toString() + ")");
                break;
            case 3:
                tempValue = box.width / 2 + box.left;
                transformations.unshift("rotate(-90 " + tempValue.toString() + " " + tempValue.toString() + ")");
        }
        if (rotation % 2 === 1) {
            if (box.left !== box.top) {
                tempValue = box.left;
                box.left = box.top;
                box.top = tempValue;
            }
            if (box.width !== box.height) {
                tempValue = box.width;
                box.width = box.height;
                box.height = tempValue;
            }
        }
        if (transformations.length) body = $09ef86b1407f6d61$var$wrapSVGContent(body, '<g transform="' + transformations.join(" ") + '">', "</g>");
    });
    const customisationsWidth = fullCustomisations.width;
    const customisationsHeight = fullCustomisations.height;
    const boxWidth = box.width;
    const boxHeight = box.height;
    let width;
    let height;
    if (customisationsWidth === null) {
        height = customisationsHeight === null ? "1em" : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
        width = $09ef86b1407f6d61$export$907c7b8171f13ef1(height, boxWidth / boxHeight);
    } else {
        width = customisationsWidth === "auto" ? boxWidth : customisationsWidth;
        height = customisationsHeight === null ? $09ef86b1407f6d61$export$907c7b8171f13ef1(width, boxHeight / boxWidth) : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
    }
    const attributes = {};
    const setAttr = (prop, value)=>{
        if (!$09ef86b1407f6d61$var$isUnsetKeyword(value)) attributes[prop] = value.toString();
    };
    setAttr("width", width);
    setAttr("height", height);
    const viewBox = [
        box.left,
        box.top,
        boxWidth,
        boxHeight
    ];
    attributes.viewBox = viewBox.join(" ");
    return {
        attributes: attributes,
        viewBox: viewBox,
        body: body
    };
}
/**
* Regular expression for finding ids
*/ const $09ef86b1407f6d61$var$regex = /\sid="(\S+)"/g;
/**
* Counters
*/ const $09ef86b1407f6d61$var$counters = /* @__PURE__ */ new Map();
/**
* Get unique new ID
*/ function $09ef86b1407f6d61$var$nextID(id) {
    id = id.replace(/[0-9]+$/, "") || "a";
    const count = $09ef86b1407f6d61$var$counters.get(id) || 0;
    $09ef86b1407f6d61$var$counters.set(id, count + 1);
    return count ? `${id}${count}` : id;
}
/**
* Replace IDs in SVG output with unique IDs
*/ function $09ef86b1407f6d61$export$cae0fa3719aa5dc4(body) {
    const ids = [];
    let match;
    while(match = $09ef86b1407f6d61$var$regex.exec(body))ids.push(match[1]);
    if (!ids.length) return body;
    const suffix = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
    ids.forEach((id)=>{
        const newID = $09ef86b1407f6d61$var$nextID(id);
        const escapedID = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        body = body.replace(new RegExp('([#;"])(' + escapedID + ')([")]|\\.[a-z])', "g"), "$1" + newID + suffix + "$3");
    });
    body = body.replace(new RegExp(suffix, "g"), "");
    return body;
}
/**
* Clear ID cache
*/ function $09ef86b1407f6d61$export$87a05ef68280bfbe() {
    $09ef86b1407f6d61$var$counters.clear();
}
/**
* Local storate types and entries
*/ const $09ef86b1407f6d61$var$storage = Object.create(null);
/**
* Set API module
*/ function $09ef86b1407f6d61$var$setAPIModule(provider, item) {
    $09ef86b1407f6d61$var$storage[provider] = item;
}
/**
* Get API module
*/ function $09ef86b1407f6d61$var$getAPIModule(provider) {
    return $09ef86b1407f6d61$var$storage[provider] || $09ef86b1407f6d61$var$storage[""];
}
/**
* Create full API configuration from partial data
*/ function $09ef86b1407f6d61$var$createAPIConfig(source) {
    let resources;
    if (typeof source.resources === "string") resources = [
        source.resources
    ];
    else {
        resources = source.resources;
        if (!(resources instanceof Array) || !resources.length) return null;
    }
    return {
        resources: resources,
        path: source.path || "/",
        maxURL: source.maxURL || 500,
        rotate: source.rotate || 750,
        timeout: source.timeout || 5e3,
        random: source.random === true,
        index: source.index || 0,
        dataAfterTimeout: source.dataAfterTimeout !== false
    };
}
/**
* Local storage
*/ const $09ef86b1407f6d61$var$configStorage = Object.create(null);
$09ef86b1407f6d61$var$configStorage[""] = $09ef86b1407f6d61$var$createAPIConfig({
    resources: [
        "https://api.iconify.design"
    ]
});
/**
* Add custom config for provider
*/ function $09ef86b1407f6d61$export$ddfda4eca64d59f6(provider, customConfig) {
    const config = $09ef86b1407f6d61$var$createAPIConfig(customConfig);
    if (config === null) return false;
    $09ef86b1407f6d61$var$configStorage[provider] = config;
    return true;
}
/**
* Get API configuration
*/ function $09ef86b1407f6d61$var$getAPIConfig(provider) {
    return $09ef86b1407f6d61$var$configStorage[provider];
}
/**
* List API providers
*/ function $09ef86b1407f6d61$var$listAPIProviders() {
    return Object.keys($09ef86b1407f6d61$var$configStorage);
}
const $09ef86b1407f6d61$var$detectFetch = ()=>{
    let callback;
    try {
        callback = fetch;
        if (typeof callback === "function") return callback;
    } catch (err) {}
};
/**
* Fetch function
*/ let $09ef86b1407f6d61$var$fetchModule = $09ef86b1407f6d61$var$detectFetch();
/**
* Set custom fetch() function
*/ function $09ef86b1407f6d61$var$setFetch(fetch1) {
    $09ef86b1407f6d61$var$fetchModule = fetch1;
}
/**
* Get fetch() function. Used by Icon Finder Core
*/ function $09ef86b1407f6d61$var$getFetch() {
    return $09ef86b1407f6d61$var$fetchModule;
}
/**
* Calculate maximum icons list length for prefix
*/ function $09ef86b1407f6d61$var$calculateMaxLength(provider, prefix) {
    const config = $09ef86b1407f6d61$var$getAPIConfig(provider);
    if (!config) return 0;
    let result;
    if (!config.maxURL) result = 0;
    else {
        let maxHostLength = 0;
        config.resources.forEach((item)=>{
            maxHostLength = Math.max(maxHostLength, item.length);
        });
        const url = prefix + ".json?icons=";
        result = config.maxURL - maxHostLength - config.path.length - url.length;
    }
    return result;
}
/**
* Should query be aborted, based on last HTTP status
*/ function $09ef86b1407f6d61$var$shouldAbort(status) {
    return status === 404;
}
/**
* Prepare params
*/ const $09ef86b1407f6d61$var$prepare = (provider, prefix, icons)=>{
    const results = [];
    const maxLength = $09ef86b1407f6d61$var$calculateMaxLength(provider, prefix);
    const type = "icons";
    let item = {
        type: type,
        provider: provider,
        prefix: prefix,
        icons: []
    };
    let length = 0;
    icons.forEach((name, index)=>{
        length += name.length + 1;
        if (length >= maxLength && index > 0) {
            results.push(item);
            item = {
                type: type,
                provider: provider,
                prefix: prefix,
                icons: []
            };
            length = name.length;
        }
        item.icons.push(name);
    });
    results.push(item);
    return results;
};
/**
* Get path
*/ function $09ef86b1407f6d61$var$getPath(provider) {
    if (typeof provider === "string") {
        const config = $09ef86b1407f6d61$var$getAPIConfig(provider);
        if (config) return config.path;
    }
    return "/";
}
/**
* Load icons
*/ const $09ef86b1407f6d61$var$send = (host, params, callback)=>{
    if (!$09ef86b1407f6d61$var$fetchModule) {
        callback("abort", 424);
        return;
    }
    let path = $09ef86b1407f6d61$var$getPath(params.provider);
    switch(params.type){
        case "icons":
            {
                const prefix = params.prefix;
                const iconsList = params.icons.join(",");
                const urlParams = new URLSearchParams({
                    icons: iconsList
                });
                path += prefix + ".json?" + urlParams.toString();
                break;
            }
        case "custom":
            {
                const uri = params.uri;
                path += uri.slice(0, 1) === "/" ? uri.slice(1) : uri;
                break;
            }
        default:
            callback("abort", 400);
            return;
    }
    let defaultError = 503;
    $09ef86b1407f6d61$var$fetchModule(host + path).then((response)=>{
        const status = response.status;
        if (status !== 200) {
            setTimeout(()=>{
                callback($09ef86b1407f6d61$var$shouldAbort(status) ? "abort" : "next", status);
            });
            return;
        }
        defaultError = 501;
        return response.json();
    }).then((data)=>{
        if (typeof data !== "object" || data === null) {
            setTimeout(()=>{
                if (data === 404) callback("abort", data);
                else callback("next", defaultError);
            });
            return;
        }
        setTimeout(()=>{
            callback("success", data);
        });
    }).catch(()=>{
        callback("next", defaultError);
    });
};
/**
* Export module
*/ const $09ef86b1407f6d61$var$fetchAPIModule = {
    prepare: $09ef86b1407f6d61$var$prepare,
    send: $09ef86b1407f6d61$var$send
};
/**
* Remove callback
*/ function $09ef86b1407f6d61$var$removeCallback(storages, id) {
    storages.forEach((storage)=>{
        const items = storage.loaderCallbacks;
        if (items) storage.loaderCallbacks = items.filter((row)=>row.id !== id);
    });
}
/**
* Update all callbacks for provider and prefix
*/ function $09ef86b1407f6d61$var$updateCallbacks(storage) {
    if (!storage.pendingCallbacksFlag) {
        storage.pendingCallbacksFlag = true;
        setTimeout(()=>{
            storage.pendingCallbacksFlag = false;
            const items = storage.loaderCallbacks ? storage.loaderCallbacks.slice(0) : [];
            if (!items.length) return;
            let hasPending = false;
            const provider = storage.provider;
            const prefix = storage.prefix;
            items.forEach((item)=>{
                const icons = item.icons;
                const oldLength = icons.pending.length;
                icons.pending = icons.pending.filter((icon)=>{
                    if (icon.prefix !== prefix) return true;
                    const name = icon.name;
                    if (storage.icons[name]) icons.loaded.push({
                        provider: provider,
                        prefix: prefix,
                        name: name
                    });
                    else if (storage.missing.has(name)) icons.missing.push({
                        provider: provider,
                        prefix: prefix,
                        name: name
                    });
                    else {
                        hasPending = true;
                        return true;
                    }
                    return false;
                });
                if (icons.pending.length !== oldLength) {
                    if (!hasPending) $09ef86b1407f6d61$var$removeCallback([
                        storage
                    ], item.id);
                    item.callback(icons.loaded.slice(0), icons.missing.slice(0), icons.pending.slice(0), item.abort);
                }
            });
        });
    }
}
/**
* Unique id counter for callbacks
*/ let $09ef86b1407f6d61$var$idCounter = 0;
/**
* Add callback
*/ function $09ef86b1407f6d61$var$storeCallback(callback, icons, pendingSources) {
    const id = $09ef86b1407f6d61$var$idCounter++;
    const abort = $09ef86b1407f6d61$var$removeCallback.bind(null, pendingSources, id);
    if (!icons.pending.length) return abort;
    const item = {
        id: id,
        icons: icons,
        callback: callback,
        abort: abort
    };
    pendingSources.forEach((storage)=>{
        (storage.loaderCallbacks || (storage.loaderCallbacks = [])).push(item);
    });
    return abort;
}
/**
* Check if icons have been loaded
*/ function $09ef86b1407f6d61$var$sortIcons(icons) {
    const result = {
        loaded: [],
        missing: [],
        pending: []
    };
    const storage = Object.create(null);
    icons.sort((a, b)=>{
        if (a.provider !== b.provider) return a.provider.localeCompare(b.provider);
        if (a.prefix !== b.prefix) return a.prefix.localeCompare(b.prefix);
        return a.name.localeCompare(b.name);
    });
    let lastIcon = {
        provider: "",
        prefix: "",
        name: ""
    };
    icons.forEach((icon)=>{
        if (lastIcon.name === icon.name && lastIcon.prefix === icon.prefix && lastIcon.provider === icon.provider) return;
        lastIcon = icon;
        const provider = icon.provider;
        const prefix = icon.prefix;
        const name = icon.name;
        const providerStorage = storage[provider] || (storage[provider] = Object.create(null));
        const localStorage = providerStorage[prefix] || (providerStorage[prefix] = $09ef86b1407f6d61$var$getStorage(provider, prefix));
        let list;
        if (name in localStorage.icons) list = result.loaded;
        else if (prefix === "" || localStorage.missing.has(name)) list = result.missing;
        else list = result.pending;
        const item = {
            provider: provider,
            prefix: prefix,
            name: name
        };
        list.push(item);
    });
    return result;
}
/**
* Convert icons list from string/icon mix to icons and validate them
*/ function $09ef86b1407f6d61$var$listToIcons(list, validate = true, simpleNames = false) {
    const result = [];
    list.forEach((item)=>{
        const icon = typeof item === "string" ? $09ef86b1407f6d61$var$stringToIcon(item, validate, simpleNames) : item;
        if (icon) result.push(icon);
    });
    return result;
}
/**
* Default RedundancyConfig for API calls
*/ const $09ef86b1407f6d61$var$defaultConfig = {
    resources: [],
    index: 0,
    timeout: 2e3,
    rotate: 750,
    random: false,
    dataAfterTimeout: false
};
/**
* Send query
*/ function $09ef86b1407f6d61$var$sendQuery(config, payload, query, done) {
    const resourcesCount = config.resources.length;
    const startIndex = config.random ? Math.floor(Math.random() * resourcesCount) : config.index;
    let resources;
    if (config.random) {
        let list = config.resources.slice(0);
        resources = [];
        while(list.length > 1){
            const nextIndex = Math.floor(Math.random() * list.length);
            resources.push(list[nextIndex]);
            list = list.slice(0, nextIndex).concat(list.slice(nextIndex + 1));
        }
        resources = resources.concat(list);
    } else resources = config.resources.slice(startIndex).concat(config.resources.slice(0, startIndex));
    const startTime = Date.now();
    let status = "pending";
    let queriesSent = 0;
    let lastError;
    let timer = null;
    let queue = [];
    let doneCallbacks = [];
    if (typeof done === "function") doneCallbacks.push(done);
    /**
	* Reset timer
	*/ function resetTimer() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    /**
	* Abort everything
	*/ function abort() {
        if (status === "pending") status = "aborted";
        resetTimer();
        queue.forEach((item)=>{
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    /**
	* Add / replace callback to call when execution is complete.
	* This can be used to abort pending query implementations when query is complete or aborted.
	*/ function subscribe(callback, overwrite) {
        if (overwrite) doneCallbacks = [];
        if (typeof callback === "function") doneCallbacks.push(callback);
    }
    /**
	* Get query status
	*/ function getQueryStatus() {
        return {
            startTime: startTime,
            payload: payload,
            status: status,
            queriesSent: queriesSent,
            queriesPending: queue.length,
            subscribe: subscribe,
            abort: abort
        };
    }
    /**
	* Fail query
	*/ function failQuery() {
        status = "failed";
        doneCallbacks.forEach((callback)=>{
            callback(void 0, lastError);
        });
    }
    /**
	* Clear queue
	*/ function clearQueue() {
        queue.forEach((item)=>{
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    /**
	* Got response from module
	*/ function moduleResponse(item, response, data) {
        const isError = response !== "success";
        queue = queue.filter((queued)=>queued !== item);
        switch(status){
            case "pending":
                break;
            case "failed":
                if (isError || !config.dataAfterTimeout) return;
                break;
            default:
                return;
        }
        if (response === "abort") {
            lastError = data;
            failQuery();
            return;
        }
        if (isError) {
            lastError = data;
            if (!queue.length) {
                if (!resources.length) failQuery();
                else execNext();
            }
            return;
        }
        resetTimer();
        clearQueue();
        if (!config.random) {
            const index = config.resources.indexOf(item.resource);
            if (index !== -1 && index !== config.index) config.index = index;
        }
        status = "completed";
        doneCallbacks.forEach((callback)=>{
            callback(data);
        });
    }
    /**
	* Execute next query
	*/ function execNext() {
        if (status !== "pending") return;
        resetTimer();
        const resource = resources.shift();
        if (resource === void 0) {
            if (queue.length) {
                timer = setTimeout(()=>{
                    resetTimer();
                    if (status === "pending") {
                        clearQueue();
                        failQuery();
                    }
                }, config.timeout);
                return;
            }
            failQuery();
            return;
        }
        const item = {
            status: "pending",
            resource: resource,
            callback: (status, data)=>{
                moduleResponse(item, status, data);
            }
        };
        queue.push(item);
        queriesSent++;
        timer = setTimeout(execNext, config.rotate);
        query(resource, payload, item.callback);
    }
    setTimeout(execNext);
    return getQueryStatus;
}
/**
* Redundancy instance
*/ function $09ef86b1407f6d61$var$initRedundancy(cfg) {
    const config = {
        ...$09ef86b1407f6d61$var$defaultConfig,
        ...cfg
    };
    let queries = [];
    /**
	* Remove aborted and completed queries
	*/ function cleanup() {
        queries = queries.filter((item)=>item().status === "pending");
    }
    /**
	* Send query
	*/ function query(payload, queryCallback, doneCallback) {
        const query = $09ef86b1407f6d61$var$sendQuery(config, payload, queryCallback, (data, error)=>{
            cleanup();
            if (doneCallback) doneCallback(data, error);
        });
        queries.push(query);
        return query;
    }
    /**
	* Find instance
	*/ function find(callback) {
        return queries.find((value)=>{
            return callback(value);
        }) || null;
    }
    return {
        query: query,
        find: find,
        setIndex: (index)=>{
            config.index = index;
        },
        getIndex: ()=>config.index,
        cleanup: cleanup
    };
}
function $09ef86b1407f6d61$var$emptyCallback$1() {}
const $09ef86b1407f6d61$var$redundancyCache = Object.create(null);
/**
* Get Redundancy instance for provider
*/ function $09ef86b1407f6d61$var$getRedundancyCache(provider) {
    if (!$09ef86b1407f6d61$var$redundancyCache[provider]) {
        const config = $09ef86b1407f6d61$var$getAPIConfig(provider);
        if (!config) return;
        const cachedReundancy = {
            config: config,
            redundancy: $09ef86b1407f6d61$var$initRedundancy(config)
        };
        $09ef86b1407f6d61$var$redundancyCache[provider] = cachedReundancy;
    }
    return $09ef86b1407f6d61$var$redundancyCache[provider];
}
/**
* Send API query
*/ function $09ef86b1407f6d61$var$sendAPIQuery(target, query, callback) {
    let redundancy;
    let send;
    if (typeof target === "string") {
        const api = $09ef86b1407f6d61$var$getAPIModule(target);
        if (!api) {
            callback(void 0, 424);
            return $09ef86b1407f6d61$var$emptyCallback$1;
        }
        send = api.send;
        const cached = $09ef86b1407f6d61$var$getRedundancyCache(target);
        if (cached) redundancy = cached.redundancy;
    } else {
        const config = $09ef86b1407f6d61$var$createAPIConfig(target);
        if (config) {
            redundancy = $09ef86b1407f6d61$var$initRedundancy(config);
            const moduleKey = target.resources ? target.resources[0] : "";
            const api = $09ef86b1407f6d61$var$getAPIModule(moduleKey);
            if (api) send = api.send;
        }
    }
    if (!redundancy || !send) {
        callback(void 0, 424);
        return $09ef86b1407f6d61$var$emptyCallback$1;
    }
    return redundancy.query(query, send, callback)().abort;
}
function $09ef86b1407f6d61$var$emptyCallback() {}
/**
* Function called when new icons have been loaded
*/ function $09ef86b1407f6d61$var$loadedNewIcons(storage) {
    if (!storage.iconsLoaderFlag) {
        storage.iconsLoaderFlag = true;
        setTimeout(()=>{
            storage.iconsLoaderFlag = false;
            $09ef86b1407f6d61$var$updateCallbacks(storage);
        });
    }
}
/**
* Check icon names for API
*/ function $09ef86b1407f6d61$var$checkIconNamesForAPI(icons) {
    const valid = [];
    const invalid = [];
    icons.forEach((name)=>{
        (name.match($09ef86b1407f6d61$var$matchIconName) ? valid : invalid).push(name);
    });
    return {
        valid: valid,
        invalid: invalid
    };
}
/**
* Parse loader response
*/ function $09ef86b1407f6d61$var$parseLoaderResponse(storage, icons, data) {
    function checkMissing() {
        const pending = storage.pendingIcons;
        icons.forEach((name)=>{
            if (pending) pending.delete(name);
            if (!storage.icons[name]) storage.missing.add(name);
        });
    }
    if (data && typeof data === "object") try {
        if (!$09ef86b1407f6d61$var$addIconSet(storage, data).length) {
            checkMissing();
            return;
        }
    } catch (err) {
        console.error(err);
    }
    checkMissing();
    $09ef86b1407f6d61$var$loadedNewIcons(storage);
}
/**
* Handle response that can be async
*/ function $09ef86b1407f6d61$var$parsePossiblyAsyncResponse(response, callback) {
    if (response instanceof Promise) response.then((data)=>{
        callback(data);
    }).catch(()=>{
        callback(null);
    });
    else callback(response);
}
/**
* Load icons
*/ function $09ef86b1407f6d61$var$loadNewIcons(storage, icons) {
    if (!storage.iconsToLoad) storage.iconsToLoad = icons;
    else storage.iconsToLoad = storage.iconsToLoad.concat(icons).sort();
    if (!storage.iconsQueueFlag) {
        storage.iconsQueueFlag = true;
        setTimeout(()=>{
            storage.iconsQueueFlag = false;
            const { provider: provider, prefix: prefix } = storage;
            const icons = storage.iconsToLoad;
            delete storage.iconsToLoad;
            if (!icons || !icons.length) return;
            const customIconLoader = storage.loadIcon;
            if (storage.loadIcons && (icons.length > 1 || !customIconLoader)) {
                $09ef86b1407f6d61$var$parsePossiblyAsyncResponse(storage.loadIcons(icons, prefix, provider), (data)=>{
                    $09ef86b1407f6d61$var$parseLoaderResponse(storage, icons, data);
                });
                return;
            }
            if (customIconLoader) {
                icons.forEach((name)=>{
                    $09ef86b1407f6d61$var$parsePossiblyAsyncResponse(customIconLoader(name, prefix, provider), (data)=>{
                        $09ef86b1407f6d61$var$parseLoaderResponse(storage, [
                            name
                        ], data ? {
                            prefix: prefix,
                            icons: {
                                [name]: data
                            }
                        } : null);
                    });
                });
                return;
            }
            const { valid: valid, invalid: invalid } = $09ef86b1407f6d61$var$checkIconNamesForAPI(icons);
            if (invalid.length) $09ef86b1407f6d61$var$parseLoaderResponse(storage, invalid, null);
            if (!valid.length) return;
            const api = prefix.match($09ef86b1407f6d61$var$matchIconName) ? $09ef86b1407f6d61$var$getAPIModule(provider) : null;
            if (!api) {
                $09ef86b1407f6d61$var$parseLoaderResponse(storage, valid, null);
                return;
            }
            api.prepare(provider, prefix, valid).forEach((item)=>{
                $09ef86b1407f6d61$var$sendAPIQuery(provider, item, (data)=>{
                    $09ef86b1407f6d61$var$parseLoaderResponse(storage, item.icons, data);
                });
            });
        });
    }
}
/**
* Load icons
*/ const $09ef86b1407f6d61$export$2527eb85cb3fa9f = (icons, callback)=>{
    const cleanedIcons = $09ef86b1407f6d61$var$listToIcons(icons, true, $09ef86b1407f6d61$var$allowSimpleNames());
    const sortedIcons = $09ef86b1407f6d61$var$sortIcons(cleanedIcons);
    if (!sortedIcons.pending.length) {
        let callCallback = true;
        if (callback) setTimeout(()=>{
            if (callCallback) callback(sortedIcons.loaded, sortedIcons.missing, sortedIcons.pending, $09ef86b1407f6d61$var$emptyCallback);
        });
        return ()=>{
            callCallback = false;
        };
    }
    const newIcons = Object.create(null);
    const sources = [];
    let lastProvider, lastPrefix;
    sortedIcons.pending.forEach((icon)=>{
        const { provider: provider, prefix: prefix } = icon;
        if (prefix === lastPrefix && provider === lastProvider) return;
        lastProvider = provider;
        lastPrefix = prefix;
        sources.push($09ef86b1407f6d61$var$getStorage(provider, prefix));
        const providerNewIcons = newIcons[provider] || (newIcons[provider] = Object.create(null));
        if (!providerNewIcons[prefix]) providerNewIcons[prefix] = [];
    });
    sortedIcons.pending.forEach((icon)=>{
        const { provider: provider, prefix: prefix, name: name } = icon;
        const storage = $09ef86b1407f6d61$var$getStorage(provider, prefix);
        const pendingQueue = storage.pendingIcons || (storage.pendingIcons = /* @__PURE__ */ new Set());
        if (!pendingQueue.has(name)) {
            pendingQueue.add(name);
            newIcons[provider][prefix].push(name);
        }
    });
    sources.forEach((storage)=>{
        const list = newIcons[storage.provider][storage.prefix];
        if (list.length) $09ef86b1407f6d61$var$loadNewIcons(storage, list);
    });
    return callback ? $09ef86b1407f6d61$var$storeCallback(callback, sortedIcons, sources) : $09ef86b1407f6d61$var$emptyCallback;
};
/**
* Load one icon using Promise
*/ const $09ef86b1407f6d61$export$8e757e0542ac47f6 = (icon)=>{
    return new Promise((fulfill, reject)=>{
        const iconObj = typeof icon === "string" ? $09ef86b1407f6d61$var$stringToIcon(icon, true) : icon;
        if (!iconObj) {
            reject(icon);
            return;
        }
        $09ef86b1407f6d61$export$2527eb85cb3fa9f([
            iconObj || icon
        ], (loaded)=>{
            if (loaded.length && iconObj) {
                const data = $09ef86b1407f6d61$var$getIconData(iconObj);
                if (data) {
                    fulfill({
                        ...$09ef86b1407f6d61$var$defaultIconProps,
                        ...data
                    });
                    return;
                }
            }
            reject(icon);
        });
    });
};
/**
* Set custom loader for multiple icons
*/ function $09ef86b1407f6d61$export$e4c6e88f1f5eeacc(loader, prefix, provider) {
    $09ef86b1407f6d61$var$getStorage(provider || "", prefix).loadIcons = loader;
}
/**
* Set custom loader for one icon
*/ function $09ef86b1407f6d61$export$605d11454a711a89(loader, prefix, provider) {
    $09ef86b1407f6d61$var$getStorage(provider || "", prefix).loadIcon = loader;
}
/**
* Convert IconifyIconCustomisations to FullIconCustomisations, checking value types
*/ function $09ef86b1407f6d61$var$mergeCustomisations(defaults, item) {
    const result = {
        ...defaults
    };
    for(const key in item){
        const value = item[key];
        const valueType = typeof value;
        if (key in $09ef86b1407f6d61$var$defaultIconSizeCustomisations) {
            if (value === null || value && (valueType === "string" || valueType === "number")) result[key] = value;
        } else if (valueType === typeof result[key]) result[key] = key === "rotate" ? value % 4 : value;
    }
    return result;
}
const $09ef86b1407f6d61$var$separator = /[\s,]+/;
/**
* Apply "flip" string to icon customisations
*/ function $09ef86b1407f6d61$var$flipFromString(custom, flip) {
    flip.split($09ef86b1407f6d61$var$separator).forEach((str)=>{
        switch(str.trim()){
            case "horizontal":
                custom.hFlip = true;
                break;
            case "vertical":
                custom.vFlip = true;
        }
    });
}
/**
* Get rotation value
*/ function $09ef86b1407f6d61$var$rotateFromString(value, defaultValue = 0) {
    const units = value.replace(/^-?[0-9.]*/, "");
    function cleanup(value) {
        while(value < 0)value += 4;
        return value % 4;
    }
    if (units === "") {
        const num = parseInt(value);
        return isNaN(num) ? 0 : cleanup(num);
    } else if (units !== value) {
        let split = 0;
        switch(units){
            case "%":
                split = 25;
                break;
            case "deg":
                split = 90;
        }
        if (split) {
            let num = parseFloat(value.slice(0, value.length - units.length));
            if (isNaN(num)) return 0;
            num = num / split;
            return num % 1 === 0 ? cleanup(num) : 0;
        }
    }
    return defaultValue;
}
/**
* Generate <svg>
*/ function $09ef86b1407f6d61$var$iconToHTML(body, attributes) {
    let renderAttribsHTML = body.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
    for(const attr in attributes)renderAttribsHTML += " " + attr + '="' + attributes[attr] + '"';
    return '<svg xmlns="http://www.w3.org/2000/svg"' + renderAttribsHTML + ">" + body + "</svg>";
}
/**
* Encode SVG for use in url()
*
* Short alternative to encodeURIComponent() that encodes only stuff used in SVG, generating
* smaller code.
*/ function $09ef86b1407f6d61$var$encodeSVGforURL(svg) {
    return svg.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ").replace(/:/g, "%3A").replace(/\//g, "%2F");
}
/**
* Generate data: URL from SVG
*/ function $09ef86b1407f6d61$var$svgToData(svg) {
    return "data:image/svg+xml," + $09ef86b1407f6d61$var$encodeSVGforURL(svg);
}
/**
* Generate url() from SVG
*/ function $09ef86b1407f6d61$var$svgToURL(svg) {
    return 'url("' + $09ef86b1407f6d61$var$svgToData(svg) + '")';
}
const $09ef86b1407f6d61$var$defaultExtendedIconCustomisations = {
    ...$09ef86b1407f6d61$var$defaultIconCustomisations,
    inline: false
};
/* eslint-disable @typescript-eslint/no-unused-vars */ /**
 * Default SVG attributes
 */ const $09ef86b1407f6d61$var$svgDefaults = {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": true,
    "role": "img"
};
/**
 * Style modes
 */ const $09ef86b1407f6d61$var$commonProps = {
    display: "inline-block"
};
const $09ef86b1407f6d61$var$monotoneProps = {
    backgroundColor: "currentColor"
};
const $09ef86b1407f6d61$var$coloredProps = {
    backgroundColor: "transparent"
};
// Dynamically add common props to variables above
const $09ef86b1407f6d61$var$propsToAdd = {
    Image: "var(--svg)",
    Repeat: "no-repeat",
    Size: "100% 100%"
};
const $09ef86b1407f6d61$var$propsToAddTo = {
    webkitMask: $09ef86b1407f6d61$var$monotoneProps,
    mask: $09ef86b1407f6d61$var$monotoneProps,
    background: $09ef86b1407f6d61$var$coloredProps
};
for(const prefix in $09ef86b1407f6d61$var$propsToAddTo){
    const list = $09ef86b1407f6d61$var$propsToAddTo[prefix];
    for(const prop in $09ef86b1407f6d61$var$propsToAdd)list[prefix + prop] = $09ef86b1407f6d61$var$propsToAdd[prop];
}
/**
 * Aliases for customisations.
 * In Vue 'v-' properties are reserved, so v-flip must be renamed
 */ const $09ef86b1407f6d61$var$customisationAliases = {};
[
    "horizontal",
    "vertical"
].forEach((prefix)=>{
    const attr = prefix.slice(0, 1) + "Flip";
    // vertical-flip
    $09ef86b1407f6d61$var$customisationAliases[prefix + "-flip"] = attr;
    // v-flip
    $09ef86b1407f6d61$var$customisationAliases[prefix.slice(0, 1) + "-flip"] = attr;
    // verticalFlip
    $09ef86b1407f6d61$var$customisationAliases[prefix + "Flip"] = attr;
});
/**
 * Fix size: add 'px' to numbers
 */ function $09ef86b1407f6d61$var$fixSize(value) {
    return value + (value.match(/^[-0-9.]+$/) ? "px" : "");
}
/**
 * Render icon
 */ const $09ef86b1407f6d61$var$render = (// Icon must be validated before calling this function
icon, // Partial properties
props)=>{
    // Split properties
    const customisations = $09ef86b1407f6d61$var$mergeCustomisations($09ef86b1407f6d61$var$defaultExtendedIconCustomisations, props);
    const componentProps = {
        ...$09ef86b1407f6d61$var$svgDefaults
    };
    // Check mode
    const mode = props.mode || "svg";
    // Copy style
    const style = {};
    const propsStyle = props.style;
    const customStyle = typeof propsStyle === "object" && !(propsStyle instanceof Array) ? propsStyle : {};
    // Get element properties
    for(let key in props){
        const value = props[key];
        if (value === void 0) continue;
        switch(key){
            // Properties to ignore
            case "icon":
            case "style":
            case "onLoad":
            case "mode":
            case "ssr":
            case "customise":
                break;
            // Boolean attributes
            case "inline":
            case "hFlip":
            case "vFlip":
                customisations[key] = value === true || value === "true" || value === 1;
                break;
            // Flip as string: 'horizontal,vertical'
            // Handled after this loop, see below.
            case "flip":
                break;
            // Color: override style
            case "color":
                style.color = value;
                break;
            // Rotation as string
            case "rotate":
                if (typeof value === "string") customisations[key] = $09ef86b1407f6d61$var$rotateFromString(value);
                else if (typeof value === "number") customisations[key] = value;
                break;
            // Remove aria-hidden
            case "ariaHidden":
            case "aria-hidden":
                // Vue transforms 'aria-hidden' property to 'ariaHidden'
                if (value !== true && value !== "true") delete componentProps["aria-hidden"];
                break;
            default:
                {
                    const alias = $09ef86b1407f6d61$var$customisationAliases[key];
                    if (alias) // Aliases for boolean customisations
                    {
                        if (value === true || value === "true" || value === 1) customisations[alias] = true;
                    } else if ($09ef86b1407f6d61$var$defaultExtendedIconCustomisations[key] === void 0) // Copy missing property if it does not exist in customisations
                    componentProps[key] = value;
                }
        }
    }
    // Apply flip shorthand ('horizontal,vertical') after all conflicting 
    // explicit hFlip/vFlip props are processed.
    // It only sets hFlip/vFlip to `true`, never `false`.
    if (typeof props.flip === "string") $09ef86b1407f6d61$var$flipFromString(customisations, props.flip);
    // Generate icon
    const item = $09ef86b1407f6d61$export$78c1051fc6863a0b(icon, customisations);
    const renderAttribs = item.attributes;
    // Inline display
    if (customisations.inline) style.verticalAlign = "-0.125em";
    if (mode === "svg") {
        // Add style
        componentProps.style = {
            ...style,
            ...customStyle
        };
        // Add icon stuff
        Object.assign(componentProps, renderAttribs);
        // Add innerHTML and style to props
        componentProps["innerHTML"] = $09ef86b1407f6d61$export$cae0fa3719aa5dc4(item.body);
        // Render icon
        return (0, $1vQIy.h)("svg", componentProps);
    }
    // Render <span> with style
    const { body: body, width: width, height: height } = icon;
    const useMask = mode === "mask" || (mode === "bg" ? false : body.indexOf("currentColor") !== -1);
    // Generate SVG
    const html = $09ef86b1407f6d61$var$iconToHTML(body, {
        ...renderAttribs,
        width: width + "",
        height: height + ""
    });
    // Generate style
    componentProps.style = {
        ...style,
        "--svg": $09ef86b1407f6d61$var$svgToURL(html),
        "width": $09ef86b1407f6d61$var$fixSize(renderAttribs.width),
        "height": $09ef86b1407f6d61$var$fixSize(renderAttribs.height),
        ...$09ef86b1407f6d61$var$commonProps,
        ...useMask ? $09ef86b1407f6d61$var$monotoneProps : $09ef86b1407f6d61$var$coloredProps,
        ...customStyle
    };
    return (0, $1vQIy.h)("span", componentProps);
};
/**
 * Initialise stuff
 */ // Enable short names
$09ef86b1407f6d61$var$allowSimpleNames(true);
// Set API module
$09ef86b1407f6d61$var$setAPIModule("", $09ef86b1407f6d61$var$fetchAPIModule);
/**
 * Browser stuff
 */ if (typeof document !== "undefined" && typeof window !== "undefined") {
    const _window = window;
    // Load icons from global "IconifyPreload"
    if (_window.IconifyPreload !== void 0) {
        const preload = _window.IconifyPreload;
        const err = "Invalid IconifyPreload syntax.";
        if (typeof preload === "object" && preload !== null) (preload instanceof Array ? preload : [
            preload
        ]).forEach((item)=>{
            try {
                if (// Check if item is an object and not null/array
                typeof item !== "object" || item === null || item instanceof Array || // Check for 'icons' and 'prefix'
                typeof item.icons !== "object" || typeof item.prefix !== "string" || // Add icon set
                !$09ef86b1407f6d61$export$933f273b2a11730f(item)) console.error(err);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (e) {
                console.error(err);
            }
        });
    }
    // Set API from global "IconifyProviders"
    if (_window.IconifyProviders !== void 0) {
        const providers = _window.IconifyProviders;
        if (typeof providers === "object" && providers !== null) for(let key in providers){
            const err = "IconifyProviders[" + key + "] is invalid.";
            try {
                const value = providers[key];
                if (typeof value !== "object" || !value || value.resources === void 0) continue;
                if (!$09ef86b1407f6d61$export$ddfda4eca64d59f6(key, value)) console.error(err);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (e) {
                console.error(err);
            }
        }
    }
}
/**
 * Empty icon data, rendered when icon is not available
 */ const $09ef86b1407f6d61$var$emptyIcon = {
    ...$09ef86b1407f6d61$var$defaultIconProps,
    body: ""
};
/**
 * Component
 */ const $09ef86b1407f6d61$export$f04a61298a47a40f = (0, $1vQIy.defineComponent)((props, { emit: emit })=>{
    const loader = (0, $1iCGX.ref)(null);
    function abortLoading() {
        if (loader.value) {
            loader.value.abort?.();
            loader.value = null;
        }
    }
    // Render state
    const rendering = (0, $1iCGX.ref)(!!props.ssr);
    const lastRenderedIconName = (0, $1iCGX.ref)("");
    const iconData = (0, $1iCGX.shallowRef)(null);
    // Update icon data
    function getIcon() {
        const icon = props.icon;
        // Icon is an object
        if (typeof icon === "object" && icon !== null && typeof icon.body === "string") {
            lastRenderedIconName.value = "";
            return {
                data: icon
            };
        }
        // Check for valid icon name
        let iconName;
        if (typeof icon !== "string" || (iconName = $09ef86b1407f6d61$var$stringToIcon(icon, false, true)) === null) return null;
        // Load icon
        let data = $09ef86b1407f6d61$var$getIconData(iconName);
        if (!data) {
            // Icon data is not available
            const oldState = loader.value;
            if (!oldState || oldState.name !== icon) {
                // Icon name does not match old loader state
                if (data === null) // Failed to load
                loader.value = {
                    name: icon
                };
                else loader.value = {
                    name: icon,
                    abort: $09ef86b1407f6d61$export$2527eb85cb3fa9f([
                        iconName
                    ], updateIconData)
                };
            }
            return null;
        }
        // Icon data is available
        abortLoading();
        if (lastRenderedIconName.value !== icon) {
            lastRenderedIconName.value = icon;
            // Emit on next tick because render will be called on next tick
            (0, $1vQIy.nextTick)(()=>{
                emit("load", icon);
            });
        }
        // Customise icon
        const customise = props.customise;
        if (customise) {
            // Clone data and customise it
            data = Object.assign({}, data);
            const customised = customise(data.body, iconName.name, iconName.prefix, iconName.provider);
            if (typeof customised === "string") data.body = customised;
        }
        // Add classes
        const classes = [
            "iconify"
        ];
        if (iconName.prefix !== "") classes.push("iconify--" + iconName.prefix);
        if (iconName.provider !== "") classes.push("iconify--" + iconName.provider);
        return {
            data: data,
            classes: classes
        };
    }
    function updateIconData() {
        const icon = getIcon();
        if (!icon) iconData.value = null;
        else if (icon.data !== iconData.value?.data) iconData.value = icon;
    }
    // Set icon data
    if (rendering.value) updateIconData();
    else (0, $1vQIy.onMounted)(()=>{
        rendering.value = true;
        updateIconData();
    });
    (0, $1vQIy.watch)(()=>props.icon, updateIconData);
    // Abort loading on unmount
    (0, $1vQIy.onUnmounted)(abortLoading);
    // Render function
    return ()=>{
        // Get icon data
        const icon = iconData.value;
        if (!icon) // Icon is not available
        return $09ef86b1407f6d61$var$render($09ef86b1407f6d61$var$emptyIcon, props);
        // Add classes
        let newProps = props;
        if (icon.classes) newProps = {
            ...props,
            class: icon.classes.join(" ")
        };
        // Render icon
        return $09ef86b1407f6d61$var$render({
            ...$09ef86b1407f6d61$var$defaultIconProps,
            ...icon.data
        }, newProps);
    };
}, {
    props: {
        // Icon and render mode
        icon: {
            type: [
                String,
                Object
            ],
            required: true
        },
        mode: {
            type: String
        },
        ssr: {
            type: Boolean
        },
        // Layout and style
        width: {
            type: [
                String,
                Number
            ]
        },
        height: {
            type: [
                String,
                Number
            ]
        },
        style: {
            type: [
                String,
                Object
            ]
        },
        color: {
            type: String
        },
        inline: {
            type: Boolean
        },
        // Transformations
        rotate: {
            type: [
                Number,
                String
            ]
        },
        hFlip: {
            type: Boolean
        },
        horizontalFlip: {
            type: Boolean
        },
        vFlip: {
            type: Boolean
        },
        verticalFlip: {
            type: Boolean
        },
        flip: {
            type: String
        },
        // Misc
        id: {
            type: String
        },
        ariaHidden: {
            type: [
                Boolean,
                String
            ],
            default: undefined
        },
        customise: {
            type: Function
        },
        title: {
            type: String
        }
    },
    emits: [
        "load"
    ]
});
/**
 * Internal API
 */ const $09ef86b1407f6d61$export$14dadc205e26d636 = {
    getAPIConfig: $09ef86b1407f6d61$var$getAPIConfig,
    setAPIModule: $09ef86b1407f6d61$var$setAPIModule,
    sendAPIQuery: $09ef86b1407f6d61$var$sendAPIQuery,
    setFetch: $09ef86b1407f6d61$var$setFetch,
    getFetch: $09ef86b1407f6d61$var$getFetch,
    listAPIProviders: $09ef86b1407f6d61$var$listAPIProviders
};

});


parcelRegister("jlmG6", function(module, exports) {

$parcel$export(module.exports, "render", () => $e15191e49ad82204$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
function $e15191e49ad82204$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Iconify = (0, $1vQIy.resolveComponent)("Iconify");
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createBlock)(_component_Iconify, {
        icon: $props.name,
        width: "28",
        height: "28"
    }, null, 8, [
        "icon"
    ]);
}

});

parcelRegister("4U7Rq", function(module, exports) {

$parcel$export(module.exports, "default", () => $39227d6147a73b6f$export$2e2bcd8739ae039);
let $39227d6147a73b6f$var$NOOP = ()=>{};
var $39227d6147a73b6f$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("8mD58", function(module, exports) {
module.exports = new URL("logo.ee0d4271.webp", import.meta.url).toString();

});


parcelRegister("2OxMi", function(module, exports) {

$parcel$export(module.exports, "render", () => $20ca73de529f66d6$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
const $20ca73de529f66d6$var$_hoisted_1 = [
    "src"
];
function $20ca73de529f66d6$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $1vQIy.resolveComponent)("router-link");
    const _component_Icon = (0, $1vQIy.resolveComponent)("Icon");
    const _component_Navigation = (0, $1vQIy.resolveComponent)("Navigation");
    const _component_Container = (0, $1vQIy.resolveComponent)("Container");
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("header", null, [
        (0, $1vQIy.createVNode)(_component_Container, null, {
            default: (0, $1vQIy.withCtx)(()=>[
                    (0, $1vQIy.createElementVNode)("h1", null, [
                        (0, $1vQIy.createVNode)(_component_router_link, {
                            to: {
                                name: "Home"
                            }
                        }, {
                            default: (0, $1vQIy.withCtx)(()=>[
                                    (0, $1vQIy.createElementVNode)("img", {
                                        src: $data.logo,
                                        height: "60px",
                                        width: "0",
                                        alt: "Evelyn Logo"
                                    }, null, 8, $20ca73de529f66d6$var$_hoisted_1)
                                ]),
                            _: 1
                        })
                    ]),
                    (0, $1vQIy.createElementVNode)("button", {
                        onClick: _cache[0] || (_cache[0] = ()=>_ctx.$emit("toggle")),
                        "aria-label": "Toggle navigation"
                    }, [
                        (0, $1vQIy.createVNode)(_component_Icon, {
                            name: $props.toggleIcon
                        }, null, 8, [
                            "name"
                        ])
                    ]),
                    (0, $1vQIy.createVNode)(_component_Navigation)
                ]),
            _: 1
        })
    ]);
}

});

parcelRegister("5VMzB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4517f43ef63712c6$export$2e2bcd8739ae039);
let $4517f43ef63712c6$var$NOOP = ()=>{};
var $4517f43ef63712c6$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("hEHvj", function(module, exports) {

$parcel$export(module.exports, "default", () => $035128f408cdaebb$export$2e2bcd8739ae039);
let $035128f408cdaebb$var$script;




let $035128f408cdaebb$var$initialize = ()=>{
    $035128f408cdaebb$var$script = (parcelRequire("6phHc"));
    if ($035128f408cdaebb$var$script.__esModule) $035128f408cdaebb$var$script = $035128f408cdaebb$var$script.default;
    $035128f408cdaebb$var$script.render = (parcelRequire("a2ZgO")).render;
    $035128f408cdaebb$var$script.__cssModules = {};
    (parcelRequire("igZFZ")).default($035128f408cdaebb$var$script);
    $035128f408cdaebb$var$script.__scopeId = "data-v-8cf84f";
    $035128f408cdaebb$var$script.__file = "HeaderOverlay.vue";
};
$035128f408cdaebb$var$initialize();
var $035128f408cdaebb$export$2e2bcd8739ae039 = $035128f408cdaebb$var$script;

});
parcelRegister("6phHc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4aa2cde6b944a66d$export$2e2bcd8739ae039);

var $3taZC = parcelRequire("3taZC");

var $b6Tqq = parcelRequire("b6Tqq");
var $4aa2cde6b944a66d$export$2e2bcd8739ae039 = {
    name: "HeaderOverlay",
    props: {
        render: false
    },
    components: {
        Header: $3taZC.default,
        Overlay: $b6Tqq.default
    }
};

});
parcelRegister("b6Tqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $816b3f86da14a876$export$2e2bcd8739ae039);
let $816b3f86da14a876$var$script;




let $816b3f86da14a876$var$initialize = ()=>{
    $816b3f86da14a876$var$script = (parcelRequire("dqE0e"));
    if ($816b3f86da14a876$var$script.__esModule) $816b3f86da14a876$var$script = $816b3f86da14a876$var$script.default;
    $816b3f86da14a876$var$script.render = (parcelRequire("aR7U0")).render;
    $816b3f86da14a876$var$script.__cssModules = {};
    (parcelRequire("hyzTF")).default($816b3f86da14a876$var$script);
    $816b3f86da14a876$var$script.__scopeId = "data-v-9afc62";
    $816b3f86da14a876$var$script.__file = "Overlay.vue";
};
$816b3f86da14a876$var$initialize();
var $816b3f86da14a876$export$2e2bcd8739ae039 = $816b3f86da14a876$var$script;

});
parcelRegister("dqE0e", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9c6cbbc6c259b611$export$2e2bcd8739ae039);
var $9c6cbbc6c259b611$export$2e2bcd8739ae039 = {
    name: "Overlay"
};

});

parcelRegister("aR7U0", function(module, exports) {

$parcel$export(module.exports, "render", () => $7e74fbde5772c4b6$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
const $7e74fbde5772c4b6$var$_hoisted_1 = {
    class: "overlay"
};
function $7e74fbde5772c4b6$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("div", $7e74fbde5772c4b6$var$_hoisted_1, [
        (0, $1vQIy.renderSlot)(_ctx.$slots, "default")
    ]);
}

});

parcelRegister("hyzTF", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc8175070b0a4e54$export$2e2bcd8739ae039);
let $cc8175070b0a4e54$var$NOOP = ()=>{};
var $cc8175070b0a4e54$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("a2ZgO", function(module, exports) {

$parcel$export(module.exports, "render", () => $75099e4a0b40328d$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
var $anRt3 = parcelRequire("anRt3");
function $75099e4a0b40328d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = (0, $1vQIy.resolveComponent)("Header");
    const _component_Overlay = (0, $1vQIy.resolveComponent)("Overlay");
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createBlock)((0, $anRt3.Transition), {
        name: "overlay"
    }, {
        default: (0, $1vQIy.withCtx)(()=>[
                $props.render ? ((0, $1vQIy.openBlock)(), (0, $1vQIy.createBlock)(_component_Overlay, {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = (0, $anRt3.withModifiers)(()=>_ctx.$emit("toggle"), [
                        "self"
                    ]))
                }, {
                    default: (0, $1vQIy.withCtx)(()=>[
                            $props.render ? ((0, $1vQIy.openBlock)(), (0, $1vQIy.createBlock)(_component_Header, {
                                key: 0,
                                onToggle: _cache[0] || (_cache[0] = ()=>_ctx.$emit("toggle")),
                                toggleIcon: "eva:close-outline"
                            })) : (0, $1vQIy.createCommentVNode)("", true)
                        ]),
                    _: 1
                })) : (0, $1vQIy.createCommentVNode)("", true)
            ]),
        _: 1
    });
}

});

parcelRegister("igZFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4d99042345acfba$export$2e2bcd8739ae039);
let $d4d99042345acfba$var$NOOP = ()=>{};
var $d4d99042345acfba$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("8vzlI", function(module, exports) {

$parcel$export(module.exports, "render", () => $631ca3987f30cfc4$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
function $631ca3987f30cfc4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_HeaderDefault = (0, $1vQIy.resolveComponent)("HeaderDefault");
    const _component_HeaderOverlay = (0, $1vQIy.resolveComponent)("HeaderOverlay");
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)((0, $1vQIy.Fragment), null, [
        (0, $1vQIy.createVNode)(_component_HeaderDefault, {
            onToggle: _cache[0] || (_cache[0] = ()=>$data.overlay = true)
        }),
        (0, $1vQIy.createVNode)(_component_HeaderOverlay, {
            onToggle: _cache[1] || (_cache[1] = ()=>$data.overlay = false),
            render: $data.overlay
        }, null, 8, [
            "render"
        ])
    ], 64);
}

});

parcelRegister("21zwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $17973bcf74d9506d$export$2e2bcd8739ae039);
let $17973bcf74d9506d$var$NOOP = ()=>{};
var $17973bcf74d9506d$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("bXYKW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b645547ebf1f6ae$export$2e2bcd8739ae039);
let $8b645547ebf1f6ae$var$script;




let $8b645547ebf1f6ae$var$initialize = ()=>{
    $8b645547ebf1f6ae$var$script = (parcelRequire("c5fBg"));
    if ($8b645547ebf1f6ae$var$script.__esModule) $8b645547ebf1f6ae$var$script = $8b645547ebf1f6ae$var$script.default;
    $8b645547ebf1f6ae$var$script.render = (parcelRequire("6Rx26")).render;
    $8b645547ebf1f6ae$var$script.__cssModules = {};
    (parcelRequire("eYQfj")).default($8b645547ebf1f6ae$var$script);
    $8b645547ebf1f6ae$var$script.__scopeId = "data-v-a8e1c0";
    $8b645547ebf1f6ae$var$script.__file = "Footer.vue";
};
$8b645547ebf1f6ae$var$initialize();
var $8b645547ebf1f6ae$export$2e2bcd8739ae039 = $8b645547ebf1f6ae$var$script;

});
parcelRegister("c5fBg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $36db4774bc5f7bb6$export$2e2bcd8739ae039);

var $iGa2N = parcelRequire("iGa2N");
var $36db4774bc5f7bb6$export$2e2bcd8739ae039 = {
    name: "Footer",
    components: {
        Container: $iGa2N.default
    }
};

});

parcelRegister("6Rx26", function(module, exports) {

$parcel$export(module.exports, "render", () => $4ff150f365a0a24b$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
function $4ff150f365a0a24b$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("footer", null, [
        ..._cache[0] || (_cache[0] = [
            (0, $1vQIy.createElementVNode)("p", null, [
                (0, $1vQIy.createTextVNode)("Made with \u2764\uFE0F by "),
                (0, $1vQIy.createElementVNode)("b", null, "Gifaldy Azka"),
                (0, $1vQIy.createTextVNode)(".")
            ], -1)
        ])
    ]);
}

});

parcelRegister("eYQfj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae7f323b2964071d$export$2e2bcd8739ae039);
let $ae7f323b2964071d$var$NOOP = ()=>{};
var $ae7f323b2964071d$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("1LCJs", function(module, exports) {

$parcel$export(module.exports, "default", () => $149839a0598a7ac2$export$2e2bcd8739ae039);
let $149839a0598a7ac2$var$script;




let $149839a0598a7ac2$var$initialize = ()=>{
    $149839a0598a7ac2$var$script = (parcelRequire("dJLi8"));
    if ($149839a0598a7ac2$var$script.__esModule) $149839a0598a7ac2$var$script = $149839a0598a7ac2$var$script.default;
    $149839a0598a7ac2$var$script.render = (parcelRequire("9lbXg")).render;
    $149839a0598a7ac2$var$script.__cssModules = {};
    (parcelRequire("8I2Oe")).default($149839a0598a7ac2$var$script);
    $149839a0598a7ac2$var$script.__scopeId = "data-v-494ff7";
    $149839a0598a7ac2$var$script.__file = "Loading.vue";
};
$149839a0598a7ac2$var$initialize();
var $149839a0598a7ac2$export$2e2bcd8739ae039 = $149839a0598a7ac2$var$script;

});
parcelRegister("dJLi8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a0042969e08b79f7$export$2e2bcd8739ae039);

var $ehG8O = parcelRequire("ehG8O");

var $iGa2N = parcelRequire("iGa2N");
var $a0042969e08b79f7$export$2e2bcd8739ae039 = {
    name: "Loading",
    components: {
        LoadEffect: $ehG8O.default,
        Container: $iGa2N.default
    }
};

});
parcelRegister("ehG8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6635797170d8bb7$export$2e2bcd8739ae039);
let $a6635797170d8bb7$var$script;




let $a6635797170d8bb7$var$initialize = ()=>{
    $a6635797170d8bb7$var$script = (parcelRequire("9oowU"));
    if ($a6635797170d8bb7$var$script.__esModule) $a6635797170d8bb7$var$script = $a6635797170d8bb7$var$script.default;
    $a6635797170d8bb7$var$script.render = (parcelRequire("8sEvP")).render;
    $a6635797170d8bb7$var$script.__cssModules = {};
    (parcelRequire("aQcKg")).default($a6635797170d8bb7$var$script);
    $a6635797170d8bb7$var$script.__scopeId = "data-v-5b79a2";
    $a6635797170d8bb7$var$script.__file = "LoadEffect.vue";
};
$a6635797170d8bb7$var$initialize();
var $a6635797170d8bb7$export$2e2bcd8739ae039 = $a6635797170d8bb7$var$script;

});
parcelRegister("9oowU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6d696208d8749af6$export$2e2bcd8739ae039);
var $6d696208d8749af6$export$2e2bcd8739ae039 = {
    name: "LoadEffect",
    props: {
        stop: {
            type: Boolean,
            default: false
        }
    }
};

});

parcelRegister("8sEvP", function(module, exports) {

$parcel$export(module.exports, "render", () => $62905d2e336456be$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
var $esA86 = parcelRequire("esA86");
function $62905d2e336456be$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("span", {
        class: (0, $esA86.normalizeClass)([
            "load-effect",
            {
                stop: $props.stop
            }
        ])
    }, [
        (0, $1vQIy.renderSlot)(_ctx.$slots, "default")
    ], 2);
}

});

parcelRegister("aQcKg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e48a5a739ee3b8e$export$2e2bcd8739ae039);
let $7e48a5a739ee3b8e$var$NOOP = ()=>{};
var $7e48a5a739ee3b8e$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("9lbXg", function(module, exports) {

$parcel$export(module.exports, "render", () => $6ccf5934546b2fde$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
const $6ccf5934546b2fde$var$_hoisted_1 = {
    class: "loading"
};
function $6ccf5934546b2fde$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoadEffect = (0, $1vQIy.resolveComponent)("LoadEffect");
    const _component_Container = (0, $1vQIy.resolveComponent)("Container");
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createBlock)(_component_Container, null, {
        default: (0, $1vQIy.withCtx)(()=>[
                (0, $1vQIy.createElementVNode)("div", $6ccf5934546b2fde$var$_hoisted_1, [
                    (0, $1vQIy.createVNode)(_component_LoadEffect, {
                        class: "loading-text"
                    }, {
                        default: (0, $1vQIy.withCtx)(()=>[
                                ..._cache[0] || (_cache[0] = [
                                    (0, $1vQIy.createTextVNode)("Loading", -1)
                                ])
                            ]),
                        _: 1
                    })
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("8I2Oe", function(module, exports) {

$parcel$export(module.exports, "default", () => $65749ca4dbf63693$export$2e2bcd8739ae039);
let $65749ca4dbf63693$var$NOOP = ()=>{};
var $65749ca4dbf63693$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("3NNX1", function(module, exports) {

$parcel$export(module.exports, "render", () => $2c4cb1eb429dee56$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
var $anRt3 = parcelRequire("anRt3");
function $2c4cb1eb429dee56$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Loading = (0, $1vQIy.resolveComponent)("Loading");
    const _component_Header = (0, $1vQIy.resolveComponent)("Header");
    const _component_Footer = (0, $1vQIy.resolveComponent)("Footer");
    const _component_router_view = (0, $1vQIy.resolveComponent)("router-view");
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createBlock)((0, $anRt3.Transition), {
        name: "fade",
        mode: "out-in"
    }, {
        default: (0, $1vQIy.withCtx)(()=>[
                $data.show ? ((0, $1vQIy.openBlock)(), (0, $1vQIy.createBlock)(_component_Loading, {
                    key: 0
                })) : ((0, $1vQIy.openBlock)(), (0, $1vQIy.createBlock)(_component_router_view, {
                    key: 1
                }, {
                    default: (0, $1vQIy.withCtx)(({ Component: Component })=>[
                            (0, $1vQIy.createVNode)(_component_Header),
                            (0, $1vQIy.createVNode)((0, $anRt3.Transition), {
                                name: "fade",
                                mode: "out-in"
                            }, {
                                default: (0, $1vQIy.withCtx)(()=>[
                                        ((0, $1vQIy.openBlock)(), (0, $1vQIy.createBlock)((0, $1vQIy.resolveDynamicComponent)(Component)))
                                    ]),
                                _: 2
                            }, 1024),
                            (0, $1vQIy.createVNode)(_component_Footer)
                        ]),
                    _: 1
                }))
            ]),
        _: 1
    });
}

});

parcelRegister("1rrBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $10cdb945e864b702$export$2e2bcd8739ae039);
let $10cdb945e864b702$var$NOOP = ()=>{};
var $10cdb945e864b702$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("gxzqo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c0ab350a551b3035$export$2e2bcd8739ae039);

var $j9tZR = parcelRequire("j9tZR");
var $c0ab350a551b3035$export$2e2bcd8739ae039 = {
    name: "Home",
    components: {
        Hero: $j9tZR.default
    }
};

});
parcelRegister("j9tZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $df1620513c16d7ce$export$2e2bcd8739ae039);
let $df1620513c16d7ce$var$script;




let $df1620513c16d7ce$var$initialize = ()=>{
    $df1620513c16d7ce$var$script = (parcelRequire("5eZ46"));
    if ($df1620513c16d7ce$var$script.__esModule) $df1620513c16d7ce$var$script = $df1620513c16d7ce$var$script.default;
    $df1620513c16d7ce$var$script.render = (parcelRequire("lsmQB")).render;
    $df1620513c16d7ce$var$script.__cssModules = {};
    (parcelRequire("9DytS")).default($df1620513c16d7ce$var$script);
    $df1620513c16d7ce$var$script.__scopeId = "data-v-5e4130";
    $df1620513c16d7ce$var$script.__file = "Hero.vue";
};
$df1620513c16d7ce$var$initialize();
var $df1620513c16d7ce$export$2e2bcd8739ae039 = $df1620513c16d7ce$var$script;

});
parcelRegister("5eZ46", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3d0da0d896563723$export$2e2bcd8739ae039);

var $iGa2N = parcelRequire("iGa2N");

var $d8Xgm = parcelRequire("d8Xgm");

var $h9bs7 = parcelRequire("h9bs7");
var $3d0da0d896563723$export$2e2bcd8739ae039 = {
    name: "Hero",
    components: {
        Container: $iGa2N.default,
        Button: $d8Xgm.default
    },
    data () {
        return {
            socials: $h9bs7.default
        };
    }
};

});
parcelRegister("d8Xgm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9919fe1912432c2e$export$2e2bcd8739ae039);
let $9919fe1912432c2e$var$script;




let $9919fe1912432c2e$var$initialize = ()=>{
    $9919fe1912432c2e$var$script = (parcelRequire("7SgKB"));
    if ($9919fe1912432c2e$var$script.__esModule) $9919fe1912432c2e$var$script = $9919fe1912432c2e$var$script.default;
    $9919fe1912432c2e$var$script.render = (parcelRequire("fuMSS")).render;
    $9919fe1912432c2e$var$script.__cssModules = {};
    (parcelRequire("goLSb")).default($9919fe1912432c2e$var$script);
    $9919fe1912432c2e$var$script.__scopeId = "data-v-bf9151";
    $9919fe1912432c2e$var$script.__file = "Button.vue";
};
$9919fe1912432c2e$var$initialize();
var $9919fe1912432c2e$export$2e2bcd8739ae039 = $9919fe1912432c2e$var$script;

});
parcelRegister("7SgKB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5bba91e00164c303$export$2e2bcd8739ae039);
var $5bba91e00164c303$export$2e2bcd8739ae039 = {
    name: "Button",
    props: {
        dest: {
            type: String
        }
    }
};

});

parcelRegister("fuMSS", function(module, exports) {

$parcel$export(module.exports, "render", () => $b47f93b5524f1074$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
const $b47f93b5524f1074$var$_hoisted_1 = {
    key: 0
};
const $b47f93b5524f1074$var$_hoisted_2 = [
    "href"
];
const $b47f93b5524f1074$var$_hoisted_3 = {
    key: 1,
    class: "button button-void",
    href: void 0
};
function $b47f93b5524f1074$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $props.dest ? ((0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("div", $b47f93b5524f1074$var$_hoisted_1, [
        (0, $1vQIy.createElementVNode)("a", {
            class: "button",
            href: $props.dest
        }, [
            (0, $1vQIy.renderSlot)(_ctx.$slots, "default")
        ], 8, $b47f93b5524f1074$var$_hoisted_2)
    ])) : ((0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("a", $b47f93b5524f1074$var$_hoisted_3, [
        (0, $1vQIy.renderSlot)(_ctx.$slots, "default")
    ]));
}

});

parcelRegister("goLSb", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf0405cb3ff296cb$export$2e2bcd8739ae039);
let $bf0405cb3ff296cb$var$NOOP = ()=>{};
var $bf0405cb3ff296cb$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("h9bs7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1664187f6ea23306$export$2e2bcd8739ae039);
const $1664187f6ea23306$var$socials = [
    {
        name: "YouTube",
        username: "Hai Halo Epel",
        url: "https://youtube.com/c/HaiHaloEpel"
    },
    {
        name: "Twitter",
        username: "EpelEvelyn",
        url: "https://twitter.com/EpelEvelyn"
    },
    {
        name: "Facebook",
        username: "haihalo.epel",
        url: "https://facebook.com/haihalo.epel"
    },
    {
        name: "Instagram",
        username: "haihalo.epel",
        url: "https://instagram.com/HaiHalo.Epel"
    },
    {
        name: "Smule",
        username: "EpelEvelyn",
        url: "https://smule.com/EpelEvelyn"
    },
    {
        name: "TikTok",
        username: "HaiHaloEpel",
        url: "https://tiktok.com/@HaiHaloEpel"
    },
    {
        name: "Discord",
        username: "\uD83D\uDC99 Piolet Eplegorden \uD83D\uDC99",
        url: "https://bit.ly/HaiHaloServer"
    },
    {
        name: "Trakteer",
        username: "HaiHaloEpel",
        url: "https://trakteer.id/HaiHaloEpel"
    },
    {
        name: "Saweria",
        username: "HaiHaloEpel",
        url: "https://saweria.co/HaiHaloEpel"
    },
    {
        name: "Karyakarsa",
        username: "HaiHaloEpel",
        url: "https://karyakarsa.com/HaiHaloEpel"
    },
    {
        name: "Streamlabs",
        username: "evelynvtuber",
        url: "https://streamlabs.com/evelynvtuber/tip"
    },
    {
        name: "Steam",
        username: "EpelEvelyn",
        url: "https://steamcommunity.com/id/EpelEvelyn"
    },
    {
        name: "Reality",
        username: "Epel || Evelyn",
        url: "https://reality.app/profile/6e0ccda3"
    }
];
var $1664187f6ea23306$export$2e2bcd8739ae039 = $1664187f6ea23306$var$socials;

});


parcelRegister("lsmQB", function(module, exports) {

$parcel$export(module.exports, "render", () => $f9edef811534789c$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");

var $6T80L = parcelRequire("6T80L");
const $f9edef811534789c$var$_hoisted_1 = {
    class: "hero"
};
const $f9edef811534789c$var$_hoisted_2 = {
    class: "info"
};
function $f9edef811534789c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Button = (0, $1vQIy.resolveComponent)("Button");
    const _component_Container = (0, $1vQIy.resolveComponent)("Container");
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("section", $f9edef811534789c$var$_hoisted_1, [
        (0, $1vQIy.createVNode)(_component_Container, null, {
            default: (0, $1vQIy.withCtx)(()=>[
                    _cache[3] || (_cache[3] = (0, $1vQIy.createElementVNode)("div", {
                        class: "model"
                    }, [
                        (0, $1vQIy.createElementVNode)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6T80L))),
                            height: "0",
                            width: "100%",
                            alt: "Evelyn Model"
                        })
                    ], -1)),
                    (0, $1vQIy.createElementVNode)("div", $f9edef811534789c$var$_hoisted_2, [
                        _cache[1] || (_cache[1] = (0, $1vQIy.createElementVNode)("p", null, [
                            (0, $1vQIy.createTextVNode)(" Hai Halo!"),
                            (0, $1vQIy.createElementVNode)("br"),
                            (0, $1vQIy.createTextVNode)(" I'm Evelyn but you can call me Epel~ ")
                        ], -1)),
                        _cache[2] || (_cache[2] = (0, $1vQIy.createElementVNode)("h1", null, [
                            (0, $1vQIy.createTextVNode)(" I am aspire to become"),
                            (0, $1vQIy.createElementVNode)("br"),
                            (0, $1vQIy.createTextVNode)(" your best mood booster! ")
                        ], -1)),
                        (0, $1vQIy.createVNode)(_component_Button, {
                            href: $data.socials[0].url
                        }, {
                            default: (0, $1vQIy.withCtx)(()=>[
                                    ..._cache[0] || (_cache[0] = [
                                        (0, $1vQIy.createTextVNode)("Join Epelables", -1)
                                    ])
                                ]),
                            _: 1
                        }, 8, [
                            "href"
                        ])
                    ])
                ]),
            _: 1
        })
    ]);
}

});
parcelRegister("6T80L", function(module, exports) {
module.exports = new URL("model.a970a462.webp", import.meta.url).toString();

});


parcelRegister("9DytS", function(module, exports) {

$parcel$export(module.exports, "default", () => $704280bdde90e5df$export$2e2bcd8739ae039);
let $704280bdde90e5df$var$NOOP = ()=>{};
var $704280bdde90e5df$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("kRdD7", function(module, exports) {

$parcel$export(module.exports, "render", () => $f2f35480c90a826a$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
function $f2f35480c90a826a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Hero = (0, $1vQIy.resolveComponent)("Hero");
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createBlock)(_component_Hero);
}

});

parcelRegister("daWq5", function(module, exports) {

$parcel$export(module.exports, "default", () => $997986804f6ad897$export$2e2bcd8739ae039);
let $997986804f6ad897$var$NOOP = ()=>{};
var $997986804f6ad897$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("gNU50", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c3bcb93a26292644$export$2e2bcd8739ae039);

var $iGa2N = parcelRequire("iGa2N");

var $jLLSu = parcelRequire("jLLSu");

var $i0cJB = parcelRequire("i0cJB");

var $ac8WF = parcelRequire("ac8WF");

var $dZqSr = parcelRequire("dZqSr");

var $lhmv9 = parcelRequire("lhmv9");
var $c3bcb93a26292644$export$2e2bcd8739ae039 = {
    name: "FanArt",
    components: {
        Container: $iGa2N.default,
        PageTitle: $jLLSu.default,
        ArtCard: $i0cJB.default,
        ArtList: $ac8WF.default,
        ImageView: $dZqSr.default
    },
    data () {
        return {
            arts: $lhmv9.default,
            view: false,
            img: ""
        };
    },
    methods: {
        toggle (img) {
            this.view = !this.view;
            this.img = img;
            document.body.setAttribute("style", "overflow: hidden;");
        },
        boolUpdate (value) {
            this.view = value;
        }
    }
};

});
parcelRegister("jLLSu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6478ba5ff2a2093$export$2e2bcd8739ae039);
let $e6478ba5ff2a2093$var$script;




let $e6478ba5ff2a2093$var$initialize = ()=>{
    $e6478ba5ff2a2093$var$script = (parcelRequire("dMPIU"));
    if ($e6478ba5ff2a2093$var$script.__esModule) $e6478ba5ff2a2093$var$script = $e6478ba5ff2a2093$var$script.default;
    $e6478ba5ff2a2093$var$script.render = (parcelRequire("2gOEy")).render;
    $e6478ba5ff2a2093$var$script.__cssModules = {};
    (parcelRequire("1sVBd")).default($e6478ba5ff2a2093$var$script);
    $e6478ba5ff2a2093$var$script.__scopeId = "data-v-49e489";
    $e6478ba5ff2a2093$var$script.__file = "PageTitle.vue";
};
$e6478ba5ff2a2093$var$initialize();
var $e6478ba5ff2a2093$export$2e2bcd8739ae039 = $e6478ba5ff2a2093$var$script;

});
parcelRegister("dMPIU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a097e13d652b5a98$export$2e2bcd8739ae039);
var $a097e13d652b5a98$export$2e2bcd8739ae039 = {
    name: "PageTitle"
};

});

parcelRegister("2gOEy", function(module, exports) {

$parcel$export(module.exports, "render", () => $1a745e0c86f9d157$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
const $1a745e0c86f9d157$var$_hoisted_1 = {
    class: "page-title"
};
function $1a745e0c86f9d157$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("div", $1a745e0c86f9d157$var$_hoisted_1, [
        (0, $1vQIy.createElementVNode)("h1", null, [
            (0, $1vQIy.renderSlot)(_ctx.$slots, "default")
        ]),
        (0, $1vQIy.createElementVNode)("p", null, [
            (0, $1vQIy.renderSlot)(_ctx.$slots, "sub")
        ])
    ]);
}

});

parcelRegister("1sVBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $11151601b8e1e9ae$export$2e2bcd8739ae039);
let $11151601b8e1e9ae$var$NOOP = ()=>{};
var $11151601b8e1e9ae$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("i0cJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1b21ae06c876326$export$2e2bcd8739ae039);
let $d1b21ae06c876326$var$script;




let $d1b21ae06c876326$var$initialize = ()=>{
    $d1b21ae06c876326$var$script = (parcelRequire("8ALXv"));
    if ($d1b21ae06c876326$var$script.__esModule) $d1b21ae06c876326$var$script = $d1b21ae06c876326$var$script.default;
    $d1b21ae06c876326$var$script.render = (parcelRequire("1r11D")).render;
    $d1b21ae06c876326$var$script.__cssModules = {};
    (parcelRequire("5LYIS")).default($d1b21ae06c876326$var$script);
    $d1b21ae06c876326$var$script.__scopeId = "data-v-1e45e5";
    $d1b21ae06c876326$var$script.__file = "ArtCard.vue";
};
$d1b21ae06c876326$var$initialize();
var $d1b21ae06c876326$export$2e2bcd8739ae039 = $d1b21ae06c876326$var$script;

});
parcelRegister("8ALXv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $92ee395543e5c14e$export$2e2bcd8739ae039);
var $92ee395543e5c14e$export$2e2bcd8739ae039 = {
    name: "ArtCard",
    props: {
        img: {
            type: String,
            required: true
        },
        artist: {
            type: String,
            required: true
        },
        artistUrl: {
            type: String,
            required: true
        }
    }
};

});

parcelRegister("1r11D", function(module, exports) {

$parcel$export(module.exports, "render", () => $10b91bb0defc4379$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
var $esA86 = parcelRequire("esA86");
const $10b91bb0defc4379$var$_hoisted_1 = {
    class: "card"
};
const $10b91bb0defc4379$var$_hoisted_2 = [
    "src",
    "alt"
];
const $10b91bb0defc4379$var$_hoisted_3 = {
    class: "desc"
};
const $10b91bb0defc4379$var$_hoisted_4 = [
    "href"
];
function $10b91bb0defc4379$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("div", $10b91bb0defc4379$var$_hoisted_1, [
        (0, $1vQIy.createElementVNode)("img", {
            src: $props.img,
            alt: `Art by ${$props.artist}`
        }, null, 8, $10b91bb0defc4379$var$_hoisted_2),
        (0, $1vQIy.createElementVNode)("div", $10b91bb0defc4379$var$_hoisted_3, [
            (0, $1vQIy.createElementVNode)("a", {
                href: $props.artistUrl
            }, (0, $esA86.toDisplayString)($props.artist), 9, $10b91bb0defc4379$var$_hoisted_4)
        ])
    ]);
}

});

parcelRegister("5LYIS", function(module, exports) {

$parcel$export(module.exports, "default", () => $434071d6dc257fb7$export$2e2bcd8739ae039);
let $434071d6dc257fb7$var$NOOP = ()=>{};
var $434071d6dc257fb7$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("ac8WF", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c1f6b9a1aa0c71$export$2e2bcd8739ae039);
let $76c1f6b9a1aa0c71$var$script;




let $76c1f6b9a1aa0c71$var$initialize = ()=>{
    $76c1f6b9a1aa0c71$var$script = (parcelRequire("jRINE"));
    if ($76c1f6b9a1aa0c71$var$script.__esModule) $76c1f6b9a1aa0c71$var$script = $76c1f6b9a1aa0c71$var$script.default;
    $76c1f6b9a1aa0c71$var$script.render = (parcelRequire("8Rwz6")).render;
    $76c1f6b9a1aa0c71$var$script.__cssModules = {};
    (parcelRequire("1NW81")).default($76c1f6b9a1aa0c71$var$script);
    $76c1f6b9a1aa0c71$var$script.__scopeId = "data-v-69b16e";
    $76c1f6b9a1aa0c71$var$script.__file = "ArtList.vue";
};
$76c1f6b9a1aa0c71$var$initialize();
var $76c1f6b9a1aa0c71$export$2e2bcd8739ae039 = $76c1f6b9a1aa0c71$var$script;

});
parcelRegister("jRINE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e765b7de4113dbc0$export$2e2bcd8739ae039);
var $e765b7de4113dbc0$export$2e2bcd8739ae039 = {
    name: "ArtList"
};

});

parcelRegister("8Rwz6", function(module, exports) {

$parcel$export(module.exports, "render", () => $673c88bbaca5b6a8$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
const $673c88bbaca5b6a8$var$_hoisted_1 = {
    class: "art-list"
};
function $673c88bbaca5b6a8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("ul", $673c88bbaca5b6a8$var$_hoisted_1, [
        (0, $1vQIy.renderSlot)(_ctx.$slots, "default")
    ]);
}

});

parcelRegister("1NW81", function(module, exports) {

$parcel$export(module.exports, "default", () => $1507751c3abb49ad$export$2e2bcd8739ae039);
let $1507751c3abb49ad$var$NOOP = ()=>{};
var $1507751c3abb49ad$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("dZqSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2f5d21ec6432265$export$2e2bcd8739ae039);
let $a2f5d21ec6432265$var$script;




let $a2f5d21ec6432265$var$initialize = ()=>{
    $a2f5d21ec6432265$var$script = (parcelRequire("kA3Dk"));
    if ($a2f5d21ec6432265$var$script.__esModule) $a2f5d21ec6432265$var$script = $a2f5d21ec6432265$var$script.default;
    $a2f5d21ec6432265$var$script.render = (parcelRequire("dKUR3")).render;
    $a2f5d21ec6432265$var$script.__cssModules = {};
    (parcelRequire("6pQLI")).default($a2f5d21ec6432265$var$script);
    $a2f5d21ec6432265$var$script.__scopeId = "data-v-180329";
    $a2f5d21ec6432265$var$script.__file = "ImageView.vue";
};
$a2f5d21ec6432265$var$initialize();
var $a2f5d21ec6432265$export$2e2bcd8739ae039 = $a2f5d21ec6432265$var$script;

});
parcelRegister("kA3Dk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2ccc7172cf5fbb8c$export$2e2bcd8739ae039);

var $g2ma9 = parcelRequire("g2ma9");
var $2ccc7172cf5fbb8c$export$2e2bcd8739ae039 = {
    name: "ImageView",
    props: [
        "arts",
        "isView",
        "img"
    ],
    components: {
        Icon: $g2ma9.default
    },
    data () {
        return {
            view: this.isView
        };
    },
    methods: {
        update () {
            this.view = !this.view;
            this.$emit("boolUpdate", this.view);
            document.body.removeAttribute("style");
        }
    }
};

});

parcelRegister("dKUR3", function(module, exports) {

$parcel$export(module.exports, "render", () => $a03bac6cce587dd5$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
var $anRt3 = parcelRequire("anRt3");
const $a03bac6cce587dd5$var$_hoisted_1 = {
    class: "img"
};
const $a03bac6cce587dd5$var$_hoisted_2 = [
    "src"
];
function $a03bac6cce587dd5$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Icon = (0, $1vQIy.resolveComponent)("Icon");
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("div", {
        class: "root",
        onClick: _cache[1] || (_cache[1] = (0, $anRt3.withModifiers)(($event)=>$options.update(), [
            "self"
        ]))
    }, [
        (0, $1vQIy.createElementVNode)("button", {
            class: "exit",
            onClick: _cache[0] || (_cache[0] = ($event)=>$options.update())
        }, [
            (0, $1vQIy.createVNode)(_component_Icon, {
                name: "eva:close-outline"
            })
        ]),
        (0, $1vQIy.createElementVNode)("figure", $a03bac6cce587dd5$var$_hoisted_1, [
            (0, $1vQIy.createElementVNode)("img", {
                src: $props.img,
                alt: "Image"
            }, null, 8, $a03bac6cce587dd5$var$_hoisted_2)
        ])
    ]);
}

});

parcelRegister("6pQLI", function(module, exports) {

$parcel$export(module.exports, "default", () => $4abe02a054ebe5b4$export$2e2bcd8739ae039);
let $4abe02a054ebe5b4$var$NOOP = ()=>{};
var $4abe02a054ebe5b4$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("lhmv9", function(module, exports) {

$parcel$export(module.exports, "default", () => $42b481f9b4bef4fe$export$2e2bcd8739ae039);
const $42b481f9b4bef4fe$var$arts = [
    {
        img: "https://pbs.twimg.com/media/FRmAB6yagAI0br0.jpg",
        artist: {
            username: "@ElaineCelestia",
            url: "https://twitter.com/ElaineCelestia"
        }
    },
    {
        img: "https://pbs.twimg.com/media/Eu9cQWIU4AYZGex.jpg",
        artist: {
            username: "@AyumiAika_",
            url: "https://twitter.com/AyumiAika_"
        }
    },
    {
        img: "https://pbs.twimg.com/media/E44l9wLUcAcMSdz.jpg",
        artist: {
            username: "@Ikazu401",
            url: "https://twitter.com/Ikazu401"
        }
    },
    {
        img: "https://pbs.twimg.com/media/FN96pDoaAAIuEQs.jpg",
        artist: {
            username: "@deidey16_",
            url: "https://twitter.com/deidey16_"
        }
    },
    {
        img: "https://pbs.twimg.com/media/FRljGC3VsAAMgQK.jpg",
        artist: {
            username: "@Ikazu401",
            url: "https://twitter.com/Ikazu401"
        }
    },
    {
        img: "https://pbs.twimg.com/media/FXfleEFacAAwCVb.jpg",
        artist: {
            username: "@MerySyafira48",
            url: "https://twitter.com/MerySyafira48"
        }
    },
    {
        img: "https://pbs.twimg.com/media/E_jg_FKVUAAJOf_.jpg",
        artist: {
            username: "@aditchris",
            url: "https://twitter.com/aditchris"
        }
    },
    {
        img: "https://pbs.twimg.com/media/Ef14v6hUEAEn7yH.jpg",
        artist: {
            username: "@Acacia_Leafs",
            url: "https://twitter.com/Acacia_Leafs"
        }
    },
    {
        img: "https://pbs.twimg.com/media/EmJ8YMGVgAYQG3p.jpg",
        artist: {
            username: "@SakurarinMochi",
            url: "https://twitter.com/SakurarinMochi"
        }
    },
    {
        img: "https://pbs.twimg.com/media/FaUgYNOaAAE-PXG.jpg",
        artist: {
            username: "@pine_pinepin",
            url: "https://twitter.com/pine_pinepin"
        }
    },
    {
        img: "https://pbs.twimg.com/media/FZsxffAUYAEegeF.jpg",
        artist: {
            username: "@SakurarinMochi",
            url: "https://twitter.com/SakurarinMochi"
        }
    },
    {
        img: "https://pbs.twimg.com/media/EfnGLyOVoAEUOaf.jpg",
        artist: {
            username: "@UpMocks",
            url: "https://twitter.com/UpMocks"
        }
    },
    {
        img: "https://pbs.twimg.com/media/Fc_gzamaIAA108D.jpg",
        artist: {
            username: "@pine_pinepin",
            url: "https://twitter.com/pine_pinepin"
        }
    }
];
var $42b481f9b4bef4fe$export$2e2bcd8739ae039 = $42b481f9b4bef4fe$var$arts;

});


parcelRegister("gGP7V", function(module, exports) {

$parcel$export(module.exports, "render", () => $c2683a5086413bb6$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
var $anRt3 = parcelRequire("anRt3");
const $c2683a5086413bb6$var$_hoisted_1 = {
    class: "fanart"
};
const $c2683a5086413bb6$var$_hoisted_2 = {
    key: 0,
    class: "viewer"
};
function $c2683a5086413bb6$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ImageView = (0, $1vQIy.resolveComponent)("ImageView");
    const _component_PageTitle = (0, $1vQIy.resolveComponent)("PageTitle");
    const _component_ArtCard = (0, $1vQIy.resolveComponent)("ArtCard");
    const _component_ArtList = (0, $1vQIy.resolveComponent)("ArtList");
    const _component_Container = (0, $1vQIy.resolveComponent)("Container");
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("section", $c2683a5086413bb6$var$_hoisted_1, [
        (0, $1vQIy.createVNode)((0, $anRt3.Transition), {
            name: "fade",
            mode: "out-in"
        }, {
            default: (0, $1vQIy.withCtx)(()=>[
                    $data.view ? ((0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("div", $c2683a5086413bb6$var$_hoisted_2, [
                        (0, $1vQIy.createVNode)(_component_ImageView, {
                            arts: $data.arts,
                            isView: $data.view,
                            img: $data.img,
                            onBoolUpdate: _cache[0] || (_cache[0] = ($event)=>$options.boolUpdate())
                        }, null, 8, [
                            "arts",
                            "isView",
                            "img"
                        ])
                    ])) : (0, $1vQIy.createCommentVNode)("", true)
                ]),
            _: 1
        }),
        (0, $1vQIy.createVNode)(_component_Container, null, {
            default: (0, $1vQIy.withCtx)(()=>[
                    (0, $1vQIy.createVNode)(_component_PageTitle, null, {
                        default: (0, $1vQIy.withCtx)(()=>[
                                ..._cache[1] || (_cache[1] = [
                                    (0, $1vQIy.createTextVNode)("Fan art", -1)
                                ])
                            ]),
                        sub: (0, $1vQIy.withCtx)(()=>[
                                ..._cache[2] || (_cache[2] = [
                                    (0, $1vQIy.createTextVNode)("\uD83D\uDDBC\uFE0F Curated Fan-made art from ", -1),
                                    (0, $1vQIy.createElementVNode)("a", {
                                        href: "https://twitter.com/hashtag/PienEpelPaint",
                                        target: "_blank"
                                    }, "#PienEpelPaint", -1),
                                    (0, $1vQIy.createTextVNode)(" hashtag on \uD83D\uDC26 Twitter", -1)
                                ])
                            ]),
                        _: 1
                    }),
                    (0, $1vQIy.createVNode)(_component_ArtList, null, {
                        default: (0, $1vQIy.withCtx)(()=>[
                                ((0, $1vQIy.openBlock)(true), (0, $1vQIy.createElementBlock)((0, $1vQIy.Fragment), null, (0, $1vQIy.renderList)($data.arts, (art)=>{
                                    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("li", null, [
                                        (0, $1vQIy.createVNode)(_component_ArtCard, {
                                            onClick: ($event)=>$options.toggle(art.img),
                                            img: art.img,
                                            artist: art.artist.username,
                                            artistUrl: art.artist.url
                                        }, null, 8, [
                                            "onClick",
                                            "img",
                                            "artist",
                                            "artistUrl"
                                        ])
                                    ]);
                                }), 256))
                            ]),
                        _: 1
                    })
                ]),
            _: 1
        })
    ]);
}

});

parcelRegister("brP4W", function(module, exports) {

$parcel$export(module.exports, "default", () => $8559d67881a21b0d$export$2e2bcd8739ae039);
let $8559d67881a21b0d$var$NOOP = ()=>{};
var $8559d67881a21b0d$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("2HYh5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9374e175e7d24e89$export$2e2bcd8739ae039);

var $iGa2N = parcelRequire("iGa2N");

var $jLLSu = parcelRequire("jLLSu");

var $d8Xgm = parcelRequire("d8Xgm");

var $h9bs7 = parcelRequire("h9bs7");

var $bbBXI = parcelRequire("bbBXI");
var $9374e175e7d24e89$export$2e2bcd8739ae039 = {
    name: "About",
    components: {
        Container: $iGa2N.default,
        PageTitle: $jLLSu.default,
        Button: $d8Xgm.default
    },
    data () {
        return {
            expanded: false,
            data: $bbBXI.default,
            socials: $h9bs7.default
        };
    },
    methods: {
        expand () {
            this.expanded = !this.expanded;
        }
    }
};

});
parcelRegister("bbBXI", function(module, exports) {

$parcel$export(module.exports, "default", () => $51d5ef7a5ed77d57$export$2e2bcd8739ae039);
const $51d5ef7a5ed77d57$var$general = {
    name: {
        origin: "Evelyn",
        alias: "Epel"
    },
    debut: "January 13, 2019",
    birthday: "December 1",
    height: {
        origin: "160 cm",
        withAhoge: "165 cm"
    },
    weight: "52 kg",
    blood: "B+",
    zodiac: "Sagittarius",
    affilation: {
        current: "Independent",
        formerly: "Re:Memories"
    },
    languages: [
        "Indonesian",
        "English",
        "Little bit of Japanese"
    ]
};
var $51d5ef7a5ed77d57$export$2e2bcd8739ae039 = $51d5ef7a5ed77d57$var$general;

});


parcelRegister("8IHNL", function(module, exports) {

$parcel$export(module.exports, "render", () => $659468e030439aea$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
var $esA86 = parcelRequire("esA86");

var $9EsLl = parcelRequire("9EsLl");
const $659468e030439aea$var$_hoisted_1 = {
    key: 0,
    class: "if-expanded"
};
const $659468e030439aea$var$_hoisted_2 = {
    id: "personal"
};
const $659468e030439aea$var$_hoisted_3 = {
    class: "content"
};
const $659468e030439aea$var$_hoisted_4 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_5 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_6 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_7 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_8 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_9 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_10 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_11 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_12 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_13 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_14 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_15 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_16 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_17 = {
    id: "socials"
};
const $659468e030439aea$var$_hoisted_18 = {
    class: "content"
};
const $659468e030439aea$var$_hoisted_19 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_20 = [
    "href"
];
const $659468e030439aea$var$_hoisted_21 = {
    key: 1,
    class: "expand-btn"
};
function $659468e030439aea$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PageTitle = (0, $1vQIy.resolveComponent)("PageTitle");
    const _component_Button = (0, $1vQIy.resolveComponent)("Button");
    const _component_Container = (0, $1vQIy.resolveComponent)("Container");
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createBlock)(_component_Container, {
        class: "about-container"
    }, {
        default: (0, $1vQIy.withCtx)(()=>[
                (0, $1vQIy.createVNode)(_component_PageTitle, {
                    class: "about-title"
                }, {
                    default: (0, $1vQIy.withCtx)(()=>[
                            ..._cache[0] || (_cache[0] = [
                                (0, $1vQIy.createTextVNode)("About", -1)
                            ])
                        ]),
                    _: 1
                }),
                _cache[9] || (_cache[9] = (0, $1vQIy.createElementVNode)("div", {
                    class: "model"
                }, [
                    (0, $1vQIy.createElementVNode)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9EsLl))),
                        alt: "Evelyn Model"
                    })
                ], -1)),
                _cache[10] || (_cache[10] = (0, $1vQIy.createElementVNode)("div", {
                    class: "main-content"
                }, [
                    (0, $1vQIy.createElementVNode)("div", {
                        id: "personality"
                    }, [
                        (0, $1vQIy.createElementVNode)("h3", {
                            class: "subtitle"
                        }, "\uD83D\uDC99 Personality"),
                        (0, $1vQIy.createElementVNode)("p", {
                            class: "content"
                        }, ' Evelyn has a warm and friendly personality towards her viewers. She has a "good girl" persona. She\'s sweet, caring, full of affection, and tends to avoid sensitive issues, as well as strong or bad words and profanities. She is described as a humble, genuine and hardworking girl since she interacts with her viewers regularly by trying to reply to most all of their comments on her YouTube and social media every day. She is willing to help people and wants to grow together with her community. '),
                        (0, $1vQIy.createElementVNode)("p", {
                            class: "content"
                        }, " Her channel's contents ranges from let's plays, song covers, ASMR, random talks and contents, story readings and problem consultations. Her contents were mostly VODs (Video On Demand) before she started following the live streaming trend in late August 2019. She currently focuses on live streams for nearly all of her contents. ")
                    ]),
                    (0, $1vQIy.createElementVNode)("div", {
                        id: "appearance"
                    }, [
                        (0, $1vQIy.createElementVNode)("h3", {
                            class: "subtitle mt"
                        }, "\uD83D\uDC85 Appearance"),
                        (0, $1vQIy.createElementVNode)("p", {
                            class: "content"
                        }, " Evelyn's first appearance is a young woman with a relatively slim body, oval face, red eyes, and long sea blue hair with an ahoge. Her dominant color scheme is blue, pink and white. "),
                        (0, $1vQIy.createElementVNode)("p", {
                            class: "content"
                        }, [
                            (0, $1vQIy.createTextVNode)(" She got a new costume on her "),
                            (0, $1vQIy.createElementVNode)("a", {
                                href: "https://youtu.be/sQk3WJPcheM"
                            }, "1st birthday"),
                            (0, $1vQIy.createTextVNode)(". Her v2 outfit is a white and pink, sleeveless button-up dress resembling a maid outfit. Her hair is pink at the tips, and her ahoge is slightly shorter in length. ")
                        ]),
                        (0, $1vQIy.createElementVNode)("p", {
                            class: "content"
                        }, [
                            (0, $1vQIy.createTextVNode)(" She got another new costume at "),
                            (0, $1vQIy.createElementVNode)("a", {
                                href: "https://youtu.be/8v0d54N4EW4&t=4075s"
                            }, "2021 valentine's day"),
                            (0, $1vQIy.createTextVNode)(". This v3 outfit is more casual because it's supposed for dating (with you). She got several new expressions like sad, crying, angry, terrified, "),
                            (0, $1vQIy.createElementVNode)("i", null, "gangimari"),
                            (0, $1vQIy.createTextVNode)(", and yandere eyes. She also has a cat girl mode that makes her have nekomimi (cat ears) and a tail with ribbon. ")
                        ])
                    ])
                ], -1)),
                $data.expanded ? ((0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("div", $659468e030439aea$var$_hoisted_1, [
                    _cache[7] || (_cache[7] = (0, $1vQIy.createElementVNode)("div", {
                        id: "history"
                    }, [
                        (0, $1vQIy.createElementVNode)("h3", {
                            class: "subtitle mt"
                        }, "\uD83D\uDCDC History"),
                        (0, $1vQIy.createElementVNode)("h4", {
                            class: "sub mt"
                        }, "Background"),
                        (0, $1vQIy.createElementVNode)("p", {
                            class: "content"
                        }, " On 20 September 2021, she and fellow VTubers in her team (Lily Ifeta, Chloe Pawapua and Reynard Blanc) announced that their management team would become an independent agency named Re:Memories. "),
                        (0, $1vQIy.createElementVNode)("h3", {
                            class: "sub mt"
                        }, "2022"),
                        (0, $1vQIy.createElementVNode)("p", {
                            class: "content"
                        }, " On 30 April, Re:memories's Twitter announced that Evelyn would be separating from Re:memories agency and becoming an independent VTuber on the same day. Before that, she also held a stream to announce it. ")
                    ], -1)),
                    (0, $1vQIy.createElementVNode)("div", $659468e030439aea$var$_hoisted_2, [
                        _cache[3] || (_cache[3] = (0, $1vQIy.createElementVNode)("h3", {
                            class: "subtitle mt"
                        }, "\uD83D\uDC64 Personal details", -1)),
                        (0, $1vQIy.createElementVNode)("ul", $659468e030439aea$var$_hoisted_3, [
                            (0, $1vQIy.createElementVNode)("li", $659468e030439aea$var$_hoisted_4, [
                                (0, $1vQIy.createTextVNode)(" Name: " + (0, $esA86.toDisplayString)($data.data.name.origin) + " ", 1),
                                (0, $1vQIy.createElementVNode)("ul", null, [
                                    (0, $1vQIy.createElementVNode)("li", $659468e030439aea$var$_hoisted_5, "Alias: " + (0, $esA86.toDisplayString)($data.data.name.alias), 1)
                                ])
                            ]),
                            (0, $1vQIy.createElementVNode)("li", $659468e030439aea$var$_hoisted_6, "Debut date: " + (0, $esA86.toDisplayString)($data.data.debut), 1),
                            (0, $1vQIy.createElementVNode)("li", $659468e030439aea$var$_hoisted_7, "Birthday: " + (0, $esA86.toDisplayString)($data.data.birthday), 1),
                            (0, $1vQIy.createElementVNode)("li", $659468e030439aea$var$_hoisted_8, "Height: " + (0, $esA86.toDisplayString)($data.data.height.origin) + " (" + (0, $esA86.toDisplayString)($data.data.height.withAhoge) + " with ahoge)", 1),
                            (0, $1vQIy.createElementVNode)("li", $659468e030439aea$var$_hoisted_9, "Weight: " + (0, $esA86.toDisplayString)($data.data.weight), 1),
                            (0, $1vQIy.createElementVNode)("li", $659468e030439aea$var$_hoisted_10, "Blood type: " + (0, $esA86.toDisplayString)($data.data.blood), 1),
                            (0, $1vQIy.createElementVNode)("li", $659468e030439aea$var$_hoisted_11, "Zodiac: " + (0, $esA86.toDisplayString)($data.data.zodiac), 1),
                            (0, $1vQIy.createElementVNode)("li", $659468e030439aea$var$_hoisted_12, [
                                _cache[1] || (_cache[1] = (0, $1vQIy.createTextVNode)(" Affilation ", -1)),
                                (0, $1vQIy.createElementVNode)("ul", null, [
                                    (0, $1vQIy.createElementVNode)("li", $659468e030439aea$var$_hoisted_13, (0, $esA86.toDisplayString)($data.data.affilation.current), 1),
                                    (0, $1vQIy.createElementVNode)("li", $659468e030439aea$var$_hoisted_14, (0, $esA86.toDisplayString)($data.data.affilation.formerly) + " (formerly)", 1)
                                ])
                            ]),
                            (0, $1vQIy.createElementVNode)("li", $659468e030439aea$var$_hoisted_15, [
                                _cache[2] || (_cache[2] = (0, $1vQIy.createTextVNode)(" Languages ", -1)),
                                (0, $1vQIy.createElementVNode)("ul", null, [
                                    ((0, $1vQIy.openBlock)(true), (0, $1vQIy.createElementBlock)((0, $1vQIy.Fragment), null, (0, $1vQIy.renderList)($data.data.languages, (lang)=>{
                                        return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("li", $659468e030439aea$var$_hoisted_16, (0, $esA86.toDisplayString)(lang), 1);
                                    }), 256))
                                ])
                            ])
                        ])
                    ]),
                    (0, $1vQIy.createElementVNode)("div", $659468e030439aea$var$_hoisted_17, [
                        _cache[4] || (_cache[4] = (0, $1vQIy.createElementVNode)("h3", {
                            class: "subtitle mt"
                        }, "#\uFE0F\u20E3 Socials", -1)),
                        _cache[5] || (_cache[5] = (0, $1vQIy.createElementVNode)("p", {
                            class: "content"
                        }, "Evelyn is discoverable at social media. Make sure to follow her social accounts!", -1)),
                        (0, $1vQIy.createElementVNode)("ul", $659468e030439aea$var$_hoisted_18, [
                            ((0, $1vQIy.openBlock)(true), (0, $1vQIy.createElementBlock)((0, $1vQIy.Fragment), null, (0, $1vQIy.renderList)($data.socials, (social)=>{
                                return (0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("li", $659468e030439aea$var$_hoisted_19, [
                                    (0, $1vQIy.createTextVNode)((0, $esA86.toDisplayString)(social.name) + ": ", 1),
                                    (0, $1vQIy.createElementVNode)("a", {
                                        href: social.url,
                                        target: "_blank"
                                    }, "@" + (0, $esA86.toDisplayString)(social.username), 9, $659468e030439aea$var$_hoisted_20)
                                ]);
                            }), 256))
                        ])
                    ]),
                    (0, $1vQIy.createVNode)(_component_Button, {
                        onClick: $options.expand
                    }, {
                        default: (0, $1vQIy.withCtx)(()=>[
                                ..._cache[6] || (_cache[6] = [
                                    (0, $1vQIy.createTextVNode)("See less information \uD83D\uDC46", -1)
                                ])
                            ]),
                        _: 1
                    }, 8, [
                        "onClick"
                    ])
                ])) : ((0, $1vQIy.openBlock)(), (0, $1vQIy.createElementBlock)("div", $659468e030439aea$var$_hoisted_21, [
                    (0, $1vQIy.createVNode)(_component_Button, {
                        onClick: $options.expand
                    }, {
                        default: (0, $1vQIy.withCtx)(()=>[
                                ..._cache[8] || (_cache[8] = [
                                    (0, $1vQIy.createTextVNode)("Expand more information \uD83D\uDC47", -1)
                                ])
                            ]),
                        _: 1
                    }, 8, [
                        "onClick"
                    ])
                ]))
            ]),
        _: 1
    });
}

});
parcelRegister("9EsLl", function(module, exports) {
module.exports = new URL("model-trp.e8f8912b.webp", import.meta.url).toString();

});


parcelRegister("k8ast", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea7caacfd891c4b8$export$2e2bcd8739ae039);
let $ea7caacfd891c4b8$var$NOOP = ()=>{};
var $ea7caacfd891c4b8$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("a5F10", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1a23af2fe307fb1f$export$2e2bcd8739ae039);

var $iGa2N = parcelRequire("iGa2N");
var $1a23af2fe307fb1f$export$2e2bcd8739ae039 = {
    name: "NotFound",
    components: {
        Container: $iGa2N.default
    }
};

});

parcelRegister("at2xZ", function(module, exports) {

$parcel$export(module.exports, "render", () => $79ee96a4927946f8$export$b3890eb0ae9dca99);
parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
const $79ee96a4927946f8$var$_hoisted_1 = {
    class: "error"
};
function $79ee96a4927946f8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $1vQIy.resolveComponent)("router-link");
    const _component_Container = (0, $1vQIy.resolveComponent)("Container");
    return (0, $1vQIy.openBlock)(), (0, $1vQIy.createBlock)(_component_Container, null, {
        default: (0, $1vQIy.withCtx)(()=>[
                (0, $1vQIy.createElementVNode)("section", $79ee96a4927946f8$var$_hoisted_1, [
                    _cache[5] || (_cache[5] = (0, $1vQIy.createElementVNode)("h1", null, ":(", -1)),
                    _cache[6] || (_cache[6] = (0, $1vQIy.createElementVNode)("h2", null, "404 Error - Oops!", -1)),
                    (0, $1vQIy.createElementVNode)("p", null, [
                        _cache[1] || (_cache[1] = (0, $1vQIy.createTextVNode)(" Sadly, Epel can't find your request on this web page. Please check back the URL \uD83D\uDE0A. ", -1)),
                        _cache[2] || (_cache[2] = (0, $1vQIy.createElementVNode)("br", null, null, -1)),
                        _cache[3] || (_cache[3] = (0, $1vQIy.createTextVNode)(" Or maybe you want back to ", -1)),
                        (0, $1vQIy.createVNode)(_component_router_link, {
                            to: {
                                name: "Home"
                            }
                        }, {
                            default: (0, $1vQIy.withCtx)(()=>[
                                    ..._cache[0] || (_cache[0] = [
                                        (0, $1vQIy.createTextVNode)("Home page", -1)
                                    ])
                                ]),
                            _: 1
                        }),
                        _cache[4] || (_cache[4] = (0, $1vQIy.createTextVNode)("? Let me take you there~ ", -1))
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("iFUMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d98818f02d83cf91$export$2e2bcd8739ae039);
let $d98818f02d83cf91$var$NOOP = ()=>{};
var $d98818f02d83cf91$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("6s3pK");
var $anRt3 = parcelRequire("anRt3");
// @ts-nocheck


let $ae3de8900c09c2f9$var$script;




let $ae3de8900c09c2f9$var$initialize = ()=>{
    $ae3de8900c09c2f9$var$script = (parcelRequire("boZNq"));
    if ($ae3de8900c09c2f9$var$script.__esModule) $ae3de8900c09c2f9$var$script = $ae3de8900c09c2f9$var$script.default;
    $ae3de8900c09c2f9$var$script.render = (parcelRequire("3NNX1")).render;
    $ae3de8900c09c2f9$var$script.__cssModules = {};
    (parcelRequire("1rrBo")).default($ae3de8900c09c2f9$var$script);
    $ae3de8900c09c2f9$var$script.__scopeId = "data-v-3170b6";
    $ae3de8900c09c2f9$var$script.__file = "App.vue";
};
$ae3de8900c09c2f9$var$initialize();
var $ae3de8900c09c2f9$export$2e2bcd8739ae039 = $ae3de8900c09c2f9$var$script;


/*!
  * vue-router v4.2.5
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */ parcelRequire("6s3pK");
var $1vQIy = parcelRequire("1vQIy");
var $1iCGX = parcelRequire("1iCGX");
function $a64da22f94f2a1a2$export$5a2d366b2d9f38f6() {
    return $a64da22f94f2a1a2$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $a64da22f94f2a1a2$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : {};
}
const $a64da22f94f2a1a2$export$bc32a04c49ed7464 = typeof Proxy === "function";


const $44596e28c79d61f0$export$b1499c3bd2a3f4df = "devtools-plugin:setup";
const $44596e28c79d61f0$export$a0897f44accbe922 = "plugin:settings:set";



let $fbd65e87907bd23e$var$supported;
let $fbd65e87907bd23e$var$perf;
function $fbd65e87907bd23e$export$70d26280bc1ca547() {
    var _a;
    if ($fbd65e87907bd23e$var$supported !== undefined) return $fbd65e87907bd23e$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $fbd65e87907bd23e$var$supported = true;
        $fbd65e87907bd23e$var$perf = window.performance;
    } else if (typeof globalThis !== "undefined" && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $fbd65e87907bd23e$var$supported = true;
        $fbd65e87907bd23e$var$perf = globalThis.perf_hooks.performance;
    } else $fbd65e87907bd23e$var$supported = false;
    return $fbd65e87907bd23e$var$supported;
}
function $fbd65e87907bd23e$export$461939dd4422153() {
    return $fbd65e87907bd23e$export$70d26280bc1ca547() ? $fbd65e87907bd23e$var$perf.now() : Date.now();
}


class $ea36bf607cf38936$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $fbd65e87907bd23e$export$461939dd4422153)();
            }
        };
        if (hook) hook.on((0, $44596e28c79d61f0$export$a0897f44accbe922), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === "on") return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}





function $54c6cb99091f414d$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $a64da22f94f2a1a2$export$c22522a4dfa48e9c)();
    const hook = (0, $a64da22f94f2a1a2$export$5a2d366b2d9f38f6)();
    const enableProxy = (0, $a64da22f94f2a1a2$export$bc32a04c49ed7464) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $44596e28c79d61f0$export$b1499c3bd2a3f4df), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $ea36bf607cf38936$export$5728f3776e9b2ac1)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}


const $55e1179cdae9ffbe$var$isBrowser = typeof window !== "undefined";
function $55e1179cdae9ffbe$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module";
}
const $55e1179cdae9ffbe$var$assign = Object.assign;
function $55e1179cdae9ffbe$var$applyToParams(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $55e1179cdae9ffbe$var$isArray(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $55e1179cdae9ffbe$var$noop = ()=>{};
/**
 * Typesafe alternative to Array.isArray
 * https://github.com/microsoft/TypeScript/pull/48228
 */ const $55e1179cdae9ffbe$var$isArray = Array.isArray;
function $55e1179cdae9ffbe$var$warn(msg) {
    // avoid using ...args as it breaks in older Edge builds
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
const $55e1179cdae9ffbe$var$TRAILING_SLASH_RE = /\/$/;
const $55e1179cdae9ffbe$var$removeTrailingSlash = (path)=>path.replace($55e1179cdae9ffbe$var$TRAILING_SLASH_RE, "");
/**
 * Transforms a URI into a normalized history location
 *
 * @param parseQuery
 * @param location - URI to normalize
 * @param currentLocation - current absolute location. Allows resolving relative
 * paths. Must start with `/`. Defaults to `/`
 * @returns a normalized history location
 */ function $55e1179cdae9ffbe$var$parseURL(parseQuery, location1, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    // Could use URL and URLSearchParams but IE 11 doesn't support it
    // TODO: move to new URL()
    const hashPos = location1.indexOf("#");
    let searchPos = location1.indexOf("?");
    // the hash appears before the search, so it's not part of the search string
    if (hashPos < searchPos && hashPos >= 0) searchPos = -1;
    if (searchPos > -1) {
        path = location1.slice(0, searchPos);
        searchString = location1.slice(searchPos + 1, hashPos > -1 ? hashPos : location1.length);
        query = parseQuery(searchString);
    }
    if (hashPos > -1) {
        path = path || location1.slice(0, hashPos);
        // keep the # character
        hash = location1.slice(hashPos, location1.length);
    }
    // no search and no query
    path = $55e1179cdae9ffbe$var$resolveRelativePath(path != null ? path : location1, currentLocation);
    // empty path means a relative query or hash `?foo=f`, `#thing`
    return {
        fullPath: path + (searchString && "?") + searchString + hash,
        path: path,
        query: query,
        hash: hash
    };
}
/**
 * Stringifies a URL object
 *
 * @param stringifyQuery
 * @param location
 */ function $55e1179cdae9ffbe$var$stringifyURL(stringifyQuery, location1) {
    const query = location1.query ? stringifyQuery(location1.query) : "";
    return location1.path + (query && "?") + query + (location1.hash || "");
}
/**
 * Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
 *
 * @param pathname - location.pathname
 * @param base - base to strip off
 */ function $55e1179cdae9ffbe$var$stripBase(pathname, base) {
    // no base or base is not found at the beginning
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
 * Checks if two RouteLocation are equal. This means that both locations are
 * pointing towards the same {@link RouteRecord} and that all `params`, `query`
 * parameters and `hash` are the same
 *
 * @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
 * @param a - first {@link RouteLocation}
 * @param b - second {@link RouteLocation}
 */ function $55e1179cdae9ffbe$var$isSameRouteLocation(stringifyQuery, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $55e1179cdae9ffbe$var$isSameRouteRecord(a.matched[aLastIndex], b.matched[bLastIndex]) && $55e1179cdae9ffbe$var$isSameRouteLocationParams(a.params, b.params) && stringifyQuery(a.query) === stringifyQuery(b.query) && a.hash === b.hash;
}
/**
 * Check if two `RouteRecords` are equal. Takes into account aliases: they are
 * considered equal to the `RouteRecord` they are aliasing.
 *
 * @param a - first {@link RouteRecord}
 * @param b - second {@link RouteRecord}
 */ function $55e1179cdae9ffbe$var$isSameRouteRecord(a, b) {
    // since the original record has an undefined value for aliasOf
    // but all aliases point to the original record, this will always compare
    // the original record
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $55e1179cdae9ffbe$var$isSameRouteLocationParams(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (!$55e1179cdae9ffbe$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    }
    return true;
}
function $55e1179cdae9ffbe$var$isSameRouteLocationParamsValue(a, b) {
    return $55e1179cdae9ffbe$var$isArray(a) ? $55e1179cdae9ffbe$var$isEquivalentArray(a, b) : $55e1179cdae9ffbe$var$isArray(b) ? $55e1179cdae9ffbe$var$isEquivalentArray(b, a) : a === b;
}
/**
 * Check if two arrays are the same or if an array with one single entry is the
 * same as another primitive value. Used to check query and parameters
 *
 * @param a - array of values
 * @param b - array of values or a single value
 */ function $55e1179cdae9ffbe$var$isEquivalentArray(a, b) {
    return $55e1179cdae9ffbe$var$isArray(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
 * Resolves a relative path that starts with `.`.
 *
 * @param to - path location we are resolving
 * @param from - currentLocation.path, should start with `/`
 */ function $55e1179cdae9ffbe$var$resolveRelativePath(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    // make . and ./ the same (../ === .., ../../ === ../..)
    // this is the same behavior as new URL()
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        // we stay on the same position
        if (segment === ".") continue;
        // go up in the from array
        if (segment === "..") // we can't go below zero, but we still need to increment toPosition
        {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments// ensure we use at least the last element in the toSegments
    .slice(toPosition - (toPosition === toSegments.length ? 1 : 0)).join("/");
}
var $55e1179cdae9ffbe$var$NavigationType;
(function(NavigationType) {
    NavigationType["pop"] = "pop";
    NavigationType["push"] = "push";
})($55e1179cdae9ffbe$var$NavigationType || ($55e1179cdae9ffbe$var$NavigationType = {}));
var $55e1179cdae9ffbe$var$NavigationDirection;
(function(NavigationDirection) {
    NavigationDirection["back"] = "back";
    NavigationDirection["forward"] = "forward";
    NavigationDirection["unknown"] = "";
})($55e1179cdae9ffbe$var$NavigationDirection || ($55e1179cdae9ffbe$var$NavigationDirection = {}));
/**
 * Starting location for Histories
 */ const $55e1179cdae9ffbe$var$START = "";
// Generic utils
/**
 * Normalizes a base by removing any trailing slash and reading the base tag if
 * present.
 *
 * @param base - base to normalize
 */ function $55e1179cdae9ffbe$var$normalizeBase(base) {
    if (!base) {
        if ($55e1179cdae9ffbe$var$isBrowser) {
            // respect <base> tag
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            // strip full URL origin
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    // ensure leading slash when it was removed by the regex above avoid leading
    // slash with hash because the file could be read from the disk like file://
    // and the leading slash would cause problems
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    // remove the trailing slash so all other method can just do `base + fullPath`
    // to build an href
    return $55e1179cdae9ffbe$var$removeTrailingSlash(base);
}
// remove any character before the hash
const $55e1179cdae9ffbe$var$BEFORE_HASH_RE = /^[^#]+#/;
function $55e1179cdae9ffbe$var$createHref(base, location1) {
    return base.replace($55e1179cdae9ffbe$var$BEFORE_HASH_RE, "#") + location1;
}
function $55e1179cdae9ffbe$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $55e1179cdae9ffbe$var$computeScrollPosition = ()=>({
        left: window.pageXOffset,
        top: window.pageYOffset
    });
function $55e1179cdae9ffbe$var$scrollToPosition(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $55e1179cdae9ffbe$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.pageXOffset, scrollToOptions.top != null ? scrollToOptions.top : window.pageYOffset);
}
function $55e1179cdae9ffbe$var$getScrollKey(path, delta) {
    const position = history.state ? history.state.position - delta : -1;
    return position + path;
}
const $55e1179cdae9ffbe$var$scrollPositions = new Map();
function $55e1179cdae9ffbe$var$saveScrollPosition(key, scrollPosition) {
    $55e1179cdae9ffbe$var$scrollPositions.set(key, scrollPosition);
}
function $55e1179cdae9ffbe$var$getSavedScrollPosition(key) {
    const scroll = $55e1179cdae9ffbe$var$scrollPositions.get(key);
    // consume it so it's not used again
    $55e1179cdae9ffbe$var$scrollPositions.delete(key);
    return scroll;
}
// TODO: RFC about how to save scroll position
/**
 * ScrollBehavior instance used by the router to compute and restore the scroll
 * position when navigating.
 */ // export interface ScrollHandler<ScrollPositionEntry extends HistoryStateValue, ScrollPosition extends ScrollPositionEntry> {
//   // returns a scroll position that can be saved in history
//   compute(): ScrollPositionEntry
//   // can take an extended ScrollPositionEntry
//   scroll(position: ScrollPosition): void
// }
// export const scrollHandler: ScrollHandler<ScrollPosition> = {
//   compute: computeScroll,
//   scroll: scrollToPosition,
// }
let $55e1179cdae9ffbe$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
 * Creates a normalized history location from a window.location object
 * @param base - The base path
 * @param location - The window.location object
 */ function $55e1179cdae9ffbe$var$createCurrentLocation(base, location1) {
    const { pathname: pathname, search: search, hash: hash } = location1;
    // allows hash bases like #, /#, #/, #!, #!/, /#!/, or even /folder#end
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        // prepend the starting slash to hash so the url starts with /#
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return $55e1179cdae9ffbe$var$stripBase(pathFromHash, "");
    }
    const path = $55e1179cdae9ffbe$var$stripBase(pathname, base);
    return path + search + hash;
}
function $55e1179cdae9ffbe$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    // TODO: should it be a stack? a Dict. Check if the popstate listener
    // can trigger twice
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $55e1179cdae9ffbe$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            // ignore the popstate and reset the pauseState
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        // Here we could also revert the navigation by calling history.go(-delta)
        // this listener will have to be adapted to not trigger again and to wait for the url
        // to be updated before triggering the listeners. Some kind of validation function would also
        // need to be passed to the listeners so the navigation can be accepted
        // call all listeners
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: $55e1179cdae9ffbe$var$NavigationType.pop,
                direction: delta ? delta > 0 ? $55e1179cdae9ffbe$var$NavigationDirection.forward : $55e1179cdae9ffbe$var$NavigationDirection.back : $55e1179cdae9ffbe$var$NavigationDirection.unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        // set up the listener and prepare teardown callbacks
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        const { history: history1 } = window;
        if (!history1.state) return;
        history1.replaceState($55e1179cdae9ffbe$var$assign({}, history1.state, {
            scroll: $55e1179cdae9ffbe$var$computeScrollPosition()
        }), "");
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("beforeunload", beforeUnloadListener);
    }
    // set up the listeners and prepare teardown callbacks
    window.addEventListener("popstate", popStateHandler);
    // TODO: could we use 'pagehide' or 'visibilitychange' instead?
    // https://developer.chrome.com/blog/page-lifecycle-api/
    window.addEventListener("beforeunload", beforeUnloadListener, {
        passive: true
    });
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
 * Creates a state object
 */ function $55e1179cdae9ffbe$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? $55e1179cdae9ffbe$var$computeScrollPosition() : null
    };
}
function $55e1179cdae9ffbe$var$useHistoryStateNavigation(base) {
    const { history: history1, location: location1 } = window;
    // private variables
    const currentLocation = {
        value: $55e1179cdae9ffbe$var$createCurrentLocation(base, location1)
    };
    const historyState = {
        value: history1.state
    };
    // build current history entry as this is a fresh navigation
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        // the length is off by one, we need to decrease it
        position: history1.length - 1,
        replaced: true,
        // don't add a scroll as the user may have an anchor, and we want
        // scrollBehavior to be triggered without a saved position
        scroll: null
    }, true);
    function changeLocation(to, state, replace) {
        /**
         * if a base tag is provided, and we are on a normal domain, we have to
         * respect the provided `base` attribute because pushState() will use it and
         * potentially erase anything before the `#` like at
         * https://github.com/vuejs/router/issues/685 where a base of
         * `/folder/#` but a base of `/` would erase the `/folder/` section. If
         * there is no host, the `<base>` tag makes no sense and if there isn't a
         * base tag we can just use everything after the `#`.
         */ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $55e1179cdae9ffbe$var$createBaseLocation() + base + to;
        try {
            // BROWSER QUIRK
            // NOTE: Safari throws a SecurityError when calling this function 100 times in 30 seconds
            history1[replace ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            // Force the navigation, this also resets the call count
            location1[replace ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        const state = $55e1179cdae9ffbe$var$assign({}, history1.state, $55e1179cdae9ffbe$var$buildState(historyState.value.back, // keep back and forward entries but override current position
        to, historyState.value.forward, true), data, {
            position: historyState.value.position
        });
        changeLocation(to, state, true);
        currentLocation.value = to;
    }
    function push(to, data) {
        // Add to current entry the information of where we are going
        // as well as saving the current position
        const currentState = $55e1179cdae9ffbe$var$assign({}, // use current history state to gracefully handle a wrong call to
        // history.replaceState
        // https://github.com/vuejs/router/issues/366
        historyState.value, history1.state, {
            forward: to,
            scroll: $55e1179cdae9ffbe$var$computeScrollPosition()
        });
        changeLocation(currentState.current, currentState, true);
        const state = $55e1179cdae9ffbe$var$assign({}, $55e1179cdae9ffbe$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data);
        changeLocation(to, state, false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
 * Creates an HTML5 history. Most common history for single page applications.
 *
 * @param base -
 */ function $55e1179cdae9ffbe$export$7b4942f78e7b8a49(base) {
    base = $55e1179cdae9ffbe$var$normalizeBase(base);
    const historyNavigation = $55e1179cdae9ffbe$var$useHistoryStateNavigation(base);
    const historyListeners = $55e1179cdae9ffbe$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = $55e1179cdae9ffbe$var$assign({
        // it's overridden right after
        location: "",
        base: base,
        go: go,
        createHref: $55e1179cdae9ffbe$var$createHref.bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
/**
 * Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
 * It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
 *
 * @param base - Base applied to all urls, defaults to '/'
 * @returns a history object that can be passed to the router constructor
 */ function $55e1179cdae9ffbe$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        $55e1179cdae9ffbe$var$START
    ];
    let position = 0;
    base = $55e1179cdae9ffbe$var$normalizeBase(base);
    function setLocation(location1) {
        position++;
        if (position !== queue.length) // we are in the middle, we remove everything from here in the queue
        queue.splice(position);
        queue.push(location1);
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: $55e1179cdae9ffbe$var$NavigationType.pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        // rewritten by Object.defineProperty
        location: $55e1179cdae9ffbe$var$START,
        // TODO: should be kept in queue
        state: {},
        base: base,
        createHref: $55e1179cdae9ffbe$var$createHref.bind(null, base),
        replace (to) {
            // remove current entry and decrement position
            queue.splice(position--, 1);
            setLocation(to);
        },
        push (to, data) {
            setLocation(to);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                $55e1179cdae9ffbe$var$START
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = // we are considering delta === 0 going forward, but in abstract mode
            // using 0 for the delta doesn't make sense like it does in html5 where
            // it reloads the page
            delta < 0 ? $55e1179cdae9ffbe$var$NavigationDirection.back : $55e1179cdae9ffbe$var$NavigationDirection.forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position]
    });
    return routerHistory;
}
/**
 * Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
 * handle any URL is not possible.
 *
 * @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
 * in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
 * calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
 * after the `#`).
 *
 * @example
 * ```js
 * // at https://example.com/folder
 * createWebHashHistory() // gives a url of `https://example.com/folder#`
 * createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
 * // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
 * createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
 * // you should avoid doing this because it changes the original url and breaks copying urls
 * createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
 *
 * // at file:///usr/etc/folder/index.html
 * // for locations with no `host`, the base is ignored
 * createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
 * ```
 */ function $55e1179cdae9ffbe$export$542bc3a76486c94d(base) {
    // Make sure this implementation is fine in terms of encoding, specially for IE11
    // for `file://`, directly use the pathname and ignore the base
    // location.pathname contains an initial `/` even at the root: `https://example.com`
    base = location.host ? base || location.pathname + location.search : "";
    // allow the user to provide a `#` in the middle: `/base/#/app`
    if (!base.includes("#")) base += "#";
    return $55e1179cdae9ffbe$export$7b4942f78e7b8a49(base);
}
function $55e1179cdae9ffbe$var$isRouteLocation(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $55e1179cdae9ffbe$var$isRouteName(name) {
    return typeof name === "string" || typeof name === "symbol";
}
/**
 * Initial route location where the router is. Can be used in navigation guards
 * to differentiate the initial navigation.
 *
 * @example
 * ```js
 * import { START_LOCATION } from 'vue-router'
 *
 * router.beforeEach((to, from) => {
 *   if (from === START_LOCATION) {
 *     // initial navigation
 *   }
 * })
 * ```
 */ const $55e1179cdae9ffbe$export$e44be9a9779c480b = {
    path: "/",
    name: undefined,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: undefined
};
const $55e1179cdae9ffbe$var$NavigationFailureSymbol = Symbol("");
/**
 * Enumeration with all possible types for navigation failures. Can be passed to
 * {@link isNavigationFailure} to check for specific failures.
 */ var $55e1179cdae9ffbe$export$35710516f95d6a57;
(function(NavigationFailureType) {
    /**
     * An aborted navigation is a navigation that failed because a navigation
     * guard returned `false` or called `next(false)`
     */ NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
     * A cancelled navigation is a navigation that failed because a more recent
     * navigation finished started (not necessarily finished).
     */ NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
     * A duplicated navigation is a navigation that failed because it was
     * initiated while already being at the exact same location.
     */ NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
})($55e1179cdae9ffbe$export$35710516f95d6a57 || ($55e1179cdae9ffbe$export$35710516f95d6a57 = {}));
// DEV only debug messages
const $55e1179cdae9ffbe$var$ErrorTypeMessages = {
    [1 /* ErrorTypes.MATCHER_NOT_FOUND */ ] ({ location: location1, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location1)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$55e1179cdae9ffbe$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [4 /* ErrorTypes.NAVIGATION_ABORTED */ ] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [8 /* ErrorTypes.NAVIGATION_CANCELLED */ ] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [16 /* ErrorTypes.NAVIGATION_DUPLICATED */ ] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
function $55e1179cdae9ffbe$var$createRouterError(type, params) {
    return $55e1179cdae9ffbe$var$assign(new Error(), {
        type: type,
        [$55e1179cdae9ffbe$var$NavigationFailureSymbol]: true
    }, params);
}
function $55e1179cdae9ffbe$export$873de56207a30e5a(error, type) {
    return error instanceof Error && $55e1179cdae9ffbe$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $55e1179cdae9ffbe$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $55e1179cdae9ffbe$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if ("path" in to) return to.path;
    const location1 = {};
    for (const key of $55e1179cdae9ffbe$var$propertiesToLog)if (key in to) location1[key] = to[key];
    return JSON.stringify(location1, null, 2);
}
// default pattern for a param: non-greedy everything but /
const $55e1179cdae9ffbe$var$BASE_PARAM_PATTERN = "[^/]+?";
const $55e1179cdae9ffbe$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
// Special Regex characters that must be escaped in static tokens
const $55e1179cdae9ffbe$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
 * Creates a path parser from an array of Segments (a segment is an array of Tokens)
 *
 * @param segments - array of segments returned by tokenizePath
 * @param extraOptions - optional options for the regexp
 * @returns a PathParser
 */ function $55e1179cdae9ffbe$var$tokensToParser(segments, extraOptions) {
    const options = $55e1179cdae9ffbe$var$assign({}, $55e1179cdae9ffbe$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    // the amount of scores is the same as the length of segments except for the root segment "/"
    const score = [];
    // the regexp as a string
    let pattern = options.start ? "^" : "";
    // extracted keys
    const keys = [];
    for (const segment of segments){
        // the root segment needs special treatment
        const segmentScores = segment.length ? [] : [
            90 /* PathScore.Root */ 
        ];
        // allow trailing slash
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            // resets the score if we are inside a sub-segment /:a-other-:b
            let subSegmentScore = 40 /* PathScore.Segment */  + (options.sensitive ? 0.25 /* PathScore.BonusCaseSensitive */  : 0);
            if (token.type === 0 /* TokenType.Static */ ) {
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($55e1179cdae9ffbe$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += 40 /* PathScore.Static */ ;
            } else if (token.type === 1 /* TokenType.Param */ ) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re = regexp ? regexp : $55e1179cdae9ffbe$var$BASE_PARAM_PATTERN;
                // the user provided a custom regexp /:id(\\d+)
                if (re !== $55e1179cdae9ffbe$var$BASE_PARAM_PATTERN) {
                    subSegmentScore += 10 /* PathScore.BonusCustomRegExp */ ;
                    // make sure the regexp is valid before using it
                    try {
                        new RegExp(`(${re})`);
                    } catch (err) {
                        throw new Error(`Invalid custom RegExp for param "${value}" (${re}): ` + err.message);
                    }
                }
                // when we repeat we must take care of the repeating leading slash
                let subPattern = repeatable ? `((?:${re})(?:/(?:${re}))*)` : `(${re})`;
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) subPattern = // avoid an optional / if there are more segments e.g. /:p?-static
                // or /:p?-:p2
                optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += 20 /* PathScore.Dynamic */ ;
                if (optional) subSegmentScore += -8 /* PathScore.BonusOptional */ ;
                if (repeatable) subSegmentScore += -20 /* PathScore.BonusRepeatable */ ;
                if (re === ".*") subSegmentScore += -50 /* PathScore.BonusWildcard */ ;
            }
            segmentScores.push(subSegmentScore);
        }
        // an empty array like /home/ -> [[{home}], []]
        // if (!segment.length) pattern += '/'
        score.push(segmentScores);
    }
    // only apply the strict bonus to the last score
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += 0.7000000000000001 /* PathScore.BonusStrict */ ;
    }
    // TODO: dev only warn double trailing slash
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        // for optional parameters to allow to be empty
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment){
                if (token.type === 0 /* TokenType.Static */ ) path += token.value;
                else if (token.type === 1 /* TokenType.Param */ ) {
                    const { value: value, repeatable: repeatable, optional: optional } = token;
                    const param = value in params ? params[value] : "";
                    if ($55e1179cdae9ffbe$var$isArray(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                    const text = $55e1179cdae9ffbe$var$isArray(param) ? param.join("/") : param;
                    if (!text) {
                        if (optional) // if we have more than one optional param like /:a?-static we don't need to care about the optional param
                        {
                            if (segment.length < 2) {
                                // remove the last slash as we could be at the end
                                if (path.endsWith("/")) path = path.slice(0, -1);
                                else avoidDuplicatedSlash = true;
                            }
                        } else throw new Error(`Missing required param "${value}"`);
                    }
                    path += text;
                }
            }
        }
        // avoid empty path when we have multiple optional params
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
 * Compares an array of numbers as used in PathParser.score and returns a
 * number. This function can be used to `sort` an array
 *
 * @param a - first array of numbers
 * @param b - second array of numbers
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 * should be sorted first
 */ function $55e1179cdae9ffbe$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        // only keep going if diff === 0
        if (diff) return diff;
        i++;
    }
    // if the last subsegment was Static, the shorter segments should be sorted first
    // otherwise sort the longest segment first
    if (a.length < b.length) return a.length === 1 && a[0] === 80 /* PathScore.Segment */  ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === 80 /* PathScore.Segment */  ? 1 : -1;
    return 0;
}
/**
 * Compare function that can be used with `sort` to sort an array of PathParser
 *
 * @param a - first PathParser
 * @param b - second PathParser
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 */ function $55e1179cdae9ffbe$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $55e1179cdae9ffbe$var$compareScoreArray(aScore[i], bScore[i]);
        // do not return if both are equal
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($55e1179cdae9ffbe$var$isLastScoreNegative(aScore)) return 1;
        if ($55e1179cdae9ffbe$var$isLastScoreNegative(bScore)) return -1;
    }
    // if a and b share the same score entries but b has more, sort b first
    return bScore.length - aScore.length;
// this is the ternary version
// return aScore.length < bScore.length
//   ? 1
//   : aScore.length > bScore.length
//   ? -1
//   : 0
}
/**
 * This allows detecting splats at the end of a path: /home/:id(.*)*
 *
 * @param score - score to check
 * @returns true if the last entry is negative
 */ function $55e1179cdae9ffbe$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $55e1179cdae9ffbe$var$ROOT_TOKEN = {
    type: 0 /* TokenType.Static */ ,
    value: ""
};
const $55e1179cdae9ffbe$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
// After some profiling, the cache seems to be unnecessary because tokenizePath
// (the slowest part of adding a route) is very fast
// const tokenCache = new Map<string, Token[][]>()
function $55e1179cdae9ffbe$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $55e1179cdae9ffbe$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error(`Invalid path "${path}"`);
    // if (tokenCache.has(path)) return tokenCache.get(path)!
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = 0 /* TokenizerState.Static */ ;
    let previousState = state;
    const tokens = [];
    // the segment will always be valid because we get into the initial state
    // with the leading /
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    // index on the path
    let i = 0;
    // char at index
    let char;
    // buffer of the value read
    let buffer = "";
    // custom regexp for a param
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === 0 /* TokenizerState.Static */ ) segment.push({
            type: 0 /* TokenType.Static */ ,
            value: buffer
        });
        else if (state === 1 /* TokenizerState.Param */  || state === 2 /* TokenizerState.ParamRegExp */  || state === 3 /* TokenizerState.ParamRegExpEnd */ ) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: 1 /* TokenType.Param */ ,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== 2 /* TokenizerState.ParamRegExp */ ) {
            previousState = state;
            state = 4 /* TokenizerState.EscapeNext */ ;
            continue;
        }
        switch(state){
            case 0 /* TokenizerState.Static */ :
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = 1 /* TokenizerState.Param */ ;
                } else addCharToBuffer();
                break;
            case 4 /* TokenizerState.EscapeNext */ :
                addCharToBuffer();
                state = previousState;
                break;
            case 1 /* TokenizerState.Param */ :
                if (char === "(") state = 2 /* TokenizerState.ParamRegExp */ ;
                else if ($55e1179cdae9ffbe$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = 0 /* TokenizerState.Static */ ;
                    // go back one character if we were not modifying
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case 2 /* TokenizerState.ParamRegExp */ :
                // TODO: is it worth handling nested regexp? like :p(?:prefix_([^/]+)_suffix)
                // it already works by escaping the closing )
                // https://paths.esm.dev/?p=AAMeJbiAwQEcDKbAoAAkP60PG2R6QAvgNaA6AFACM2ABuQBB#
                // is this really something people need since you can also write
                // /prefix_:p()_suffix
                if (char === ")") {
                    // handle the escaped )
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = 3 /* TokenizerState.ParamRegExpEnd */ ;
                } else customRe += char;
                break;
            case 3 /* TokenizerState.ParamRegExpEnd */ :
                // same as finalizing a param
                consumeBuffer();
                state = 0 /* TokenizerState.Static */ ;
                // go back one character if we were not modifying
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === 2 /* TokenizerState.ParamRegExp */ ) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    // tokenCache.set(path, tokens)
    return tokens;
}
function $55e1179cdae9ffbe$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $55e1179cdae9ffbe$var$tokensToParser($55e1179cdae9ffbe$var$tokenizePath(record.path), options);
    const matcher = $55e1179cdae9ffbe$var$assign(parser, {
        record: record,
        parent: parent,
        // these needs to be populated by the parent
        children: [],
        alias: []
    });
    if (parent) // both are aliases or both are not aliases
    // we don't want to mix them because the order is used when
    // passing originalRecord in Matcher.addRoute
    {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
/**
 * Creates a Router Matcher.
 *
 * @internal
 * @param routes - array of initial routes
 * @param globalOptions - global route options
 */ function $55e1179cdae9ffbe$export$36302c85fdcc95a8(routes, globalOptions) {
    // normalized ordered array of matchers
    const matchers = [];
    const matcherMap = new Map();
    globalOptions = $55e1179cdae9ffbe$var$mergeOptions({
        strict: false,
        end: true,
        sensitive: false
    }, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        // used later on to remove by name
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $55e1179cdae9ffbe$var$normalizeRouteRecord(record);
        // we might be the child of an alias
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = $55e1179cdae9ffbe$var$mergeOptions(globalOptions, record);
        // generate an array of records to correctly handle aliases
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($55e1179cdae9ffbe$var$assign({}, mainNormalizedRecord, {
                // this allows us to hold a copy of the `components` option
                // so that async components cache is hold on the original record
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                // we might be the child of an alias
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            }));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            // Build up the path for nested routes if the child isn't an absolute
            // route. Only add the / delimiter if the child path isn't empty and if the
            // parent path doesn't have a trailing slash
            if (parent && path[0] !== "/") {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            // create the object beforehand, so it can be passed to children
            matcher = $55e1179cdae9ffbe$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            // if we are an alias we must tell the original record that we exist,
            // so we can be removed
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                // otherwise, the first record is the original and others are aliases
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                // remove the route if named and only for the top record (avoid in nested calls)
                // this works because the original record is the first one
                if (isRootAdd && record.name && !$55e1179cdae9ffbe$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            // if there was no original record, then the first one was not an alias and all
            // other aliases (if any) need to reference this record when adding children
            originalRecord = originalRecord || matcher;
            // TODO: add normalized records for more flexibility
            // if (parent && isAliasRecord(originalRecord)) {
            //   parent.children.push(originalRecord)
            // }
            // Avoid adding a record that doesn't display anything. This allows passing through records without a component to
            // not be reached and pass through the catch all route
            if (matcher.record.components && Object.keys(matcher.record.components).length || matcher.record.name || matcher.record.redirect) insertMatcher(matcher);
        }
        return originalMatcher ? ()=>{
            // since other matchers are aliases, they should be removed by the original matcher
            removeRoute(originalMatcher);
        } : $55e1179cdae9ffbe$var$noop;
    }
    function removeRoute(matcherRef) {
        if ($55e1179cdae9ffbe$var$isRouteName(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        let i = 0;
        while(i < matchers.length && $55e1179cdae9ffbe$var$comparePathParserScore(matcher, matchers[i]) >= 0 && // Adding children with empty path should still appear before the parent
        // https://github.com/vuejs/router/issues/1124
        (matcher.record.path !== matchers[i].record.path || !$55e1179cdae9ffbe$var$isRecordChildOf(matcher, matchers[i])))i++;
        matchers.splice(i, 0, matcher);
        // only add the original record to the name map
        if (matcher.record.name && !$55e1179cdae9ffbe$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location1 && location1.name) {
            matcher = matcherMap.get(location1.name);
            if (!matcher) throw $55e1179cdae9ffbe$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1
            });
            name = matcher.record.name;
            params = $55e1179cdae9ffbe$var$assign(// paramsFromLocation is a new object
            $55e1179cdae9ffbe$var$paramsFromLocation(currentLocation.params, // only keep params that exist in the resolved location
            // TODO: only keep optional params coming from a parent record
            matcher.keys.filter((k)=>!k.optional).map((k)=>k.name)), // discard any existing params in the current location that do not exist here
            // #1497 this ensures better active/exact matching
            location1.params && $55e1179cdae9ffbe$var$paramsFromLocation(location1.params, matcher.keys.map((k)=>k.name)));
            // throws if cannot be stringified
            path = matcher.stringify(params);
        } else if ("path" in location1) {
            // no need to resolve the path with the matcher as it was provided
            // this also allows the user to control the encoding
            path = location1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            // matcher should have a value after the loop
            if (matcher) {
                // we know the matcher works because we tested the regexp
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        // location is a relative path
        } else {
            // match by name or path of current route
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw $55e1179cdae9ffbe$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            // since we are navigating to the same location, we don't need to pick the
            // params like when `name` is provided
            params = $55e1179cdae9ffbe$var$assign({}, currentLocation.params, location1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            // reversed order so parents are at the beginning
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $55e1179cdae9ffbe$var$mergeMetaFields(matched)
        };
    }
    // add initial routes
    routes.forEach((route)=>addRoute(route));
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
function $55e1179cdae9ffbe$var$paramsFromLocation(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
 * Normalizes a RouteRecordRaw. Creates a copy
 *
 * @param record
 * @returns the normalized version
 */ function $55e1179cdae9ffbe$var$normalizeRouteRecord(record) {
    return {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: undefined,
        beforeEnter: record.beforeEnter,
        props: $55e1179cdae9ffbe$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: new Set(),
        updateGuards: new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
}
/**
 * Normalize the optional `props` in a record to always be an object similar to
 * components. Also accept a boolean for components.
 * @param record
 */ function $55e1179cdae9ffbe$var$normalizeRecordProps(record) {
    const propsObject = {};
    // props does not exist on redirect records, but we can set false directly
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else // NOTE: we could also allow a function to be applied to every component.
    // Would need user feedback for use cases
    for(const name in record.components)propsObject[name] = typeof props === "object" ? props[name] : props;
    return propsObject;
}
/**
 * Checks if a record or any of its parent is an alias
 * @param record
 */ function $55e1179cdae9ffbe$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
 * Merge meta fields of an array of records
 *
 * @param matched - array of matched records
 */ function $55e1179cdae9ffbe$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>$55e1179cdae9ffbe$var$assign(meta, record.meta), {});
}
function $55e1179cdae9ffbe$var$mergeOptions(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
function $55e1179cdae9ffbe$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
 * Check if a path and its alias have the same required params
 *
 * @param a - original record
 * @param b - alias record
 */ function $55e1179cdae9ffbe$var$checkSameParams(a, b) {
    for (const key of a.keys){
        if (!key.optional && !b.keys.find($55e1179cdae9ffbe$var$isSameParam.bind(null, key))) return $55e1179cdae9ffbe$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
    for (const key of b.keys){
        if (!key.optional && !a.keys.find($55e1179cdae9ffbe$var$isSameParam.bind(null, key))) return $55e1179cdae9ffbe$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
}
/**
 * A route with a name and a child with an empty path without a name should warn when adding the route
 *
 * @param mainNormalizedRecord - RouteRecordNormalized
 * @param parent - RouteRecordMatcher
 */ function $55e1179cdae9ffbe$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) $55e1179cdae9ffbe$var$warn(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $55e1179cdae9ffbe$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys){
        if (!record.keys.find($55e1179cdae9ffbe$var$isSameParam.bind(null, key))) return $55e1179cdae9ffbe$var$warn(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
    }
}
function $55e1179cdae9ffbe$var$isRecordChildOf(record, parent) {
    return parent.children.some((child)=>child === record || $55e1179cdae9ffbe$var$isRecordChildOf(record, child));
}
/**
 * Encoding Rules ␣ = Space Path: ␣ " < > # ? { } Query: ␣ " < > # & = Hash: ␣ "
 * < > `
 *
 * On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
 * defines some extra characters to be encoded. Most browsers do not encode them
 * in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
 * also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
 * plus `-._~`. This extra safety should be applied to query by patching the
 * string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
 * should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
 * into a `/` if directly typed in. The _backtick_ (`````) should also be
 * encoded everywhere because some browsers like FF encode it when directly
 * written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
 */ // const EXTRA_RESERVED_RE = /[!'()*]/g
// const encodeReservedReplacer = (c: string) => '%' + c.charCodeAt(0).toString(16)
const $55e1179cdae9ffbe$var$HASH_RE = /#/g; // %23
const $55e1179cdae9ffbe$var$AMPERSAND_RE = /&/g; // %26
const $55e1179cdae9ffbe$var$SLASH_RE = /\//g; // %2F
const $55e1179cdae9ffbe$var$EQUAL_RE = /=/g; // %3D
const $55e1179cdae9ffbe$var$IM_RE = /\?/g; // %3F
const $55e1179cdae9ffbe$var$PLUS_RE = /\+/g; // %2B
/**
 * NOTE: It's not clear to me if we should encode the + symbol in queries, it
 * seems to be less flexible than not doing so and I can't find out the legacy
 * systems requiring this for regular requests like text/html. In the standard,
 * the encoding of the plus character is only mentioned for
 * application/x-www-form-urlencoded
 * (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
 * leave the plus character as is in queries. To be more flexible, we allow the
 * plus character on the query, but it can also be manually encoded by the user.
 *
 * Resources:
 * - https://url.spec.whatwg.org/#urlencoded-parsing
 * - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
 */ const $55e1179cdae9ffbe$var$ENC_BRACKET_OPEN_RE = /%5B/g; // [
const $55e1179cdae9ffbe$var$ENC_BRACKET_CLOSE_RE = /%5D/g; // ]
const $55e1179cdae9ffbe$var$ENC_CARET_RE = /%5E/g; // ^
const $55e1179cdae9ffbe$var$ENC_BACKTICK_RE = /%60/g; // `
const $55e1179cdae9ffbe$var$ENC_CURLY_OPEN_RE = /%7B/g; // {
const $55e1179cdae9ffbe$var$ENC_PIPE_RE = /%7C/g; // |
const $55e1179cdae9ffbe$var$ENC_CURLY_CLOSE_RE = /%7D/g; // }
const $55e1179cdae9ffbe$var$ENC_SPACE_RE = /%20/g; // }
/**
 * Encode characters that need to be encoded on the path, search and hash
 * sections of the URL.
 *
 * @internal
 * @param text - string to encode
 * @returns encoded string
 */ function $55e1179cdae9ffbe$var$commonEncode(text) {
    return encodeURI("" + text).replace($55e1179cdae9ffbe$var$ENC_PIPE_RE, "|").replace($55e1179cdae9ffbe$var$ENC_BRACKET_OPEN_RE, "[").replace($55e1179cdae9ffbe$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
 * Encode characters that need to be encoded on the hash section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $55e1179cdae9ffbe$var$encodeHash(text) {
    return $55e1179cdae9ffbe$var$commonEncode(text).replace($55e1179cdae9ffbe$var$ENC_CURLY_OPEN_RE, "{").replace($55e1179cdae9ffbe$var$ENC_CURLY_CLOSE_RE, "}").replace($55e1179cdae9ffbe$var$ENC_CARET_RE, "^");
}
/**
 * Encode characters that need to be encoded query values on the query
 * section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $55e1179cdae9ffbe$var$encodeQueryValue(text) {
    return $55e1179cdae9ffbe$var$commonEncode(text)// Encode the space as +, encode the + to differentiate it from the space
    .replace($55e1179cdae9ffbe$var$PLUS_RE, "%2B").replace($55e1179cdae9ffbe$var$ENC_SPACE_RE, "+").replace($55e1179cdae9ffbe$var$HASH_RE, "%23").replace($55e1179cdae9ffbe$var$AMPERSAND_RE, "%26").replace($55e1179cdae9ffbe$var$ENC_BACKTICK_RE, "`").replace($55e1179cdae9ffbe$var$ENC_CURLY_OPEN_RE, "{").replace($55e1179cdae9ffbe$var$ENC_CURLY_CLOSE_RE, "}").replace($55e1179cdae9ffbe$var$ENC_CARET_RE, "^");
}
/**
 * Like `encodeQueryValue` but also encodes the `=` character.
 *
 * @param text - string to encode
 */ function $55e1179cdae9ffbe$var$encodeQueryKey(text) {
    return $55e1179cdae9ffbe$var$encodeQueryValue(text).replace($55e1179cdae9ffbe$var$EQUAL_RE, "%3D");
}
/**
 * Encode characters that need to be encoded on the path section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $55e1179cdae9ffbe$var$encodePath(text) {
    return $55e1179cdae9ffbe$var$commonEncode(text).replace($55e1179cdae9ffbe$var$HASH_RE, "%23").replace($55e1179cdae9ffbe$var$IM_RE, "%3F");
}
/**
 * Encode characters that need to be encoded on the path section of the URL as a
 * param. This function encodes everything {@link encodePath} does plus the
 * slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
 * string instead.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $55e1179cdae9ffbe$var$encodeParam(text) {
    return text == null ? "" : $55e1179cdae9ffbe$var$encodePath(text).replace($55e1179cdae9ffbe$var$SLASH_RE, "%2F");
}
/**
 * Decode text using `decodeURIComponent`. Returns the original text if it
 * fails.
 *
 * @param text - string to decode
 * @returns decoded string
 */ function $55e1179cdae9ffbe$var$decode(text) {
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
/**
 * Transforms a queryString into a {@link LocationQuery} object. Accept both, a
 * version with the leading `?` and without Should work as URLSearchParams

 * @internal
 *
 * @param search - search string to parse
 * @returns a query object
 */ function $55e1179cdae9ffbe$export$1e8473eaf75b0d10(search) {
    const query = {};
    // avoid creating an object with an empty key and empty value
    // because of split('&')
    if (search === "" || search === "?") return query;
    const hasLeadingIM = search[0] === "?";
    const searchParams = (hasLeadingIM ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        // pre decode the + into space
        const searchParam = searchParams[i].replace($55e1179cdae9ffbe$var$PLUS_RE, " ");
        // allow the = character
        const eqPos = searchParam.indexOf("=");
        const key = $55e1179cdae9ffbe$var$decode(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $55e1179cdae9ffbe$var$decode(searchParam.slice(eqPos + 1));
        if (key in query) {
            // an extra variable for ts types
            let currentValue = query[key];
            if (!$55e1179cdae9ffbe$var$isArray(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
 * Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
 * doesn't prepend a `?`
 *
 * @internal
 *
 * @param query - query object to stringify
 * @returns string version of the query without the leading `?`
 */ function $55e1179cdae9ffbe$export$d33b45a8f796a30(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $55e1179cdae9ffbe$var$encodeQueryKey(key);
        if (value == null) {
            // only null adds the value
            if (value !== undefined) search += (search.length ? "&" : "") + key;
            continue;
        }
        // keep null values
        const values = $55e1179cdae9ffbe$var$isArray(value) ? value.map((v)=>v && $55e1179cdae9ffbe$var$encodeQueryValue(v)) : [
            value && $55e1179cdae9ffbe$var$encodeQueryValue(value)
        ];
        values.forEach((value)=>{
            // skip undefined values in arrays as if they were not present
            // smaller code than using filter
            if (value !== undefined) {
                // only append & with non-empty search
                search += (search.length ? "&" : "") + key;
                if (value != null) search += "=" + value;
            }
        });
    }
    return search;
}
/**
 * Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
 * numbers into strings, removing keys with an undefined value and replacing
 * undefined with null in arrays
 *
 * @param query - query object to normalize
 * @returns a normalized query object
 */ function $55e1179cdae9ffbe$var$normalizeQuery(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== undefined) normalizedQuery[key] = $55e1179cdae9ffbe$var$isArray(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
/**
 * RouteRecord being rendered by the closest ancestor Router View. Used for
 * `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
 * Location Matched
 *
 * @internal
 */ const $55e1179cdae9ffbe$export$7f4879db1558672d = Symbol("");
/**
 * Allows overriding the router view depth to control which component in
 * `matched` is rendered. rvd stands for Router View Depth
 *
 * @internal
 */ const $55e1179cdae9ffbe$export$9b3825c34ca1427a = Symbol("");
/**
 * Allows overriding the router instance returned by `useRouter` in tests. r
 * stands for router
 *
 * @internal
 */ const $55e1179cdae9ffbe$export$b6c0da8b9dae491f = Symbol("");
/**
 * Allows overriding the current route returned by `useRoute` in tests. rl
 * stands for route location
 *
 * @internal
 */ const $55e1179cdae9ffbe$export$3aca783e9a3e6e9e = Symbol("");
/**
 * Allows overriding the current route used by router-view. Internally this is
 * used when the `route` prop is passed.
 *
 * @internal
 */ const $55e1179cdae9ffbe$export$54c8124bead129f8 = Symbol("");
/**
 * Create a list of callbacks that can be reset. Used to create before and after navigation guards list
 */ function $55e1179cdae9ffbe$var$useCallbacks() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
function $55e1179cdae9ffbe$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $1vQIy.onUnmounted)(removeFromList);
    (0, $1vQIy.onDeactivated)(removeFromList);
    (0, $1vQIy.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
 * Add a navigation guard that triggers whenever the component for the current
 * location is about to be left. Similar to {@link beforeRouteLeave} but can be
 * used in any component. The guard is removed when the component is unmounted.
 *
 * @param leaveGuard - {@link NavigationGuard}
 */ function $55e1179cdae9ffbe$export$d7fcdd004b009a9e(leaveGuard) {
    const activeRecord = (0, $1vQIy.inject)($55e1179cdae9ffbe$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $55e1179cdae9ffbe$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
 * Add a navigation guard that triggers whenever the current location is about
 * to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
 * component. The guard is removed when the component is unmounted.
 *
 * @param updateGuard - {@link NavigationGuard}
 */ function $55e1179cdae9ffbe$export$46b4cb99461f4cc7(updateGuard) {
    const activeRecord = (0, $1vQIy.inject)($55e1179cdae9ffbe$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $55e1179cdae9ffbe$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $55e1179cdae9ffbe$var$guardToPromiseFn(guard, to, from, record, name) {
    // keep a reference to the enterCallbackArray to prevent pushing callbacks if a new navigation took place
    const enterCallbackArray = record && // name is defined if record is because of the function overload
    (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($55e1179cdae9ffbe$var$createRouterError(4 /* ErrorTypes.NAVIGATION_ABORTED */ , {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($55e1179cdae9ffbe$var$isRouteLocation(valid)) reject($55e1179cdae9ffbe$var$createRouterError(2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ , {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && // since enterCallbackArray is truthy, both record and name also are
                    record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            // wrapping with Promise.resolve allows it to work with both async and sync guards
            const guardReturn = guard.call(record && record.instances[name], to, from, next);
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $55e1179cdae9ffbe$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $55e1179cdae9ffbe$var$warn(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        // @ts-expect-error: we put it in the original one because it's easier to check
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $55e1179cdae9ffbe$var$extractComponentsGuards(matched, guardType, to, from) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        // skip update and leave guards if the route component is not mounted
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ($55e1179cdae9ffbe$var$isRouteComponent(rawComponent)) {
            // __vccOpts is added by vue-class-component and contain the regular options
            const options = rawComponent.__vccOpts || rawComponent;
            const guard = options[guardType];
            guard && guards.push($55e1179cdae9ffbe$var$guardToPromiseFn(guard, to, from, record, name));
        } else {
            // start requesting the chunk already
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}"`));
                    const resolvedComponent = $55e1179cdae9ffbe$var$isESModule(resolved) ? resolved.default : resolved;
                    // replace the function with the resolved component
                    // cannot be null or undefined because we went into the for loop
                    record.components[name] = resolvedComponent;
                    // __vccOpts is added by vue-class-component and contain the regular options
                    const options = resolvedComponent.__vccOpts || resolvedComponent;
                    const guard = options[guardType];
                    return guard && $55e1179cdae9ffbe$var$guardToPromiseFn(guard, to, from, record, name)();
                }));
        }
    }
    return guards;
}
/**
 * Allows differentiating lazy components from functional components and vue-class-component
 * @internal
 *
 * @param component
 */ function $55e1179cdae9ffbe$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
/**
 * Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
 *
 * @param route - resolved route to load
 */ function $55e1179cdae9ffbe$export$d092a02cbf0deea7(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $55e1179cdae9ffbe$var$isESModule(resolved) ? resolved.default : resolved;
                // replace the function with the resolved component
                // cannot be null or undefined because we went into the for loop
                record.components[name] = resolvedComponent;
                return;
            }));
            return promises;
        }, [])))).then(()=>route);
}
// TODO: we could allow currentRoute as a prop to expose `isActive` and
// `isExactActive` behavior should go through an RFC
function $55e1179cdae9ffbe$export$dcf14c9974fe2767(props) {
    const router = (0, $1vQIy.inject)($55e1179cdae9ffbe$export$b6c0da8b9dae491f);
    const currentRoute = (0, $1vQIy.inject)($55e1179cdae9ffbe$export$3aca783e9a3e6e9e);
    const route = (0, $1iCGX.computed)(()=>router.resolve((0, $1iCGX.unref)(props.to)));
    const activeRecordIndex = (0, $1iCGX.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex($55e1179cdae9ffbe$var$isSameRouteRecord.bind(null, routeMatched));
        if (index > -1) return index;
        // possible parent record
        const parentRecordPath = $55e1179cdae9ffbe$var$getOriginalPath(matched[length - 2]);
        return(// we are dealing with nested routes
        length > 1 && // if the parent and matched route have the same path, this link is
        // referring to the empty child. Or we currently are on a different
        // child of the same parent
        $55e1179cdae9ffbe$var$getOriginalPath(routeMatched) === parentRecordPath && // avoid comparing the child with its parent
        currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex($55e1179cdae9ffbe$var$isSameRouteRecord.bind(null, matched[length - 2])) : index);
    });
    const isActive = (0, $1iCGX.computed)(()=>activeRecordIndex.value > -1 && $55e1179cdae9ffbe$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $1iCGX.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && $55e1179cdae9ffbe$var$isSameRouteLocationParams(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($55e1179cdae9ffbe$var$guardEvent(e)) return router[(0, $1iCGX.unref)(props.replace) ? "replace" : "push"]((0, $1iCGX.unref)(props.to)).catch($55e1179cdae9ffbe$var$noop);
        return Promise.resolve();
    }
    // devtools only
    if (__VUE_PROD_DEVTOOLS__ && $55e1179cdae9ffbe$var$isBrowser) {
        const instance = (0, $1vQIy.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value
            };
            // @ts-expect-error: this is internal
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            // @ts-expect-error: this is internal
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $1vQIy.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
            }, {
                flush: "post"
            });
        }
    }
    /**
     * NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
     */ return {
        route: route,
        href: (0, $1iCGX.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
const $55e1179cdae9ffbe$var$RouterLinkImpl = /*#__PURE__*/ (0, $1vQIy.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        // inactiveClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        }
    },
    useLink: $55e1179cdae9ffbe$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $1iCGX.reactive)($55e1179cdae9ffbe$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $1vQIy.inject)($55e1179cdae9ffbe$export$b6c0da8b9dae491f);
        const elClass = (0, $1iCGX.computed)(()=>({
                [$55e1179cdae9ffbe$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                // [getLinkClass(
                //   props.inactiveClass,
                //   options.linkInactiveClass,
                //   'router-link-inactive'
                // )]: !link.isExactActive,
                [$55e1179cdae9ffbe$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && slots.default(link);
            return props.custom ? children : (0, $1vQIy.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                // this would override user added attrs but Vue will still add
                // the listener, so we end up triggering both
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to render a link that triggers a navigation on click.
 */ const $55e1179cdae9ffbe$export$fce709ebdac448ed = $55e1179cdae9ffbe$var$RouterLinkImpl;
function $55e1179cdae9ffbe$var$guardEvent(e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    // don't redirect when preventDefault called
    if (e.defaultPrevented) return;
    // don't redirect on right click
    if (e.button !== undefined && e.button !== 0) return;
    // don't redirect if `target="_blank"`
    // @ts-expect-error getAttribute does exist
    if (e.currentTarget && e.currentTarget.getAttribute) {
        // @ts-expect-error getAttribute exists
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    // this may be a Weex event which doesn't have this method
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $55e1179cdae9ffbe$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else {
            if (!$55e1179cdae9ffbe$var$isArray(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value !== outerValue[i])) return false;
        }
    }
    return true;
}
/**
 * Get the original path value of a record by following its aliasOf
 * @param record
 */ function $55e1179cdae9ffbe$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
 * Utility class to get the active class based on defaults.
 * @param propClass
 * @param globalClass
 * @param defaultClass
 */ const $55e1179cdae9ffbe$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
const $55e1179cdae9ffbe$var$RouterViewImpl = /*#__PURE__*/ (0, $1vQIy.defineComponent)({
    name: "RouterView",
    // #674 we manually inherit them
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    // Better compat for @vue/compat users
    // https://github.com/vuejs/router/issues/1315
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $1vQIy.inject)($55e1179cdae9ffbe$export$54c8124bead129f8);
        const routeToDisplay = (0, $1iCGX.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $1vQIy.inject)($55e1179cdae9ffbe$export$9b3825c34ca1427a, 0);
        // The depth changes based on empty components option, which allows passthrough routes e.g. routes with children
        // that are used to reuse the `path` property
        const depth = (0, $1iCGX.computed)(()=>{
            let initialDepth = (0, $1iCGX.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $1iCGX.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $1vQIy.provide)($55e1179cdae9ffbe$export$9b3825c34ca1427a, (0, $1iCGX.computed)(()=>depth.value + 1));
        (0, $1vQIy.provide)($55e1179cdae9ffbe$export$7f4879db1558672d, matchedRouteRef);
        (0, $1vQIy.provide)($55e1179cdae9ffbe$export$54c8124bead129f8, routeToDisplay);
        const viewRef = (0, $1iCGX.ref)();
        // watch at the same time the component instance, the route record we are
        // rendering, and the name
        (0, $1vQIy.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            // copy reused instances
            if (to) {
                // this will update the instance for new instances as well as reused
                // instances when navigating to a new route
                to.instances[name] = instance;
                // the component instance is reused for a different route or name, so
                // we copy any saved update or leave guards. With async setup, the
                // mounting component will mount before the matchedRoute changes,
                // making instance === oldInstance, so we check if guards have been
                // added before. This works because we remove guards when
                // unmounting/deactivating components
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            // trigger beforeRouteEnter next callbacks
            if (instance && to && // if there is no instance but to and from are the same this might be
            // the first visit
            (!from || !$55e1179cdae9ffbe$var$isSameRouteRecord(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            // we need the value at the time we render because when we unmount, we
            // navigated to a different location so the value is different
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $55e1179cdae9ffbe$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            // props from route configuration
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                // remove the instance reference to prevent leak
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $1vQIy.h)(ViewComponent, $55e1179cdae9ffbe$var$assign({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && $55e1179cdae9ffbe$var$isBrowser && component.ref) {
                // TODO: can display if it's an alias, its props
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                const internalInstances = $55e1179cdae9ffbe$var$isArray(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ];
                internalInstances.forEach((instance)=>{
                    // @ts-expect-error
                    instance.__vrv_devtools = info;
                });
            }
            return(// pass the vnode to the slot as a prop.
            // h and <component :is="..."> both accept vnodes
            $55e1179cdae9ffbe$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component);
        };
    }
});
function $55e1179cdae9ffbe$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to display the current route the user is at.
 */ const $55e1179cdae9ffbe$export$d941f00e9b9a537 = $55e1179cdae9ffbe$var$RouterViewImpl;
// warn against deprecated usage with <transition> & <keep-alive>
// due to functional component being no longer eager in Vue 3
function $55e1179cdae9ffbe$var$warnDeprecatedUsage() {
    const instance = (0, $1vQIy.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && typeof parentSubTreeType === "object" && parentSubTreeType.name === "RouterView") {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        $55e1179cdae9ffbe$var$warn(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.\n` + `Use slot props instead:\n\n` + `<router-view v-slot="{ Component }">\n` + `  <${comp}>\n` + `    <component :is="Component" />\n` + `  </${comp}>\n` + `</router-view>`);
    }
}
/**
 * Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
 *
 * @param routeLocation - routeLocation to format
 * @param tooltip - optional tooltip
 * @returns a copy of the routeLocation
 */ function $55e1179cdae9ffbe$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $55e1179cdae9ffbe$var$assign({}, routeLocation, {
        // remove variables that can contain vue instances
        matched: routeLocation.matched.map((matched)=>$55e1179cdae9ffbe$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $55e1179cdae9ffbe$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
// to support multiple router instances
let $55e1179cdae9ffbe$var$routerId = 0;
function $55e1179cdae9ffbe$var$addDevtools(app, router, matcher) {
    // Take over router.beforeEach and afterEach
    // make sure we are not registering the devtool twice
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    // increment to support multiple router instances
    const id = $55e1179cdae9ffbe$var$routerId++;
    (0, $54c6cb99091f414d$export$63b9a9bba9f20f3e)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") console.warn("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        // display state added by the router
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $55e1179cdae9ffbe$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        // mark router-link as active and display tags on router views
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $55e1179cdae9ffbe$var$PINK_500
                });
            }
            // if multiple useLink are used
            if ($55e1179cdae9ffbe$var$isArray(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let backgroundColor = $55e1179cdae9ffbe$var$ORANGE_400;
                    let tooltip = "";
                    if (devtoolsData.isExactActive) {
                        backgroundColor = $55e1179cdae9ffbe$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $55e1179cdae9ffbe$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: devtoolsData.route.path,
                        textColor: 0,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $1vQIy.watch)(router.currentRoute, ()=>{
            // refresh active state
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 0x40a8c4
        });
        // const errorsLayerId = 'router:errors'
        // api.addTimelineLayer({
        //   id: errorsLayerId,
        //   label: 'Router Errors',
        //   color: 0xea5455,
        // })
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        // attached to `meta` and used to group events
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $55e1179cdae9ffbe$var$formatDisplay("beforeEach"),
                from: $55e1179cdae9ffbe$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $55e1179cdae9ffbe$var$formatRouteLocation(to, "Target location")
            };
            // Used to group navigations together, hide from devtools
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $55e1179cdae9ffbe$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $55e1179cdae9ffbe$var$formatDisplay("\u274C");
            } else data.status = $55e1179cdae9ffbe$var$formatDisplay("\u2705");
            // we set here to have the right order
            data.from = $55e1179cdae9ffbe$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $55e1179cdae9ffbe$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
         * Inspector of Existing routes
         */ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            // the routes view isn't active
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            // children routes will appear as nested
            let routes = matcher.getRoutes().filter((route)=>!route.parent || // these routes have a parent with no component which will not appear in the view
                // therefore we still need to include them
                !route.parent.record.components);
            // reset match state to false
            routes.forEach($55e1179cdae9ffbe$var$resetMatchStateOnRouteRecord);
            // apply a match state if there is a payload
            if (payload.filter) routes = routes.filter((route)=>// save matches state based on the payload
                $55e1179cdae9ffbe$var$isRouteMatching(route, payload.filter.toLowerCase()));
            // mark active routes
            routes.forEach((route)=>$55e1179cdae9ffbe$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($55e1179cdae9ffbe$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
         * Display information about the currently selected route record
         */ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const routes = matcher.getRoutes();
                const route = routes.find((route)=>route.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $55e1179cdae9ffbe$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $55e1179cdae9ffbe$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $55e1179cdae9ffbe$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$55e1179cdae9ffbe$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
 * Extracted from tailwind palette
 */ const $55e1179cdae9ffbe$var$PINK_500 = 0xec4899;
const $55e1179cdae9ffbe$var$BLUE_600 = 0x2563eb;
const $55e1179cdae9ffbe$var$LIME_500 = 0x84cc16;
const $55e1179cdae9ffbe$var$CYAN_400 = 0x22d3ee;
const $55e1179cdae9ffbe$var$ORANGE_400 = 0xfb923c;
// const GRAY_100 = 0xf4f4f5
const $55e1179cdae9ffbe$var$DARK = 0x666666;
function $55e1179cdae9ffbe$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $55e1179cdae9ffbe$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $55e1179cdae9ffbe$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $55e1179cdae9ffbe$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $55e1179cdae9ffbe$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $55e1179cdae9ffbe$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 0xffffff,
        backgroundColor: $55e1179cdae9ffbe$var$DARK
    });
    // add an id to be able to select it. Using the `path` is not possible because
    // empty path children would collide with their parents
    let id = record.__vd_id;
    if (id == null) {
        id = String($55e1179cdae9ffbe$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($55e1179cdae9ffbe$var$formatRouteRecordForInspector)
    };
}
//  incremental id for route records and inspector state
let $55e1179cdae9ffbe$var$routeRecordId = 0;
const $55e1179cdae9ffbe$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $55e1179cdae9ffbe$var$markRouteRecordActive(route, currentRoute) {
    // no route will be active if matched is empty
    // reset the matching state
    const isExactActive = currentRoute.matched.length && $55e1179cdae9ffbe$var$isSameRouteRecord(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$55e1179cdae9ffbe$var$isSameRouteRecord(match, route.record));
    route.children.forEach((childRoute)=>$55e1179cdae9ffbe$var$markRouteRecordActive(childRoute, currentRoute));
}
function $55e1179cdae9ffbe$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($55e1179cdae9ffbe$var$resetMatchStateOnRouteRecord);
}
function $55e1179cdae9ffbe$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($55e1179cdae9ffbe$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    // use a regexp without $ at the end to match nested routes better
    const nonEndingRE = new RegExp(found[1].replace(/\$$/, ""), found[2]);
    if (nonEndingRE.test(filter)) {
        // mark children as matches
        route.children.forEach((child)=>$55e1179cdae9ffbe$var$isRouteMatching(child, filter));
        // exception case: `/`
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        // hide the / route
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $55e1179cdae9ffbe$var$decode(path);
    // also allow partial matching on the path
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$55e1179cdae9ffbe$var$isRouteMatching(child, filter));
}
function $55e1179cdae9ffbe$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) // @ts-expect-error
    ret[key] = obj[key];
    return ret;
}
/**
 * Creates a Router instance that can be used by a Vue app.
 *
 * @param options - {@link RouterOptions}
 */ function $55e1179cdae9ffbe$export$baddd0131ee8c05b(options) {
    const matcher = $55e1179cdae9ffbe$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || $55e1179cdae9ffbe$export$1e8473eaf75b0d10;
    const stringifyQuery$1 = options.stringifyQuery || $55e1179cdae9ffbe$export$d33b45a8f796a30;
    const routerHistory = options.history;
    const beforeGuards = $55e1179cdae9ffbe$var$useCallbacks();
    const beforeResolveGuards = $55e1179cdae9ffbe$var$useCallbacks();
    const afterGuards = $55e1179cdae9ffbe$var$useCallbacks();
    const currentRoute = (0, $1iCGX.shallowRef)($55e1179cdae9ffbe$export$e44be9a9779c480b);
    let pendingLocation = $55e1179cdae9ffbe$export$e44be9a9779c480b;
    // leave the scrollRestoration if no scrollBehavior is provided
    if ($55e1179cdae9ffbe$var$isBrowser && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = $55e1179cdae9ffbe$var$applyToParams.bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = $55e1179cdae9ffbe$var$applyToParams.bind(null, $55e1179cdae9ffbe$var$encodeParam);
    const decodeParams = // @ts-expect-error: intentionally avoid the type check
    $55e1179cdae9ffbe$var$applyToParams.bind(null, $55e1179cdae9ffbe$var$decode);
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ($55e1179cdae9ffbe$var$isRouteName(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        // const objectLocation = routerLocationAsObject(rawLocation)
        // we create a copy to modify it later
        currentLocation = $55e1179cdae9ffbe$var$assign({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            const locationNormalized = $55e1179cdae9ffbe$var$parseURL(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href = routerHistory.createHref(locationNormalized.fullPath);
            // locationNormalized is always a new object
            return $55e1179cdae9ffbe$var$assign(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                hash: $55e1179cdae9ffbe$var$decode(locationNormalized.hash),
                redirectedFrom: undefined,
                href: href
            });
        }
        let matcherLocation;
        // path could be relative in object as well
        if ("path" in rawLocation) matcherLocation = $55e1179cdae9ffbe$var$assign({}, rawLocation, {
            path: $55e1179cdae9ffbe$var$parseURL(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            // remove any nullish param
            const targetParams = $55e1179cdae9ffbe$var$assign({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            // pass encoded values to the matcher, so it can produce encoded path and fullPath
            matcherLocation = $55e1179cdae9ffbe$var$assign({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            // current location params are decoded, we need to encode them in case the
            // matcher merges the params
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        // the matcher might have merged current location params, so
        // we need to run the decoding again
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = $55e1179cdae9ffbe$var$stringifyURL(stringifyQuery$1, $55e1179cdae9ffbe$var$assign({}, rawLocation, {
            hash: $55e1179cdae9ffbe$var$encodeHash(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return $55e1179cdae9ffbe$var$assign({
            fullPath: fullPath,
            hash: // keep the hash encoded so fullPath is effectively path + encodedQuery +
            // hash
            hash,
            query: // if the user is using a custom query lib like qs, we might have
            // nested objects, so we keep the query as is, meaning it can contain
            // numbers at `$route.query`, but at the point, the user will have to
            // use their own type anyway.
            // https://github.com/vuejs/router/issues/328#issuecomment-649481567
            stringifyQuery$1 === $55e1179cdae9ffbe$export$d33b45a8f796a30 ? $55e1179cdae9ffbe$var$normalizeQuery(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: undefined,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? $55e1179cdae9ffbe$var$parseURL(parseQuery$1, to, currentRoute.value.path) : $55e1179cdae9ffbe$var$assign({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return $55e1179cdae9ffbe$var$createRouterError(8 /* ErrorTypes.NAVIGATION_CANCELLED */ , {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push($55e1179cdae9ffbe$var$assign(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                // @ts-expect-error: force empty params when a string is passed to let
                // the router parse them again
                newTargetLocation.params = {};
            }
            return $55e1179cdae9ffbe$var$assign({
                query: to.query,
                hash: to.hash,
                // avoid transferring params if the redirect has a path
                params: "path" in newTargetLocation ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        // to could be a string where `replace` is a function
        const replace = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation);
        if (shouldRedirect) return pushWithRedirect($55e1179cdae9ffbe$var$assign(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? $55e1179cdae9ffbe$var$assign({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace
        }), // keep original redirectedFrom if it exists
        redirectedFrom || targetLocation);
        // if it was a redirect we already called `pushWithRedirect` above
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && $55e1179cdae9ffbe$var$isSameRouteLocation(stringifyQuery$1, from, targetLocation)) {
            failure = $55e1179cdae9ffbe$var$createRouterError(16 /* ErrorTypes.NAVIGATION_DUPLICATED */ , {
                to: toLocation,
                from: from
            });
            // trigger scroll to allow scrolling to the same anchor
            handleScroll(from, from, // this is a push, the only way for it to be triggered from a
            // history.listen is with a redirect, which makes it become a push
            true, // This cannot be the first navigation because the initial location
            // cannot be manually navigated to
            false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>$55e1179cdae9ffbe$export$873de56207a30e5a(error) ? $55e1179cdae9ffbe$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ) ? error : markAsReady(error) // also returns the error
             : triggerError(error, toLocation, from)).then((failure)=>{
            if (failure) {
                if ($55e1179cdae9ffbe$export$873de56207a30e5a(failure, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) return pushWithRedirect(// keep options
                $55e1179cdae9ffbe$var$assign({
                    replace: // preserve an existing replacement but allow the redirect to override it
                    replace
                }, locationAsObject(failure.to), {
                    state: typeof failure.to === "object" ? $55e1179cdae9ffbe$var$assign({}, data, failure.to.state) : data,
                    force: force
                }), // preserve the original redirectedFrom if any
                redirectedFrom || toLocation);
            } else // if we fail we don't finalize the navigation
            failure = finalizeNavigation(toLocation, from, true, replace, data);
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
     * Helper to reject and skip all navigation guards if a new navigation happened
     * @param to
     * @param from
     */ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        // support Vue < 3.3
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    // TODO: refactor the whole before guards by internally using router.beforeEach
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = $55e1179cdae9ffbe$var$extractChangingRecords(to, from);
        // all components here have been resolved once because we are leaving
        guards = $55e1179cdae9ffbe$var$extractComponentsGuards(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        // leavingRecords is already reversed
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push($55e1179cdae9ffbe$var$guardToPromiseFn(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        // run the queue of per route beforeRouteLeave guards
        return runGuardQueue(guards).then(()=>{
            // check global guards beforeEach
            guards = [];
            for (const guard of beforeGuards.list())guards.push($55e1179cdae9ffbe$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            // check in components beforeRouteUpdate
            guards = $55e1179cdae9ffbe$var$extractComponentsGuards(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push($55e1179cdae9ffbe$var$guardToPromiseFn(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check the route beforeEnter
            guards = [];
            for (const record of enteringRecords)// do not trigger beforeEnter on reused views
            if (record.beforeEnter) {
                if ($55e1179cdae9ffbe$var$isArray(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push($55e1179cdae9ffbe$var$guardToPromiseFn(beforeEnter, to, from));
                else guards.push($55e1179cdae9ffbe$var$guardToPromiseFn(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // NOTE: at this point to.matched is normalized and does not contain any () => Promise<Component>
            // clear existing enterCallbacks, these are added by extractComponentsGuards
            to.matched.forEach((record)=>record.enterCallbacks = {});
            // check in-component beforeRouteEnter
            guards = $55e1179cdae9ffbe$var$extractComponentsGuards(enteringRecords, "beforeRouteEnter", to, from);
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check global guards beforeResolve
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push($55e1179cdae9ffbe$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        })// catch any navigation canceled
        .catch((err)=>$55e1179cdae9ffbe$export$873de56207a30e5a(err, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ ) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        // navigation is confirmed, call afterGuards
        // TODO: wrap with error handlers
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
     * - Cleans up any navigation guards
     * - Changes the url if necessary
     * - Calls the scrollBehavior
     */ function finalizeNavigation(toLocation, from, isPush, replace, data) {
        // a more recent navigation took place
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        // only consider as push if it's not the first navigation
        const isFirstNavigation = from === $55e1179cdae9ffbe$export$e44be9a9779c480b;
        const state = !$55e1179cdae9ffbe$var$isBrowser ? {} : history.state;
        // change URL only if the user did a push/replace and if it's not the initial navigation because
        // it's just reflecting the url
        if (isPush) {
            // on the initial navigation, we want to reuse the scroll position from
            // history state if it exists
            if (replace || isFirstNavigation) routerHistory.replace(toLocation.fullPath, $55e1179cdae9ffbe$var$assign({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        // accept current navigation
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    // attach listener to history to trigger navigations
    function setupListeners() {
        // avoid setting up listeners twice due to an invalid first navigation
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            // cannot be a redirect route because it was in history
            const toLocation = resolve(to);
            // due to dynamic routing, and to hash history with manual navigation
            // (manually changing the url or calling history.hash = '#/somewhere'),
            // there could be a redirect record in history
            const shouldRedirect = handleRedirectRecord(toLocation);
            if (shouldRedirect) {
                pushWithRedirect($55e1179cdae9ffbe$var$assign(shouldRedirect, {
                    replace: true
                }), toLocation).catch($55e1179cdae9ffbe$var$noop);
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            // TODO: should be moved to web history?
            if ($55e1179cdae9ffbe$var$isBrowser) $55e1179cdae9ffbe$var$saveScrollPosition($55e1179cdae9ffbe$var$getScrollKey(from.fullPath, info.delta), $55e1179cdae9ffbe$var$computeScrollPosition());
            navigate(toLocation, from).catch((error)=>{
                if ($55e1179cdae9ffbe$export$873de56207a30e5a(error, 12 /* ErrorTypes.NAVIGATION_CANCELLED */ )) return error;
                if ($55e1179cdae9ffbe$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) {
                    // Here we could call if (info.delta) routerHistory.go(-info.delta,
                    // false) but this is bug prone as we have no way to wait the
                    // navigation to be finished before calling pushWithRedirect. Using
                    // a setTimeout of 16ms seems to work but there is no guarantee for
                    // it to work on every browser. So instead we do not restore the
                    // history entry and trigger a new navigation as requested by the
                    // navigation guard.
                    // the error is already handled by router.push we just want to avoid
                    // logging the error
                    pushWithRedirect(error.to, toLocation).then((failure)=>{
                        // manual change in hash history #916 ending up in the URL not
                        // changing, but it was changed by the manual url change, so we
                        // need to manually change it ourselves
                        if ($55e1179cdae9ffbe$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ ) && !info.delta && info.type === $55e1179cdae9ffbe$var$NavigationType.pop) routerHistory.go(-1, false);
                    }).catch($55e1179cdae9ffbe$var$noop);
                    // avoid the then branch
                    return Promise.reject();
                }
                // do not restore history on unknown direction
                if (info.delta) routerHistory.go(-info.delta, false);
                // unrecognized error, transfer to the global handler
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(// after navigation, all matched components are resolved
                toLocation, from, false);
                // revert the navigation
                if (failure) {
                    if (info.delta && // a new navigation has been triggered, so we do not want to revert, that will change the current history
                    // entry while a different route is displayed
                    !$55e1179cdae9ffbe$export$873de56207a30e5a(failure, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ )) routerHistory.go(-info.delta, false);
                    else if (info.type === $55e1179cdae9ffbe$var$NavigationType.pop && $55e1179cdae9ffbe$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ )) // manual change in hash history #916
                    // it's like a push but lacks the information of the direction
                    routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            })// avoid warnings in the console about uncaught rejections, they are logged by triggerErrors
            .catch($55e1179cdae9ffbe$var$noop);
        });
    }
    // Initialization and Errors
    let readyHandlers = $55e1179cdae9ffbe$var$useCallbacks();
    let errorListeners = $55e1179cdae9ffbe$var$useCallbacks();
    let ready;
    /**
     * Trigger errorListeners added via onError and throws the error as well
     *
     * @param error - error to throw
     * @param to - location we were navigating to when the error happened
     * @param from - location we were navigating from when the error happened
     * @returns the error as a rejected promise
     */ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorListeners.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        // reject the error no matter there were error listeners or not
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== $55e1179cdae9ffbe$export$e44be9a9779c480b) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            readyHandlers.add([
                resolve,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            // still not ready if an error happened
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve, reject])=>err ? reject(err) : resolve());
            readyHandlers.reset();
        }
        return err;
    }
    // Scroll behavior
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!$55e1179cdae9ffbe$var$isBrowser || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && $55e1179cdae9ffbe$var$getSavedScrollPosition($55e1179cdae9ffbe$var$getScrollKey(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $1vQIy.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && $55e1179cdae9ffbe$var$scrollToPosition(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install (app) {
            const router = this;
            app.component("RouterLink", $55e1179cdae9ffbe$export$fce709ebdac448ed);
            app.component("RouterView", $55e1179cdae9ffbe$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $1iCGX.unref)(currentRoute)
            });
            // this initial navigation is only necessary on client, on server it doesn't
            // make sense because it will create an extra unnecessary navigation and could
            // lead to problems
            if ($55e1179cdae9ffbe$var$isBrowser && // used for the initial navigation client side to avoid pushing
            // multiple times when the router is used in multiple apps
            !started && currentRoute.value === $55e1179cdae9ffbe$export$e44be9a9779c480b) {
                // see above
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in $55e1179cdae9ffbe$export$e44be9a9779c480b)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide($55e1179cdae9ffbe$export$b6c0da8b9dae491f, router);
            app.provide($55e1179cdae9ffbe$export$3aca783e9a3e6e9e, (0, $1iCGX.shallowReactive)(reactiveRoute));
            app.provide($55e1179cdae9ffbe$export$54c8124bead129f8, currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                // the router is not attached to an app anymore
                if (installedApps.size < 1) {
                    // invalidate the current navigation
                    pendingLocation = $55e1179cdae9ffbe$export$e44be9a9779c480b;
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = $55e1179cdae9ffbe$export$e44be9a9779c480b;
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            // TODO: this probably needs to be updated so it can be used by vue-termui
            if (__VUE_PROD_DEVTOOLS__ && $55e1179cdae9ffbe$var$isBrowser) $55e1179cdae9ffbe$var$addDevtools(app, router, matcher);
        }
    };
    // TODO: type this as NavigationGuardReturn or similar instead of any
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
function $55e1179cdae9ffbe$var$extractChangingRecords(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$55e1179cdae9ffbe$var$isSameRouteRecord(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) // the type doesn't matter because we are comparing per reference
        {
            if (!from.matched.find((record)=>$55e1179cdae9ffbe$var$isSameRouteRecord(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
/**
 * Returns the router instance. Equivalent to using `$router` inside
 * templates.
 */ function $55e1179cdae9ffbe$export$9a302a45f65d0572() {
    return (0, $1vQIy.inject)($55e1179cdae9ffbe$export$b6c0da8b9dae491f);
}
/**
 * Returns the current route location. Equivalent to using `$route` inside
 * templates.
 */ function $55e1179cdae9ffbe$export$3f79f0b98112cf57() {
    return (0, $1vQIy.inject)($55e1179cdae9ffbe$export$3aca783e9a3e6e9e);
}


var $25966294968d5582$exports = {};
(function(root, factory) {
    if (typeof define === "function" && define.amd) define(factory);
    else $25966294968d5582$exports = factory();
})($25966294968d5582$exports, function() {
    var NProgress = {};
    NProgress.version = "0.2.0";
    var Settings = NProgress.settings = {
        minimum: 0.08,
        easing: "ease",
        positionUsing: "",
        speed: 200,
        trickle: true,
        trickleRate: 0.02,
        trickleSpeed: 800,
        showSpinner: true,
        barSelector: '[role="bar"]',
        spinnerSelector: '[role="spinner"]',
        parent: "body",
        template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
    };
    /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */ NProgress.configure = function(options) {
        var key, value;
        for(key in options){
            value = options[key];
            if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
        }
        return this;
    };
    /**
   * Last number.
   */ NProgress.status = null;
    /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */ NProgress.set = function(n) {
        var started = NProgress.isStarted();
        n = clamp(n, Settings.minimum, 1);
        NProgress.status = n === 1 ? null : n;
        var progress = NProgress.render(!started), bar = progress.querySelector(Settings.barSelector), speed = Settings.speed, ease = Settings.easing;
        progress.offsetWidth; /* Repaint */ 
        queue(function(next) {
            // Set positionUsing if it hasn't already been set
            if (Settings.positionUsing === "") Settings.positionUsing = NProgress.getPositioningCSS();
            // Add transition
            css(bar, barPositionCSS(n, speed, ease));
            if (n === 1) {
                // Fade out
                css(progress, {
                    transition: "none",
                    opacity: 1
                });
                progress.offsetWidth; /* Repaint */ 
                setTimeout(function() {
                    css(progress, {
                        transition: "all " + speed + "ms linear",
                        opacity: 0
                    });
                    setTimeout(function() {
                        NProgress.remove();
                        next();
                    }, speed);
                }, speed);
            } else setTimeout(next, speed);
        });
        return this;
    };
    NProgress.isStarted = function() {
        return typeof NProgress.status === "number";
    };
    /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */ NProgress.start = function() {
        if (!NProgress.status) NProgress.set(0);
        var work = function() {
            setTimeout(function() {
                if (!NProgress.status) return;
                NProgress.trickle();
                work();
            }, Settings.trickleSpeed);
        };
        if (Settings.trickle) work();
        return this;
    };
    /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */ NProgress.done = function(force) {
        if (!force && !NProgress.status) return this;
        return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
    };
    /**
   * Increments by a random amount.
   */ NProgress.inc = function(amount) {
        var n = NProgress.status;
        if (!n) return NProgress.start();
        else {
            if (typeof amount !== "number") amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
            n = clamp(n + amount, 0, 0.994);
            return NProgress.set(n);
        }
    };
    NProgress.trickle = function() {
        return NProgress.inc(Math.random() * Settings.trickleRate);
    };
    /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */ (function() {
        var initial = 0, current = 0;
        NProgress.promise = function($promise) {
            if (!$promise || $promise.state() === "resolved") return this;
            if (current === 0) NProgress.start();
            initial++;
            current++;
            $promise.always(function() {
                current--;
                if (current === 0) {
                    initial = 0;
                    NProgress.done();
                } else NProgress.set((initial - current) / initial);
            });
            return this;
        };
    })();
    /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */ NProgress.render = function(fromStart) {
        if (NProgress.isRendered()) return document.getElementById("nprogress");
        addClass(document.documentElement, "nprogress-busy");
        var progress = document.createElement("div");
        progress.id = "nprogress";
        progress.innerHTML = Settings.template;
        var bar = progress.querySelector(Settings.barSelector), perc = fromStart ? "-100" : toBarPerc(NProgress.status || 0), parent = document.querySelector(Settings.parent), spinner;
        css(bar, {
            transition: "all 0 linear",
            transform: "translate3d(" + perc + "%,0,0)"
        });
        if (!Settings.showSpinner) {
            spinner = progress.querySelector(Settings.spinnerSelector);
            spinner && removeElement(spinner);
        }
        if (parent != document.body) addClass(parent, "nprogress-custom-parent");
        parent.appendChild(progress);
        return progress;
    };
    /**
   * Removes the element. Opposite of render().
   */ NProgress.remove = function() {
        removeClass(document.documentElement, "nprogress-busy");
        removeClass(document.querySelector(Settings.parent), "nprogress-custom-parent");
        var progress = document.getElementById("nprogress");
        progress && removeElement(progress);
    };
    /**
   * Checks if the progress bar is rendered.
   */ NProgress.isRendered = function() {
        return !!document.getElementById("nprogress");
    };
    /**
   * Determine which positioning CSS rule to use.
   */ NProgress.getPositioningCSS = function() {
        // Sniff on document.body.style
        var bodyStyle = document.body.style;
        // Sniff prefixes
        var vendorPrefix = "WebkitTransform" in bodyStyle ? "Webkit" : "MozTransform" in bodyStyle ? "Moz" : "msTransform" in bodyStyle ? "ms" : "OTransform" in bodyStyle ? "O" : "";
        if (vendorPrefix + "Perspective" in bodyStyle) // Modern browsers with 3D support, e.g. Webkit, IE10
        return "translate3d";
        else if (vendorPrefix + "Transform" in bodyStyle) // Browsers without 3D support, e.g. IE9
        return "translate";
        else // Browsers without translate() support, e.g. IE7-8
        return "margin";
    };
    /**
   * Helpers
   */ function clamp(n, min, max) {
        if (n < min) return min;
        if (n > max) return max;
        return n;
    }
    /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */ function toBarPerc(n) {
        return (-1 + n) * 100;
    }
    /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */ function barPositionCSS(n, speed, ease) {
        var barCSS;
        if (Settings.positionUsing === "translate3d") barCSS = {
            transform: "translate3d(" + toBarPerc(n) + "%,0,0)"
        };
        else if (Settings.positionUsing === "translate") barCSS = {
            transform: "translate(" + toBarPerc(n) + "%,0)"
        };
        else barCSS = {
            "margin-left": toBarPerc(n) + "%"
        };
        barCSS.transition = "all " + speed + "ms " + ease;
        return barCSS;
    }
    /**
   * (Internal) Queues a function to be executed.
   */ var queue = function() {
        var pending = [];
        function next() {
            var fn = pending.shift();
            if (fn) fn(next);
        }
        return function(fn) {
            pending.push(fn);
            if (pending.length == 1) next();
        };
    }();
    /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */ var css = function() {
        var cssPrefixes = [
            "Webkit",
            "O",
            "Moz",
            "ms"
        ], cssProps = {};
        function camelCase(string) {
            return string.replace(/^-ms-/, "ms-").replace(/-([\da-z])/gi, function(match, letter) {
                return letter.toUpperCase();
            });
        }
        function getVendorProp(name) {
            var style = document.body.style;
            if (name in style) return name;
            var i = cssPrefixes.length, capName = name.charAt(0).toUpperCase() + name.slice(1), vendorName;
            while(i--){
                vendorName = cssPrefixes[i] + capName;
                if (vendorName in style) return vendorName;
            }
            return name;
        }
        function getStyleProp(name) {
            name = camelCase(name);
            return cssProps[name] || (cssProps[name] = getVendorProp(name));
        }
        function applyCss(element, prop, value) {
            prop = getStyleProp(prop);
            element.style[prop] = value;
        }
        return function(element, properties) {
            var args = arguments, prop, value;
            if (args.length == 2) for(prop in properties){
                value = properties[prop];
                if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
            }
            else applyCss(element, args[1], args[2]);
        };
    }();
    /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */ function hasClass(element, name) {
        var list = typeof element == "string" ? element : classList(element);
        return list.indexOf(" " + name + " ") >= 0;
    }
    /**
   * (Internal) Adds a class to an element.
   */ function addClass(element, name) {
        var oldList = classList(element), newList = oldList + name;
        if (hasClass(oldList, name)) return;
        // Trim the opening space.
        element.className = newList.substring(1);
    }
    /**
   * (Internal) Removes a class from an element.
   */ function removeClass(element, name) {
        var oldList = classList(element), newList;
        if (!hasClass(element, name)) return;
        // Replace the class name.
        newList = oldList.replace(" " + name + " ", " ");
        // Trim the opening and closing spaces.
        element.className = newList.substring(1, newList.length - 1);
    }
    /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */ function classList(element) {
        return (" " + (element.className || "") + " ").replace(/\s+/gi, " ");
    }
    /**
   * (Internal) Removes an element from the DOM.
   */ function removeElement(element) {
        element && element.parentNode && element.parentNode.removeChild(element);
    }
    return NProgress;
});


let $71b22bf27c24e4d8$var$script;



let $71b22bf27c24e4d8$var$initialize = ()=>{
    $71b22bf27c24e4d8$var$script = (parcelRequire("gxzqo"));
    if ($71b22bf27c24e4d8$var$script.__esModule) $71b22bf27c24e4d8$var$script = $71b22bf27c24e4d8$var$script.default;
    $71b22bf27c24e4d8$var$script.render = (parcelRequire("kRdD7")).render;
    (parcelRequire("daWq5")).default($71b22bf27c24e4d8$var$script);
    $71b22bf27c24e4d8$var$script.__scopeId = "data-v-733c9b";
    $71b22bf27c24e4d8$var$script.__file = "Home.vue";
};
$71b22bf27c24e4d8$var$initialize();
var $71b22bf27c24e4d8$export$2e2bcd8739ae039 = $71b22bf27c24e4d8$var$script;


let $cf3e3d128d5383b8$var$script;




let $cf3e3d128d5383b8$var$initialize = ()=>{
    $cf3e3d128d5383b8$var$script = (parcelRequire("gNU50"));
    if ($cf3e3d128d5383b8$var$script.__esModule) $cf3e3d128d5383b8$var$script = $cf3e3d128d5383b8$var$script.default;
    $cf3e3d128d5383b8$var$script.render = (parcelRequire("gGP7V")).render;
    $cf3e3d128d5383b8$var$script.__cssModules = {};
    (parcelRequire("brP4W")).default($cf3e3d128d5383b8$var$script);
    $cf3e3d128d5383b8$var$script.__scopeId = "data-v-6833bc";
    $cf3e3d128d5383b8$var$script.__file = "FanArt.vue";
};
$cf3e3d128d5383b8$var$initialize();
var $cf3e3d128d5383b8$export$2e2bcd8739ae039 = $cf3e3d128d5383b8$var$script;


let $f6c12f7b39190ca7$var$script;




let $f6c12f7b39190ca7$var$initialize = ()=>{
    $f6c12f7b39190ca7$var$script = (parcelRequire("2HYh5"));
    if ($f6c12f7b39190ca7$var$script.__esModule) $f6c12f7b39190ca7$var$script = $f6c12f7b39190ca7$var$script.default;
    $f6c12f7b39190ca7$var$script.render = (parcelRequire("8IHNL")).render;
    $f6c12f7b39190ca7$var$script.__cssModules = {};
    (parcelRequire("k8ast")).default($f6c12f7b39190ca7$var$script);
    $f6c12f7b39190ca7$var$script.__scopeId = "data-v-a6b0d2";
    $f6c12f7b39190ca7$var$script.__file = "About.vue";
};
$f6c12f7b39190ca7$var$initialize();
var $f6c12f7b39190ca7$export$2e2bcd8739ae039 = $f6c12f7b39190ca7$var$script;


let $ff75756085a18a57$var$script;




let $ff75756085a18a57$var$initialize = ()=>{
    $ff75756085a18a57$var$script = (parcelRequire("a5F10"));
    if ($ff75756085a18a57$var$script.__esModule) $ff75756085a18a57$var$script = $ff75756085a18a57$var$script.default;
    $ff75756085a18a57$var$script.render = (parcelRequire("at2xZ")).render;
    $ff75756085a18a57$var$script.__cssModules = {};
    (parcelRequire("iFUMc")).default($ff75756085a18a57$var$script);
    $ff75756085a18a57$var$script.__scopeId = "data-v-af336e";
    $ff75756085a18a57$var$script.__file = "NotFound.vue";
};
$ff75756085a18a57$var$initialize();
var $ff75756085a18a57$export$2e2bcd8739ae039 = $ff75756085a18a57$var$script;


const $c0bf5d899dec86d6$var$routes = [
    {
        path: "/",
        name: "Home",
        component: (0, $71b22bf27c24e4d8$export$2e2bcd8739ae039),
        meta: {
            title: "Home | Hai Halo Epel"
        }
    },
    {
        path: "/about",
        name: "About",
        component: (0, $f6c12f7b39190ca7$export$2e2bcd8739ae039),
        meta: {
            title: "About | Hai Halo Epel"
        }
    },
    {
        path: "/fanart",
        name: "Fanart",
        component: (0, $cf3e3d128d5383b8$export$2e2bcd8739ae039),
        meta: {
            title: "Fan art | Hai Halo Epel"
        }
    },
    {
        path: "/:catchAll(.*)",
        name: "NotFound",
        component: (0, $ff75756085a18a57$export$2e2bcd8739ae039),
        meta: {
            title: "Page not Found | Hai Halo Epel"
        }
    }
];
const $c0bf5d899dec86d6$var$router = (0, $55e1179cdae9ffbe$export$baddd0131ee8c05b)({
    history: (0, $55e1179cdae9ffbe$export$7b4942f78e7b8a49)(),
    routes: $c0bf5d899dec86d6$var$routes
});
$c0bf5d899dec86d6$var$router.beforeResolve((to, from, next)=>{
    if (to.name) (0, (/*@__PURE__*/$parcel$interopDefault($25966294968d5582$exports))).start();
    const nearestWithTitle = to.matched.slice().reverse().find((r)=>r.meta && r.meta.title);
    const nearestWithMeta = to.matched.slice().reverse().find((r)=>r.meta && r.meta.metaTags);
    const previousNearestWithMeta = from.matched.slice().reverse().find((r)=>r.meta && r.meta.metaTags);
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
    else if (previousNearestWithMeta) document.title = previousNearestWithMeta.meta.title;
    Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map((el)=>el.parentNode.removeChild(el));
    if (!nearestWithMeta) return next();
    nearestWithMeta.meta.metaTags.map((tagDef)=>{
        const tag = document.createElement("meta");
        Object.keys(tagDef).forEach((key)=>{
            tag.setAttribute(key, tagDef[key]);
        });
        tag.setAttribute("data-vue-router-controlled", "");
        return tag;
    }).forEach((tag)=>document.head.appendChild(tag));
    next();
});
$c0bf5d899dec86d6$var$router.afterEach((to, from)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($25966294968d5582$exports))).done();
});
var $c0bf5d899dec86d6$export$2e2bcd8739ae039 = $c0bf5d899dec86d6$var$router;


(0, $anRt3.createApp)((0, $ae3de8900c09c2f9$export$2e2bcd8739ae039)).use((0, $c0bf5d899dec86d6$export$2e2bcd8739ae039)).mount("#app");


//# sourceMappingURL=index.85db2b94.js.map
